webpackJsonp([2],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1386)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1245),
  /* template */
  __webpack_require__(1547),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SourceLocation", function() { return SourceLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ASTNode", function() { return ASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListASTNode", function() { return ListASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmptyASTNode", function() { return EmptyASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IfASTNode", function() { return IfASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReturnASTNode", function() { return ReturnASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExpressionStatementASTNode", function() { return ExpressionStatementASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LiteralASTNode", function() { return LiteralASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IdentifierASTNode", function() { return IdentifierASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrayLiteralASTNode", function() { return ArrayLiteralASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MapLiteralASTNode", function() { return MapLiteralASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PropertyASTNode", function() { return PropertyASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BinaryExpressionASTNode", function() { return BinaryExpressionASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TernaryExpressionASTNode", function() { return TernaryExpressionASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnaryExpressionASTNode", function() { return UnaryExpressionASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PostfixExpressionASTNode", function() { return PostfixExpressionASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PrefixExpressionASTNode", function() { return PrefixExpressionASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MemberExpressionASTNode", function() { return MemberExpressionASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AssignmentASTNode", function() { return AssignmentASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IdentifierAssignmentASTNode", function() { return IdentifierAssignmentASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MemberAssignmentASTNode", function() { return MemberAssignmentASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VarASTNode", function() { return VarASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IterationASTNode", function() { return IterationASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BreakContinueASTNode", function() { return BreakContinueASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BreakASTNode", function() { return BreakASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContinueASTNode", function() { return ContinueASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ForASTNode", function() { return ForASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WhileASTNode", function() { return WhileASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FunctionASTNode", function() { return FunctionASTNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FunctionCallASTNode", function() { return FunctionCallASTNode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_get__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_parascript_identifierTable_js__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_common_errors_js__ = __webpack_require__(14);











var SourceLocation = function SourceLocation(firstToken, lastToken) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, SourceLocation);

  this.startLine = firstToken.first_line;
  this.startColumn = firstToken.first_column;
  if (lastToken != null) {
    this.endLine = lastToken.last_line;
    this.endColumn = lastToken.last_column;
  } else {
    this.endLine = firstToken.last_line;
    this.endColumn = firstToken.last_column;
  }
};

var ASTNode = function () {
  function ASTNode(location, children) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, ASTNode);

    this.location = location;

    this.children = [];
    if (children) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(children), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var child = _step.value;

          if (child) {
            child.parent = this;
            this.children.push(child);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(ASTNode, [{
    key: 'visit',
    value: function visit(operation) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var child = _step2.value;

          child.visit(operation);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (operation) {
        operation(this);
      }
    }
  }, {
    key: 'generate',
    value: function generate(agentAPI, agentCosts) {
      var identifierTable = new __WEBPACK_IMPORTED_MODULE_7_parascript_identifierTable_js__["a" /* default */](agentAPI.packageFunctions, agentAPI.packageConstants);

      this.visit(function (node) {
        node.identifierTable = identifierTable;
      });

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.children), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var node = _step3.value;

          if (node.declare) {
            node.declare();
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var instructionList = [];
      this.append(instructionList);

      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["a" /* HaltInstruction */]());

      var address = 0;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(instructionList), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var instruction = _step4.value;

          if (instruction.id == __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["b" /* INSTRUCTION_TYPES */].CALL) {
            this.identifierTable.fixFunctionCallInstruction(instruction);
          }

          instruction.cost = agentCosts[instruction.id];

          instruction.address = address++;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return instructionList;
    }
  }, {
    key: 'append',
    value: function append(instructionList) {}
  }]);

  return ASTNode;
}();

var ListASTNode = function (_ASTNode) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ListASTNode, _ASTNode);

  function ListASTNode(location, children, nestedScope) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, ListASTNode);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ListASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ListASTNode)).call(this, location, children));

    _this.nestedScope = nestedScope;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(ListASTNode, [{
    key: 'append',
    value: function append(instructionList) {
      if (this.nestedScope) {
        this.identifierTable.pushScope();
      }

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.children), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var node = _step5.value;

          node.append(instructionList);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      if (this.nestedScope) {
        this.identifierTable.popScope();
      }
    }
  }]);

  return ListASTNode;
}(ASTNode);

var EmptyASTNode = function (_ASTNode2) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(EmptyASTNode, _ASTNode2);

  function EmptyASTNode() {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, EmptyASTNode);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (EmptyASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(EmptyASTNode)).call(this, null));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(EmptyASTNode, [{
    key: 'append',
    value: function append(instructionList) {}
  }]);

  return EmptyASTNode;
}(ASTNode);

var IfASTNode = function (_ASTNode3) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(IfASTNode, _ASTNode3);

  function IfASTNode(location, condition, body, elsebody) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, IfASTNode);

    var _this3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (IfASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(IfASTNode)).call(this, location, [condition, body, elsebody]));

    _this3.condition = condition;
    _this3.body = body;
    _this3.elsebody = elsebody;
    return _this3;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(IfASTNode, [{
    key: 'append',
    value: function append(instructionList) {
      this.condition.append(instructionList);
      var condJmp = new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["c" /* ConditionalJumpInstruction */](this.location);
      instructionList.push(condJmp);
      this.body.append(instructionList);

      if (this.elsebody) {
        var elseJmp = new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["d" /* JumpInstruction */](this.location);
        elseJmp.isElse = true;
        instructionList.push(elseJmp);
      }

      condJmp.setAddress(instructionList.length);

      if (this.elsebody) {
        this.elsebody.append(instructionList);
        elseJmp.setAddress(instructionList.length);
      }
    }
  }]);

  return IfASTNode;
}(ASTNode);

var ReturnASTNode = function (_ASTNode4) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ReturnASTNode, _ASTNode4);

  function ReturnASTNode(location, expression) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, ReturnASTNode);

    var _this4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ReturnASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ReturnASTNode)).call(this, location, [expression]));

    _this4.expression = expression;
    return _this4;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(ReturnASTNode, [{
    key: 'hasEnclosingFunction',
    value: function hasEnclosingFunction() {
      var n = this;
      while (n.parent) {
        if (n.isFunctionDeclaration) {
          return true;
        }
        n = n.parent;
      }

      return false;
    }
  }, {
    key: 'append',
    value: function append(instructionList) {
      if (!this.hasEnclosingFunction()) {
        throw new __WEBPACK_IMPORTED_MODULE_9_common_errors_js__["b" /* CodeError */]("Return statement can be used only in a function.", this.location);
      }
      if (this.expression) {
        this.expression.append(instructionList);
      }
      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["e" /* ReturnInstruction */](this.location));
    }
  }]);

  return ReturnASTNode;
}(ASTNode);

var ExpressionStatementASTNode = function (_ASTNode5) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ExpressionStatementASTNode, _ASTNode5);

  function ExpressionStatementASTNode(location, expression) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, ExpressionStatementASTNode);

    var _this5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ExpressionStatementASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ExpressionStatementASTNode)).call(this, location, [expression]));

    _this5.expression = expression;
    return _this5;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(ExpressionStatementASTNode, [{
    key: 'append',
    value: function append(instructionList) {
      if (this.expression) {
        this.expression.append(instructionList);
      }

      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["f" /* PopInstruction */](this.location));
    }
  }]);

  return ExpressionStatementASTNode;
}(ASTNode);

var LiteralASTNode = function (_ASTNode6) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LiteralASTNode, _ASTNode6);

  function LiteralASTNode(location, value) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, LiteralASTNode);

    var _this6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LiteralASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(LiteralASTNode)).call(this, location));

    _this6.value = eval(value);
    return _this6;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(LiteralASTNode, [{
    key: 'append',
    value: function append(instructionList) {
      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["g" /* PushLiteralInstruction */](this.location, this.value));
    }
  }]);

  return LiteralASTNode;
}(ASTNode);

var IdentifierASTNode = function (_ASTNode7) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(IdentifierASTNode, _ASTNode7);

  function IdentifierASTNode(location, identifier) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, IdentifierASTNode);

    var _this7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (IdentifierASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(IdentifierASTNode)).call(this, location));

    _this7.identifier = identifier;
    return _this7;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(IdentifierASTNode, [{
    key: 'append',
    value: function append(instructionList) {
      this.identifierTable.checkIdentifierOrConstantDeclared(this.identifier, this.location);
      if (this.identifierTable.isPackageConstantDeclared(this.identifier)) {
        instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["g" /* PushLiteralInstruction */](this.location, this.identifierTable.getPackageConstant(this.identifier)));
      } else {
        instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["h" /* PushInstruction */](this.location, this.identifier, this.identifierTable.isGlobal(this.identifier)));
      }
    }
  }]);

  return IdentifierASTNode;
}(ASTNode);

var ArrayLiteralASTNode = function (_ASTNode8) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ArrayLiteralASTNode, _ASTNode8);

  function ArrayLiteralASTNode(location, expressionList) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, ArrayLiteralASTNode);

    var _this8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ArrayLiteralASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ArrayLiteralASTNode)).call(this, location, expressionList));

    _this8.expressionList = expressionList;
    return _this8;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(ArrayLiteralASTNode, [{
    key: 'append',
    value: function append(instructionList) {
      var length = 0;
      if (this.expressionList) {
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.expressionList), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var expression = _step6.value;

            if (expression) {
              expression.append(instructionList);
              length++;
            }
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }
      }
      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["i" /* ArrayInstruction */](this.location, length));
    }
  }]);

  return ArrayLiteralASTNode;
}(ASTNode);

var MapLiteralASTNode = function (_ASTNode9) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(MapLiteralASTNode, _ASTNode9);

  function MapLiteralASTNode(location, propertyList) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, MapLiteralASTNode);

    var _this9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MapLiteralASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(MapLiteralASTNode)).call(this, location, propertyList));

    _this9.propertyList = propertyList;
    return _this9;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(MapLiteralASTNode, [{
    key: 'append',
    value: function append(instructionList) {
      var propertyNames = [];
      if (this.propertyList) {
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.propertyList), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var property = _step7.value;

            if (property) {
              property.append(instructionList);
              propertyNames.push(property.property);
            }
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
              _iterator7.return();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }
      }
      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["j" /* MapInstruction */](this.location, propertyNames));
    }
  }]);

  return MapLiteralASTNode;
}(ASTNode);

var PropertyASTNode = function (_ASTNode10) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PropertyASTNode, _ASTNode10);

  function PropertyASTNode(location, property, expression) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, PropertyASTNode);

    var _this10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PropertyASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(PropertyASTNode)).call(this, location, [expression]));

    _this10.property = property;
    _this10.expression = expression;
    return _this10;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(PropertyASTNode, [{
    key: 'append',
    value: function append(instructionList) {
      this.expression.append(instructionList);
    }
  }]);

  return PropertyASTNode;
}(ASTNode);

var BinaryExpressionASTNode = function (_ASTNode11) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(BinaryExpressionASTNode, _ASTNode11);

  function BinaryExpressionASTNode(location, left, right, operator) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, BinaryExpressionASTNode);

    var _this11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BinaryExpressionASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(BinaryExpressionASTNode)).call(this, location, [left, right]));

    _this11.left = left;
    _this11.right = right;
    _this11.operator = operator;
    return _this11;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(BinaryExpressionASTNode, [{
    key: 'append',
    value: function append(instructionList) {
      this.left.append(instructionList);

      var shortCircuitJump = void 0;
      if (this.operator == "&&") {
        shortCircuitJump = new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["k" /* ShortCircuitConditionalJumpInstruction */](this.location, false);
        instructionList.push(shortCircuitJump);
      } else if (this.operator == "||") {
        shortCircuitJump = new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["k" /* ShortCircuitConditionalJumpInstruction */](this.location, true);
        instructionList.push(shortCircuitJump);
      }
      this.right.append(instructionList);
      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["l" /* BinaryOperationInstruction */](this.location, this.operator));
      if (shortCircuitJump) {
        shortCircuitJump.setAddress(instructionList.length);
      }
    }
  }]);

  return BinaryExpressionASTNode;
}(ASTNode);

var TernaryExpressionASTNode = function (_IfASTNode) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(TernaryExpressionASTNode, _IfASTNode);

  function TernaryExpressionASTNode(location, condition, first, second) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, TernaryExpressionASTNode);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TernaryExpressionASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(TernaryExpressionASTNode)).call(this, location, condition, first, second));
  }

  return TernaryExpressionASTNode;
}(IfASTNode);

var UnaryExpressionASTNode = function (_ASTNode12) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(UnaryExpressionASTNode, _ASTNode12);

  function UnaryExpressionASTNode(location, operator, expression) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, UnaryExpressionASTNode);

    var _this13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UnaryExpressionASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(UnaryExpressionASTNode)).call(this, location, [expression]));

    _this13.operator = operator;
    _this13.expression = expression;
    return _this13;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(UnaryExpressionASTNode, [{
    key: 'append',
    value: function append(instructionList) {
      this.expression.append(instructionList);
      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["m" /* UnaryOperationInstruction */](this.location, this.operator));
    }
  }]);

  return UnaryExpressionASTNode;
}(ASTNode);

var PostfixExpressionASTNode = function (_ASTNode13) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PostfixExpressionASTNode, _ASTNode13);

  function PostfixExpressionASTNode(location, identifier, operator) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, PostfixExpressionASTNode);

    var _this14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PostfixExpressionASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(PostfixExpressionASTNode)).call(this, location));

    _this14.operator = operator;
    _this14.identifier = identifier;

    return _this14;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(PostfixExpressionASTNode, [{
    key: 'append',
    value: function append(instructionList) {
      this.identifierTable.checkIdentifierAssignable(this.identifier, this.location);
      var global = this.identifierTable.isGlobal(this.identifier);
      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["h" /* PushInstruction */](this.location, this.identifier, global));
      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["h" /* PushInstruction */](this.location, this.identifier, global));
      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["m" /* UnaryOperationInstruction */](this.location, this.operator));
      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["n" /* AssignInstruction */](this.location, this.identifier, global, false));
    }
  }]);

  return PostfixExpressionASTNode;
}(ASTNode);

var PrefixExpressionASTNode = function (_ASTNode14) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PrefixExpressionASTNode, _ASTNode14);

  function PrefixExpressionASTNode(location, identifier, operator) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, PrefixExpressionASTNode);

    var _this15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PrefixExpressionASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(PrefixExpressionASTNode)).call(this, location));

    _this15.operator = operator;
    _this15.identifier = identifier;
    return _this15;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(PrefixExpressionASTNode, [{
    key: 'append',
    value: function append(instructionList) {
      this.identifierTable.checkIdentifierAssignable(this.identifier, this.location);
      var global = this.identifierTable.isGlobal(this.identifier);
      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["h" /* PushInstruction */](this.location, this.identifier, global));
      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["m" /* UnaryOperationInstruction */](this.location, this.operator));
      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["n" /* AssignInstruction */](this.location, this.identifier, global, false));
      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["h" /* PushInstruction */](this.location, this.identifier, global));
    }
  }]);

  return PrefixExpressionASTNode;
}(ASTNode);

var MemberExpressionASTNode = function (_ASTNode15) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(MemberExpressionASTNode, _ASTNode15);

  function MemberExpressionASTNode(location, owner, field, evaluate) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, MemberExpressionASTNode);

    var _this16 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MemberExpressionASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(MemberExpressionASTNode)).call(this, location, evaluate ? [owner, field] : [owner]));

    _this16.owner = owner;
    _this16.field = field;
    _this16.evaluate = evaluate;return _this16;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(MemberExpressionASTNode, [{
    key: 'append',
    value: function append(instructionList, assignment) {
      this.owner.append(instructionList);
      if (this.evaluate) {
        this.field.append(instructionList);
      }

      var fieldName = this.evaluate ? null : this.field;

      if (!assignment) {
        instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["o" /* MemberInstruction */](this.location, fieldName));
      } else {
        instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["p" /* MemberAssignmentInstruction */](this.location, fieldName));
      }
    }
  }]);

  return MemberExpressionASTNode;
}(ASTNode);

var AssignmentASTNode = function (_ASTNode16) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AssignmentASTNode, _ASTNode16);

  function AssignmentASTNode(location, expression, operator, children) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, AssignmentASTNode);

    var _this17 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AssignmentASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AssignmentASTNode)).call(this, location, children));

    _this17.expression = expression;
    _this17.operator = operator;
    return _this17;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(AssignmentASTNode, [{
    key: 'append',
    value: function append(instructionList) {
      this.expression.append(instructionList);

      var assignmentOperator = this.getArithmeticOperator(this.operator);
      if (assignmentOperator) {
        this.appendLeftHandSide(instructionList);

        instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["l" /* BinaryOperationInstruction */](this.location, assignmentOperator));
      }

      this.appendAssignmentInstruction(instructionList);
    }
  }, {
    key: 'appendLeftHandSide',
    value: function appendLeftHandSide(instructionList) {}
  }, {
    key: 'appendAssignmentInstruction',
    value: function appendAssignmentInstruction(instructionList) {}
  }, {
    key: 'getArithmeticOperator',
    value: function getArithmeticOperator(assignmentOperator) {
      if (assignmentOperator == "=") {
        return null;
      }
      if (assignmentOperator == "+=") {
        return "+";
      } else if (assignmentOperator == "-=") {
        return "-";
      }if (assignmentOperator == "/=") {
        return "/";
      }if (assignmentOperator == "*=") {
        return "*";
      }
      throw new __WEBPACK_IMPORTED_MODULE_9_common_errors_js__["b" /* CodeError */]("Assignment operator not known: " + assignmentOperator, this.location);
    }
  }]);

  return AssignmentASTNode;
}(ASTNode);

var IdentifierAssignmentASTNode = function (_AssignmentASTNode) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(IdentifierAssignmentASTNode, _AssignmentASTNode);

  function IdentifierAssignmentASTNode(location, identifier, expression, operator) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, IdentifierAssignmentASTNode);

    var _this18 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (IdentifierAssignmentASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(IdentifierAssignmentASTNode)).call(this, location, expression, operator, [expression]));

    _this18.identifier = identifier;
    return _this18;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(IdentifierAssignmentASTNode, [{
    key: 'appendLeftHandSide',
    value: function appendLeftHandSide(instructionList) {
      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["h" /* PushInstruction */](this.location, this.identifier, this.identifierTable.isGlobal(this.identifier)));
    }
  }, {
    key: 'appendAssignmentInstruction',
    value: function appendAssignmentInstruction(instructionList) {
      this.identifierTable.checkIdentifierAssignable(this.identifier, this.location);

      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["n" /* AssignInstruction */](this.location, this.identifier, this.identifierTable.isGlobal(this.identifier), true));
    }
  }]);

  return IdentifierAssignmentASTNode;
}(AssignmentASTNode);

var MemberAssignmentASTNode = function (_AssignmentASTNode2) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(MemberAssignmentASTNode, _AssignmentASTNode2);

  function MemberAssignmentASTNode(location, member, expression, operator) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, MemberAssignmentASTNode);

    var _this19 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MemberAssignmentASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(MemberAssignmentASTNode)).call(this, location, expression, operator, [expression, member]));

    _this19.member = member;
    return _this19;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(MemberAssignmentASTNode, [{
    key: 'appendLeftHandSide',
    value: function appendLeftHandSide(instructionList) {
      this.member.append(instructionList);
    }
  }, {
    key: 'appendAssignmentInstruction',
    value: function appendAssignmentInstruction(instructionList) {
      this.member.append(instructionList, true);
    }
  }]);

  return MemberAssignmentASTNode;
}(AssignmentASTNode);

var VarASTNode = function (_ASTNode17) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(VarASTNode, _ASTNode17);

  function VarASTNode(location, identifier, expression) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, VarASTNode);

    var _this20 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (VarASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(VarASTNode)).call(this, location, [expression]));

    _this20.identifier = identifier;
    _this20.expression = expression;
    return _this20;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(VarASTNode, [{
    key: 'append',
    value: function append(instructionList) {
      this.identifierTable.declareIdentifier(this.identifier, this.location);
      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["q" /* DeclareInstruction */](this.location, this.identifier, this.identifierTable.isGlobal()));
      if (this.expression) {
        this.expression.append(instructionList);
        instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["n" /* AssignInstruction */](this.location, this.identifier, this.identifierTable.isGlobal(), false));
      }
    }
  }]);

  return VarASTNode;
}(ASTNode);

var IterationASTNode = function (_ASTNode18) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(IterationASTNode, _ASTNode18);

  function IterationASTNode(location, children) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, IterationASTNode);

    var _this21 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (IterationASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(IterationASTNode)).call(this, location, children));

    _this21.iterationNode = true;
    return _this21;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(IterationASTNode, [{
    key: 'fixBreakContinue',
    value: function fixBreakContinue(continueAddr, breakAddr) {
      var _recursive = function _recursive(nodes) {
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
          for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(nodes), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
            var node = _step8.value;

            if (node.isBreak) {
              node.instruction.setAddress(breakAddr);
            } else if (node.isContinue) {
              node.instruction.setAddress(continueAddr);
            } else if (!node.iterationNode && node.children) {
              _recursive(node.children);
            }
          }
        } catch (err) {
          _didIteratorError8 = true;
          _iteratorError8 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion8 && _iterator8.return) {
              _iterator8.return();
            }
          } finally {
            if (_didIteratorError8) {
              throw _iteratorError8;
            }
          }
        }
      };

      _recursive([this.body]);
    }
  }]);

  return IterationASTNode;
}(ASTNode);

var BreakContinueASTNode = function (_ASTNode19) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(BreakContinueASTNode, _ASTNode19);

  function BreakContinueASTNode(location) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, BreakContinueASTNode);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BreakContinueASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(BreakContinueASTNode)).call(this, location, null));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(BreakContinueASTNode, [{
    key: 'append',
    value: function append(instructionList) {
      if (!this.hasEnclosingLoop()) {
        throw new __WEBPACK_IMPORTED_MODULE_9_common_errors_js__["b" /* CodeError */]("Break/continue statement cannot be used without an enclosing loop.", this.location);
      }
      this.instruction = new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["d" /* JumpInstruction */](this.location);
      instructionList.push(this.instruction);
    }
  }, {
    key: 'hasEnclosingLoop',
    value: function hasEnclosingLoop() {
      var n = this;
      while (n.parent) {
        if (n.iterationNode) {
          return true;
        }
        n = n.parent;
      }

      return false;
    }
  }]);

  return BreakContinueASTNode;
}(ASTNode);

var BreakASTNode = function (_BreakContinueASTNode) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(BreakASTNode, _BreakContinueASTNode);

  function BreakASTNode(location) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, BreakASTNode);

    var _this23 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BreakASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(BreakASTNode)).call(this, location));

    _this23.isBreak = true;
    return _this23;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(BreakASTNode, [{
    key: 'append',
    value: function append(instructionList) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_get___default()(BreakASTNode.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(BreakASTNode.prototype), 'append', this).call(this, instructionList);
      this.instruction.isBreak = true;
    }
  }]);

  return BreakASTNode;
}(BreakContinueASTNode);

var ContinueASTNode = function (_BreakContinueASTNode2) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ContinueASTNode, _BreakContinueASTNode2);

  function ContinueASTNode(location) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, ContinueASTNode);

    var _this24 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ContinueASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ContinueASTNode)).call(this, location));

    _this24.isContinue = true;
    return _this24;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(ContinueASTNode, [{
    key: 'append',
    value: function append(instructionList) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_get___default()(ContinueASTNode.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ContinueASTNode.prototype), 'append', this).call(this, instructionList);
      this.instruction.isContinue = true;
    }
  }]);

  return ContinueASTNode;
}(BreakContinueASTNode);

var ForASTNode = function (_IterationASTNode) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ForASTNode, _IterationASTNode);

  function ForASTNode(location, initialiser, condition, iteration, body) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, ForASTNode);

    var _this25 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ForASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ForASTNode)).call(this, location, [initialiser, condition, iteration, body]));

    _this25.initialiser = initialiser;
    _this25.condition = condition;
    _this25.iteration = iteration;
    _this25.body = body;
    return _this25;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(ForASTNode, [{
    key: 'append',
    value: function append(instructionList) {
      this.identifierTable.pushScope();

      if (this.initialiser) {
        this.initialiser.append(instructionList);
      }
      var startAddr = instructionList.length;
      var condJmp;
      if (this.condition) {
        this.condition.append(instructionList);
        condJmp = new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["c" /* ConditionalJumpInstruction */](this.location);
        instructionList.push(condJmp);
      }
      if (this.body) {
        this.body.append(instructionList);
      }

      var continueAddr = instructionList.length;
      if (this.iteration) {
        this.iteration.append(instructionList);

        instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["f" /* PopInstruction */](this.iteration.location));
      }
      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["d" /* JumpInstruction */](this.location, startAddr));
      if (condJmp) {
        condJmp.setAddress(instructionList.length);
      }

      this.identifierTable.popScope();

      condJmp.continueAddr = continueAddr;

      this.fixBreakContinue(continueAddr, instructionList.length);
    }
  }]);

  return ForASTNode;
}(IterationASTNode);

var WhileASTNode = function (_IterationASTNode2) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(WhileASTNode, _IterationASTNode2);

  function WhileASTNode(location, condition, body) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, WhileASTNode);

    var _this26 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WhileASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(WhileASTNode)).call(this, location, [condition, body]));

    _this26.condition = condition;
    _this26.body = body;
    return _this26;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(WhileASTNode, [{
    key: 'append',
    value: function append(instructionList) {
      var startAddr = instructionList.length;
      var condJmp;
      if (this.condition) {
        this.condition.append(instructionList);
        condJmp = new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["c" /* ConditionalJumpInstruction */](this.location);
        instructionList.push(condJmp);
      }
      if (this.body) {
        this.body.append(instructionList);
      }
      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["d" /* JumpInstruction */](this.location, startAddr));
      if (condJmp) {
        condJmp.setAddress(instructionList.length);
      }

      var continueAddr = instructionList.length;

      condJmp.continueAddr = continueAddr;

      this.fixBreakContinue(startAddr, continueAddr);
    }
  }]);

  return WhileASTNode;
}(IterationASTNode);

var FunctionASTNode = function (_ASTNode20) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(FunctionASTNode, _ASTNode20);

  function FunctionASTNode(location, name, args, body) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, FunctionASTNode);

    var _this27 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (FunctionASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(FunctionASTNode)).call(this, location, [body]));

    _this27.name = name;
    _this27.args = args;
    _this27.argCount = args ? args.length : 0;
    _this27.body = body;
    _this27.isFunctionDeclaration = true;
    return _this27;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(FunctionASTNode, [{
    key: 'declare',
    value: function declare() {

      this.identifierTable.declareFunction(this.name, this.location, this.argCount);
    }
  }, {
    key: 'append',
    value: function append(instructionList) {
      var skipJmp = new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["d" /* JumpInstruction */](this.location);
      instructionList.push(skipJmp);

      this.identifierTable.setFunctionAddress(this.name, instructionList.length, this.location);

      this.identifierTable.pushScope();

      if (this.args && this.args.length > 0) {
        var _iteratorNormalCompletion9 = true;
        var _didIteratorError9 = false;
        var _iteratorError9 = undefined;

        try {
          for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.args), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
            var arg = _step9.value;

            this.identifierTable.declareIdentifier(arg, this.location);

            instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["n" /* AssignInstruction */](this.location, arg, false, false));
          }
        } catch (err) {
          _didIteratorError9 = true;
          _iteratorError9 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion9 && _iterator9.return) {
              _iterator9.return();
            }
          } finally {
            if (_didIteratorError9) {
              throw _iteratorError9;
            }
          }
        }
      }

      this.body.nestedScope = false;
      this.body.append(instructionList);

      instructionList.push(new __WEBPACK_IMPORTED_MODULE_8_runtime_instructions_js__["e" /* ReturnInstruction */](this.location));

      this.identifierTable.popScope();

      skipJmp.setAddress(instructionList.length);
    }
  }]);

  return FunctionASTNode;
}(ASTNode);

var FunctionCallASTNode = function (_ASTNode21) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(FunctionCallASTNode, _ASTNode21);

  function FunctionCallASTNode(location, name, args) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, FunctionCallASTNode);

    var _this28 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (FunctionCallASTNode.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(FunctionCallASTNode)).call(this, location, args));

    _this28.name = name;
    _this28.args = args;
    _this28.isFunctionCall = true;
    return _this28;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(FunctionCallASTNode, [{
    key: 'append',
    value: function append(instructionList) {
      var argCount = 0;
      if (this.args) {
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
          for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.args.reverse()), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var arg = _step10.value;

            if (arg) {
              arg.append(instructionList);
              argCount++;
            }
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }
      }

      var functionCall = this.identifierTable.createFunctionCallInstruction(this.name, this.location, argCount);
      instructionList.push(functionCall);
    }
  }]);

  return FunctionCallASTNode;
}(ASTNode);

/***/ }),

/***/ 102:
/***/ (function(module, exports) {

module.exports = {
  NODE_ENV: '"production"'
}


/***/ }),

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_errors_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_parascript_ast_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_parascript_parser_parascript_js__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_parascript_parser_parascript_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_parascript_parser_parascript_js__);






var Compiler = function () {
  function Compiler() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Compiler);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Compiler, [{
    key: 'compile',
    value: function compile(source, agentType) {
      var parseTree;
      try {
        parseTree = __WEBPACK_IMPORTED_MODULE_4_parascript_parser_parascript_js___default.a.parse(source);
      } catch (e) {
        var location = null;
        if (e.hash) {
          location = new __WEBPACK_IMPORTED_MODULE_3_parascript_ast_js__["SourceLocation"](e.hash.loc);
        }
        throw new __WEBPACK_IMPORTED_MODULE_2_common_errors_js__["b" /* CodeError */](e.message ? e.message : "Parse error", location);
      }

      if (!parseTree) {
        throw new __WEBPACK_IMPORTED_MODULE_2_common_errors_js__["b" /* CodeError */]("Unknown parse error, cannot build parse tree.");
      }

      return parseTree.generate(agentType.api, agentType.costs);
    }
  }]);

  return Compiler;
}();

/* harmony default export */ __webpack_exports__["a"] = (Compiler);

/***/ }),

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_stack_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_runtime_valueStack_js__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_runtime_memory_js__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_console_consoleProxy_js__ = __webpack_require__(19);







var Executor = function () {
    function Executor(agent) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Executor);

        this.agent = agent;
        this.instructions = agent.agentType.instructions;
        this.reset();
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Executor, [{
        key: 'reset',
        value: function reset() {
            this.ip = 0;
            this.elapsedSteps = 0;
            this.accumulatedCost = 0;
            this.done = false;
            this.stack = new __WEBPACK_IMPORTED_MODULE_3_runtime_valueStack_js__["a" /* default */]();
            this.addressStack = new __WEBPACK_IMPORTED_MODULE_2_utils_stack_js__["a" /* default */]();
            this.memory = new __WEBPACK_IMPORTED_MODULE_4_runtime_memory_js__["a" /* default */]();
            this.error = null;
            this.penalty = 0;
            this.next = null;
            this.lastIp = null;
            this.iterate();
        }
    }, {
        key: 'performNext',
        value: function performNext() {
            var instruction = this.next;
            this.elapsedSteps++;
            this.lastIp = this.ip;
            try {
                var cost = instruction.perform(this);
                this.accumulatedCost += cost;

                this.iterate();
                return {
                    instruction: instruction,
                    cost: cost,
                    done: this.done,
                    error: false
                };
            } catch (e) {
                console.error(e);
                __WEBPACK_IMPORTED_MODULE_5_components_console_consoleProxy_js__["a" /* default */].error(this.agent.name, "Runtime Error: " + e.message);
                this.error = e;
                this.done = true;
                return {
                    instruction: instruction,
                    error: e,
                    done: true
                };
            }
        }
    }, {
        key: 'breakpoint',
        value: function breakpoint() {
            return this.next && this.next.breakpoint;
        }
    }, {
        key: 'iterate',
        value: function iterate() {
            this.last = this.next;
            this.next = this.instructions[this.ip];
        }
    }, {
        key: 'highlight',
        value: function highlight(next) {
            if (next && this.next) {
                this.highlighted = true;
                this.agent.agentType.codearea.highlightAgent(this.agent, this.next);
            } else if (this.last) {
                this.highlighted = true;
                this.agent.agentType.codearea.highlightAgent(this.agent, this.last);
            }
        }
    }, {
        key: 'lowlight',
        value: function lowlight() {
            if (this.highlighted) {
                this.agent.agentType.codearea.lowlightAgent();
            }
        }
    }, {
        key: 'cleanup',
        value: function cleanup() {
            this.lowlight();
            this.done = true;
            this.agent = null;
            this.instructions = null;
        }
    }, {
        key: 'redeemPromise',
        value: function redeemPromise() {
            var lastPush = this.stack.peek();
            if (lastPush && typeof lastPush == 'function') {
                this.stack.pop();

                this.stack.push(lastPush());
            }
        }
    }]);

    return Executor;
}();

/* harmony default export */ __webpack_exports__["a"] = (Executor);

/***/ }),

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_AGENT_COSTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_global_js__ = __webpack_require__(32);






var DEFAULT_UNIT_COST = __WEBPACK_IMPORTED_MODULE_5_constants_js__["a" /* default */].TICK_COST;
var RANDOM_COST_COEF = 5;

var CostProfile = function () {
    function CostProfile() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, CostProfile);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(CostProfile, [{
        key: 'unit',
        value: function unit() {}
    }, {
        key: 'free',
        value: function free() {
            return 0;
        }
    }]);

    return CostProfile;
}();

var ConstantCostProfile = function (_CostProfile) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ConstantCostProfile, _CostProfile);

    function ConstantCostProfile() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ConstantCostProfile);

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ConstantCostProfile.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ConstantCostProfile)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ConstantCostProfile, [{
        key: 'unit',
        value: function unit() {
            return DEFAULT_UNIT_COST;
        }
    }]);

    return ConstantCostProfile;
}(CostProfile);

var RandomCostProfile = function (_CostProfile2) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(RandomCostProfile, _CostProfile2);

    function RandomCostProfile() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, RandomCostProfile);

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RandomCostProfile.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(RandomCostProfile)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(RandomCostProfile, [{
        key: 'unit',
        value: function unit() {
            return Math.random() * DEFAULT_UNIT_COST * RANDOM_COST_COEF;
        }
    }]);

    return RandomCostProfile;
}(CostProfile);

var AgentCostProfile = function (_ConstantCostProfile) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(AgentCostProfile, _ConstantCostProfile);

    function AgentCostProfile() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, AgentCostProfile);

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AgentCostProfile.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AgentCostProfile)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(AgentCostProfile, [{
        key: 'unit',
        value: function unit(agent) {
            return agent.instructionCost + Math.random() * agent.instructionCost * DEFAULT_UNIT_COST;
        }
    }]);

    return AgentCostProfile;
}(ConstantCostProfile);

var InstructionCost = function () {
    function InstructionCost() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, InstructionCost);

        this.setConstantProfile();
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(InstructionCost, [{
        key: 'setConstantProfile',
        value: function setConstantProfile() {
            this.profile = new ConstantCostProfile();
        }
    }, {
        key: 'setRandomProfile',
        value: function setRandomProfile() {
            this.profile = new RandomCostProfile();
        }
    }, {
        key: 'setAgentProfile',
        value: function setAgentProfile() {
            this.profile = new AgentCostProfile();
        }
    }, {
        key: 'unit',
        value: function unit(agent) {
            return this.profile.unit(agent);
        }
    }, {
        key: 'free',
        value: function free(agent) {
            return this.profile.free(agent);
        }
    }]);

    return InstructionCost;
}();

var instructionCost = new InstructionCost();

__WEBPACK_IMPORTED_MODULE_6_utils_global_js__["a" /* default */].publish(instructionCost, "instructionCost");
/* harmony default export */ __webpack_exports__["a"] = (instructionCost);

var COST_PROXY = {

    free: function free(agent) {
        return instructionCost.free(agent);
    },

    unit: function unit(agent) {
        return instructionCost.unit(agent);
    }

};

var DEFAULT_AGENT_COSTS = {
    HALT: COST_PROXY.free,

    JUMP: COST_PROXY.unit,
    COND_JUMP: COST_PROXY.unit,

    CALL: COST_PROXY.unit,
    CALL_PACKAGE: COST_PROXY.unit,
    RETURN: COST_PROXY.unit,

    DECLARE: COST_PROXY.free,
    ASSIGN: COST_PROXY.unit,

    PUSH: COST_PROXY.free,
    POP: COST_PROXY.free,
    PUSH_LITERAL: COST_PROXY.free,

    ARRAY: COST_PROXY.free,
    MAP: COST_PROXY.free,
    MEMBER: COST_PROXY.free,
    MEMBER_ASSIGN: COST_PROXY.free,

    BINARY_OP: COST_PROXY.unit,
    UNARY_OP: COST_PROXY.unit
};

/***/ }),

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INSTRUCTION_TYPES; });
/* unused harmony export Instruction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HaltInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return JumpInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ConditionalJumpInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ShortCircuitConditionalJumpInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ReturnInstruction; });
/* unused harmony export IdentifierInstruction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PushInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PopInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PushLiteralInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ArrayInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MapInstruction; });
/* unused harmony export AbstractMemberInstruction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MemberInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return MemberAssignmentInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DeclareInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return AssignInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return BinaryOperationInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UnaryOperationInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FunctionCallInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PackageFunctionCallInstruction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_errors_js__ = __webpack_require__(14);









var INSTRUCTION_TYPES = {

  HALT: "HALT",

  JUMP: "JUMP",
  COND_JUMP: "COND_JUMP",

  CALL: "CALL",
  CALL_PACKAGE: "CALL_PACKAGE",
  RETURN: "RETURN",

  DECLARE: "DECLARE",
  ASSIGN: "ASSIGN",

  PUSH: "PUSH",
  POP: "POP",
  PUSH_LITERAL: "PUSH_LITERAL",

  ARRAY: "ARRAY",
  MAP: "MAP",
  MEMBER: "MEMBER",
  MEMBER_ASSIGN: "MEMBER_ASSIGN",

  BINARY_OP: "BINARY_OP",
  UNARY_OP: "UNARY_OP"
};

var Instruction = function () {
  function Instruction(id, location) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, Instruction);

    this.id = id;
    this.location = location;
    this.params = {};
    this.cost = null;
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(Instruction, [{
    key: "perform",
    value: function perform(executor) {}
  }]);

  return Instruction;
}();

var HaltInstruction = function (_Instruction) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(HaltInstruction, _Instruction);

  function HaltInstruction() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, HaltInstruction);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (HaltInstruction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(HaltInstruction)).call(this, INSTRUCTION_TYPES.HALT, null));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(HaltInstruction, [{
    key: "perform",
    value: function perform(executor) {
      executor.done = true;
      executor.ip++;
      return this.cost(executor.agent.definition);
    }
  }]);

  return HaltInstruction;
}(Instruction);

var JumpInstruction = function (_Instruction2) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(JumpInstruction, _Instruction2);

  function JumpInstruction(location, address) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, JumpInstruction);

    var _this2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (JumpInstruction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(JumpInstruction)).call(this, INSTRUCTION_TYPES.JUMP, location));

    _this2.params.address = address;
    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(JumpInstruction, [{
    key: "setAddress",
    value: function setAddress(address) {
      this.params.address = address;
    }
  }, {
    key: "perform",
    value: function perform(executor) {
      executor.ip = this.params.address;
      return this.cost(executor.agent.definition);
    }
  }]);

  return JumpInstruction;
}(Instruction);

var ConditionalJumpInstruction = function (_Instruction3) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ConditionalJumpInstruction, _Instruction3);

  function ConditionalJumpInstruction(location) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, ConditionalJumpInstruction);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ConditionalJumpInstruction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ConditionalJumpInstruction)).call(this, INSTRUCTION_TYPES.COND_JUMP));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(ConditionalJumpInstruction, [{
    key: "setAddress",
    value: function setAddress(address) {
      this.params.address = address;
    }
  }, {
    key: "getCondition",
    value: function getCondition(executor) {
      return executor.stack.pop();
    }
  }, {
    key: "perform",
    value: function perform(executor) {
      var condition = this.getCondition(executor);
      if (!condition) {
        executor.ip = this.params.address;
        executor.jumped = true;
      } else {
        executor.ip++;
        executor.jumped = false;
      }
      return this.cost(executor.agent.definition);
    }
  }]);

  return ConditionalJumpInstruction;
}(Instruction);

var ShortCircuitConditionalJumpInstruction = function (_ConditionalJumpInstr) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ShortCircuitConditionalJumpInstruction, _ConditionalJumpInstr);

  function ShortCircuitConditionalJumpInstruction(location, negate) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, ShortCircuitConditionalJumpInstruction);

    var _this4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ShortCircuitConditionalJumpInstruction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ShortCircuitConditionalJumpInstruction)).call(this, location));

    _this4.params.peek = true;
    _this4.params.negate = negate;
    return _this4;
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(ShortCircuitConditionalJumpInstruction, [{
    key: "getCondition",
    value: function getCondition(executor) {
      var condition = executor.stack.peek();
      if (this.params.negate) {
        condition = !condition;
      }
      return condition;
    }
  }]);

  return ShortCircuitConditionalJumpInstruction;
}(ConditionalJumpInstruction);

var ReturnInstruction = function (_Instruction4) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ReturnInstruction, _Instruction4);

  function ReturnInstruction(location) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, ReturnInstruction);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ReturnInstruction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ReturnInstruction)).call(this, INSTRUCTION_TYPES.RETURN, location));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(ReturnInstruction, [{
    key: "perform",
    value: function perform(executor) {
      executor.memory.exit();

      executor.ip = executor.addressStack.pop() + 1;
      return this.cost(executor.agent.definition);
    }
  }]);

  return ReturnInstruction;
}(Instruction);

var IdentifierInstruction = function (_Instruction5) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(IdentifierInstruction, _Instruction5);

  function IdentifierInstruction(id, location, identifier, global) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, IdentifierInstruction);

    var _this6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (IdentifierInstruction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(IdentifierInstruction)).call(this, id, location));

    if (global === null || global === undefined) {
      throw new __WEBPACK_IMPORTED_MODULE_7_common_errors_js__["a" /* InternalError */]("Global must be specified for identifier " + identifier, location);
    }
    _this6.params.identifier = identifier;
    _this6.params.global = global;
    return _this6;
  }

  return IdentifierInstruction;
}(Instruction);

var PushInstruction = function (_IdentifierInstructio) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PushInstruction, _IdentifierInstructio);

  function PushInstruction(location, identifier, global) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, PushInstruction);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PushInstruction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(PushInstruction)).call(this, INSTRUCTION_TYPES.PUSH, location, identifier, global));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(PushInstruction, [{
    key: "perform",
    value: function perform(executor) {
      var value;
      if (this.params.global) {
        value = executor.memory.loadGlobal(this.params.identifier);
      } else {
        value = executor.memory.loadLocal(this.params.identifier);
      }
      executor.stack.push(value);
      executor.ip++;
      return this.cost(executor.agent.definition);
    }
  }]);

  return PushInstruction;
}(IdentifierInstruction);

var PopInstruction = function (_Instruction6) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PopInstruction, _Instruction6);

  function PopInstruction(location) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, PopInstruction);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PopInstruction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(PopInstruction)).call(this, INSTRUCTION_TYPES.POP, location));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(PopInstruction, [{
    key: "perform",
    value: function perform(executor) {
      executor.stack.pop();
      executor.ip++;
      return this.cost(executor.agent.definition);
    }
  }]);

  return PopInstruction;
}(Instruction);

var PushLiteralInstruction = function (_Instruction7) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PushLiteralInstruction, _Instruction7);

  function PushLiteralInstruction(location, value) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, PushLiteralInstruction);

    var _this9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PushLiteralInstruction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(PushLiteralInstruction)).call(this, INSTRUCTION_TYPES.PUSH_LITERAL, location));

    _this9.params.value = value;
    return _this9;
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(PushLiteralInstruction, [{
    key: "perform",
    value: function perform(executor) {
      executor.stack.push(this.params.value);
      executor.ip++;
      return this.cost(executor.agent.definition);
    }
  }]);

  return PushLiteralInstruction;
}(Instruction);

var ArrayInstruction = function (_Instruction8) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ArrayInstruction, _Instruction8);

  function ArrayInstruction(location, length) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, ArrayInstruction);

    var _this10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ArrayInstruction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ArrayInstruction)).call(this, INSTRUCTION_TYPES.ARRAY, location));

    _this10.params.length = length;
    return _this10;
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(ArrayInstruction, [{
    key: "perform",
    value: function perform(executor) {
      var array = executor.stack.popN(this.params.length);

      executor.stack.push(array);
      executor.ip++;
      return this.cost(executor.agent.definition);
    }
  }]);

  return ArrayInstruction;
}(Instruction);

var MapInstruction = function (_Instruction9) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MapInstruction, _Instruction9);

  function MapInstruction(location, properties) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, MapInstruction);

    var _this11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MapInstruction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(MapInstruction)).call(this, INSTRUCTION_TYPES.MAP, location));

    _this11.params.properties = properties;
    return _this11;
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(MapInstruction, [{
    key: "perform",
    value: function perform(executor) {
      var values = executor.stack.popN(this.params.properties.length);

      var map = {};
      for (var i = 0; i < this.params.properties.length; i++) {
        map[this.params.properties[i]] = values[i];
      }
      executor.stack.push(map);
      executor.ip++;
      return this.cost(executor.agent.definition);
    }
  }]);

  return MapInstruction;
}(Instruction);

var AbstractMemberInstruction = function (_Instruction10) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AbstractMemberInstruction, _Instruction10);

  function AbstractMemberInstruction(instructionType, location, field) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, AbstractMemberInstruction);

    var _this12 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AbstractMemberInstruction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(AbstractMemberInstruction)).call(this, instructionType, location));

    _this12.params.field = field;
    return _this12;
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(AbstractMemberInstruction, [{
    key: "getIndexable",
    value: function getIndexable(executor) {
      var indexable = executor.stack.pop();
      if (indexable === null || indexable === undefined) {
        throw new __WEBPACK_IMPORTED_MODULE_7_common_errors_js__["c" /* RuntimeError */]("Null pointer access: Array or Map is not initialized.", this, executor.agent);
      }
      if (indexable.constructor.name != 'Array' && indexable.constructor.name != 'Object') {
        throw new __WEBPACK_IMPORTED_MODULE_7_common_errors_js__["c" /* RuntimeError */]("Illegal member access: expected Array or Map, but got " + (typeof indexable === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(indexable)) + " instead.", this, executor.agent);
      }
      return indexable;
    }
  }]);

  return AbstractMemberInstruction;
}(Instruction);

var MemberInstruction = function (_AbstractMemberInstru) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MemberInstruction, _AbstractMemberInstru);

  function MemberInstruction(location, field) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, MemberInstruction);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MemberInstruction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(MemberInstruction)).call(this, INSTRUCTION_TYPES.MEMBER, location, field));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(MemberInstruction, [{
    key: "perform",
    value: function perform(executor) {
      if (this.params.field) {
        executor.stack.push(this.getIndexable(executor)[this.params.field]);
      } else {
        var index = executor.stack.pop();
        executor.stack.push(this.getIndexable(executor)[index]);
      }
      executor.ip++;
      return this.cost(executor.agent.definition);
    }
  }]);

  return MemberInstruction;
}(AbstractMemberInstruction);

var MemberAssignmentInstruction = function (_AbstractMemberInstru2) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MemberAssignmentInstruction, _AbstractMemberInstru2);

  function MemberAssignmentInstruction(location, field) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, MemberAssignmentInstruction);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MemberAssignmentInstruction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(MemberAssignmentInstruction)).call(this, INSTRUCTION_TYPES.MEMBER_ASSIGN, location, field));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(MemberAssignmentInstruction, [{
    key: "perform",
    value: function perform(executor) {
      var index = void 0;
      if (this.params.field) {
        index = this.params.field;
      } else {
        index = executor.stack.pop();
      }

      var indexable = this.getIndexable(executor);

      var value = executor.stack.peek();

      indexable[index] = value;
      executor.ip++;
      return this.cost(executor.agent.definition);
    }
  }]);

  return MemberAssignmentInstruction;
}(AbstractMemberInstruction);

var DeclareInstruction = function (_IdentifierInstructio2) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DeclareInstruction, _IdentifierInstructio2);

  function DeclareInstruction(location, identifier, global) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, DeclareInstruction);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DeclareInstruction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(DeclareInstruction)).call(this, INSTRUCTION_TYPES.DECLARE, location, identifier, global));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(DeclareInstruction, [{
    key: "perform",
    value: function perform(executor) {
      if (this.params.global) {
        executor.memory.storeGlobal(this.params.identifier, null);
      } else {
        executor.memory.storeLocal(this.params.identifier, null);
      }
      executor.ip++;
      return this.cost(executor.agent.definition);
    }
  }]);

  return DeclareInstruction;
}(IdentifierInstruction);

var AssignInstruction = function (_IdentifierInstructio3) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AssignInstruction, _IdentifierInstructio3);

  function AssignInstruction(location, identifier, global, peek) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, AssignInstruction);

    var _this16 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AssignInstruction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(AssignInstruction)).call(this, INSTRUCTION_TYPES.ASSIGN, location, identifier, global));

    if (peek) {
      _this16.getValue = function (executor) {
        return executor.stack.peek();
      };
    } else {
      _this16.getValue = function (executor) {
        return executor.stack.pop();
      };
    }
    return _this16;
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(AssignInstruction, [{
    key: "perform",
    value: function perform(executor) {
      var value = this.getValue(executor);
      if (this.params.global) {
        executor.memory.storeGlobal(this.params.identifier, value);
      } else {
        executor.memory.storeLocal(this.params.identifier, value);
      }
      executor.ip++;
      return this.cost(executor.agent.definition);
    }
  }]);

  return AssignInstruction;
}(IdentifierInstruction);

function getBinaryOperation(operator) {
  if (operator == "+") {
    return function (a, b) {
      return a + b;
    };
  } else if (operator == "-") {
    return function (a, b) {
      return a - b;
    };
  } else if (operator == "*") {
    return function (a, b) {
      return a * b;
    };
  } else if (operator == "/") {
    return function (a, b) {
      return a / b;
    };
  } else if (operator == "%") {
    return function (a, b) {
      return a % b;
    };
  } else if (operator == "&&") {
    return function (a, b) {
      return a && b;
    };
  } else if (operator == "||") {
    return function (a, b) {
      return a || b;
    };
  } else if (operator == "==") {
    return function (a, b) {
      return a == b;
    };
  } else if (operator == "!=") {
    return function (a, b) {
      return a != b;
    };
  } else if (operator == "===") {
    return function (a, b) {
      return a === b;
    };
  } else if (operator == "!==") {
    return function (a, b) {
      return a !== b;
    };
  } else if (operator == "<") {
    return function (a, b) {
      return a < b;
    };
  } else if (operator == ">") {
    return function (a, b) {
      return a > b;
    };
  } else if (operator == "<=") {
    return function (a, b) {
      return a <= b;
    };
  } else if (operator == ">=") {
    return function (a, b) {
      return a >= b;
    };
  } else if (operator == "|") {
    return function (a, b) {
      return a | b;
    };
  } else if (operator == "&") {
    return function (a, b) {
      return a & b;
    };
  } else if (operator == "^") {
    return function (a, b) {
      return a ^ b;
    };
  } else if (operator == ">>") {
    return function (a, b) {
      return a >> b;
    };
  } else if (operator == "<<") {
    return function (a, b) {
      return a << b;
    };
  }
  throw new __WEBPACK_IMPORTED_MODULE_7_common_errors_js__["a" /* InternalError */]("Unknown binary operator: " + operator);
}

var BinaryOperationInstruction = function (_Instruction11) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(BinaryOperationInstruction, _Instruction11);

  function BinaryOperationInstruction(location, operator) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, BinaryOperationInstruction);

    var _this17 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BinaryOperationInstruction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(BinaryOperationInstruction)).call(this, INSTRUCTION_TYPES.BINARY_OP, location));

    _this17.params.operator = operator;
    _this17.operation = getBinaryOperation(operator);
    return _this17;
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(BinaryOperationInstruction, [{
    key: "perform",
    value: function perform(executor) {
      var value2 = executor.stack.pop();
      var value1 = executor.stack.pop();
      var result = this.operation(value1, value2);
      executor.stack.push(result);
      executor.ip++;
      return this.cost(executor.agent.definition);
    }
  }]);

  return BinaryOperationInstruction;
}(Instruction);

function getUnaryOperation(operator) {
  if (operator == "+") {
    return function (a) {
      return a;
    };
  } else if (operator == "-") {
    return function (a) {
      return -a;
    };
  } else if (operator == "!") {
    return function (a) {
      return !a;
    };
  } else if (operator == "--") {
    return function (a) {
      return --a;
    };
  } else if (operator == "++") {
    return function (a) {
      return ++a;
    };
  }
  throw new __WEBPACK_IMPORTED_MODULE_7_common_errors_js__["a" /* InternalError */]("Unknown unary operator: " + operator);
}

var UnaryOperationInstruction = function (_Instruction12) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(UnaryOperationInstruction, _Instruction12);

  function UnaryOperationInstruction(location, operator) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, UnaryOperationInstruction);

    var _this18 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UnaryOperationInstruction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(UnaryOperationInstruction)).call(this, INSTRUCTION_TYPES.UNARY_OP, location));

    _this18.params.operator = operator;
    _this18.operation = getUnaryOperation(operator);
    return _this18;
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(UnaryOperationInstruction, [{
    key: "perform",
    value: function perform(executor) {
      var value = executor.stack.pop();
      var result = this.operation(value);
      executor.stack.push(result);
      executor.ip++;
      return this.cost(executor.agent.definition);
    }
  }]);

  return UnaryOperationInstruction;
}(Instruction);

var FunctionCallInstruction = function (_Instruction13) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FunctionCallInstruction, _Instruction13);

  function FunctionCallInstruction(location, name, argCount) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, FunctionCallInstruction);

    var _this19 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (FunctionCallInstruction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(FunctionCallInstruction)).call(this, INSTRUCTION_TYPES.CALL, location));

    _this19.params.name = name;
    _this19.params.argCount = argCount;
    return _this19;
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(FunctionCallInstruction, [{
    key: "setAddress",
    value: function setAddress(address) {
      this.params.address = address;
    }
  }, {
    key: "perform",
    value: function perform(executor) {
      executor.memory.enter(this);
      executor.addressStack.push(executor.ip);
      executor.ip = this.params.address;
      return this.cost(executor.agent.definition);
    }
  }]);

  return FunctionCallInstruction;
}(Instruction);

var PackageFunctionCallInstruction = function (_Instruction14) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PackageFunctionCallInstruction, _Instruction14);

  function PackageFunctionCallInstruction(location, name, argCount, _function) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, PackageFunctionCallInstruction);

    var _this20 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PackageFunctionCallInstruction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(PackageFunctionCallInstruction)).call(this, INSTRUCTION_TYPES.CALL_PACKAGE, location));

    _this20.params.name = name;
    _this20.params.argCount = argCount;
    _this20.params._function = _function;
    return _this20;
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(PackageFunctionCallInstruction, [{
    key: "perform",
    value: function perform(executor) {
      var _params;

      var args = executor.stack.popN(this.params.argCount);
      var result = (_params = this.params)._function.apply(_params, [executor.agent.definition].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
      if (!result || isNaN(result.cost)) {
        throw new __WEBPACK_IMPORTED_MODULE_7_common_errors_js__["c" /* RuntimeError */]("Package function must return Object containing cost.", this, executor.agent);
      }
      executor.stack.push(result.result);
      executor.ip++;
      return result.cost;
    }
  }]);

  return PackageFunctionCallInstruction;
}(Instruction);

/***/ }),

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_runtime_executor_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_runtime_scheduler_states_js__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_errors_js__ = __webpack_require__(14);








var Scheduler = function () {
    function Scheduler(session) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Scheduler);

        this.session = session;
        this.state = __WEBPACK_IMPORTED_MODULE_4_runtime_scheduler_states_js__["a" /* default */].READY;
        this.doneExecutors = 0;
        this.type = null;
        this.createExecutors();
        this.reset();
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Scheduler, [{
        key: 'createExecutors',
        value: function createExecutors() {
            this.executors = [];
            this.executorMap = {};
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.session.agentTypeNames), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var agentTypeName = _step.value;

                    var agentType = this.session.agentMap[agentTypeName];
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(agentType.agentNames), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var agentName = _step2.value;

                            var agent = agentType.agents[agentName];
                            this.addExecutor(agent.createExecutor());
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: 'addExecutor',
        value: function addExecutor(executor) {
            this.executors.push(executor);
            this.executorMap[executor.agent.name] = executor;
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.lowlight();
            this.breakpoint = false;
            this.elapsedSteps = 0;
            this.accumulatedCost = 0;
            this.exception = null;
            this.state = __WEBPACK_IMPORTED_MODULE_4_runtime_scheduler_states_js__["a" /* default */].READY;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.executors), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var e = _step3.value;

                    e.reset();
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            this.doneExecutors = 0;

            this.nextExecutor = null;
            this.iterate();
        }
    }, {
        key: 'step',
        value: function step(executor) {
            if (this.isRunning() && executor.breakpoint() && !this.breakpoint) {
                this.breakpoint = true;
                this.pause();
                executor.highlight(true);
                return null;
            } else {
                this.breakpoint = false;
            }
            var result = executor.performNext();
            this.elapsedSteps++;
            this.lastExecutor = executor;
            if (result.error) {
                this.error(result.error);
                return result;
            }
            if (result.done) {
                this.doneExecutors++;
                if (this.doneExecutors >= this.executors.length) {
                    this.done();
                }
            }
            if ((executor.last && executor.last.id == 'CALL_PACKAGE' || this.isDone()) && !result.error) {
                try {
                    this.checkFinished();
                } catch (e) {
                    this.error(new __WEBPACK_IMPORTED_MODULE_5_common_errors_js__["a" /* InternalError */]("Tutorial Error: exception while checking tutorial status", e));
                }
            }
            return result;
        }
    }, {
        key: 'iterate',
        value: function iterate() {
            this.lastExecutor = this.nextExecutor;
            this.nextExecutor = this.getNextExecutor();
        }
    }, {
        key: 'getNextExecutor',
        value: function getNextExecutor() {
            throw "Unimplemented";
        }
    }, {
        key: 'checkFinished',
        value: function checkFinished() {
            var status = this.session.tutorial.getStatus(this.isDone());
            if (status && status.done) {
                this.done();

                this.session.tutorialFinished(status);
                return;
            }
            if (this.isDone()) {
                this.session.tutorialUnsolved();
            }
        }
    }, {
        key: 'done',
        value: function done() {
            this.nextExecutor = null;
            this.exception = null;
            this.state = __WEBPACK_IMPORTED_MODULE_4_runtime_scheduler_states_js__["a" /* default */].DONE;
            this.lowlight();
        }
    }, {
        key: 'run',
        value: function run() {
            this.exception = null;
            this.lowlight();
            this.state = __WEBPACK_IMPORTED_MODULE_4_runtime_scheduler_states_js__["a" /* default */].RUNNING;
        }
    }, {
        key: 'pause',
        value: function pause() {
            this.exception = null;
            this.state = __WEBPACK_IMPORTED_MODULE_4_runtime_scheduler_states_js__["a" /* default */].PAUSED;
        }
    }, {
        key: 'error',
        value: function error(e) {
            this.exception = e;
            this.state = __WEBPACK_IMPORTED_MODULE_4_runtime_scheduler_states_js__["a" /* default */].ERROR;
            this.lastExecutor.highlight(true);
        }
    }, {
        key: 'debugTick',
        value: function debugTick() {}
    }, {
        key: 'debugStep',
        value: function debugStep() {}
    }, {
        key: 'isReady',
        value: function isReady() {
            return this.state == __WEBPACK_IMPORTED_MODULE_4_runtime_scheduler_states_js__["a" /* default */].READY;
        }
    }, {
        key: 'isPaused',
        value: function isPaused() {
            return this.state == __WEBPACK_IMPORTED_MODULE_4_runtime_scheduler_states_js__["a" /* default */].PAUSED;
        }
    }, {
        key: 'isRunning',
        value: function isRunning() {
            return this.state == __WEBPACK_IMPORTED_MODULE_4_runtime_scheduler_states_js__["a" /* default */].RUNNING;
        }
    }, {
        key: 'isDone',
        value: function isDone() {
            return this.state == __WEBPACK_IMPORTED_MODULE_4_runtime_scheduler_states_js__["a" /* default */].DONE;
        }
    }, {
        key: 'isError',
        value: function isError() {
            return this.state == __WEBPACK_IMPORTED_MODULE_4_runtime_scheduler_states_js__["a" /* default */].ERROR;
        }
    }, {
        key: 'highlightNext',
        value: function highlightNext() {
            if (this.nextExecutor) {
                this.nextExecutor.highlight(true);
            }
        }
    }, {
        key: 'lowlight',
        value: function lowlight() {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.executors), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var e = _step4.value;

                    e.lowlight();
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        }
    }, {
        key: 'cleanup',
        value: function cleanup() {
            this.pause();
            if (this.timeout) {
                window.clearTimeout(this.timeout);
            }
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.executors), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var e = _step5.value;

                    e.cleanup();
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }
        }
    }]);

    return Scheduler;
}();

/* harmony default export */ __webpack_exports__["a"] = (Scheduler);

/***/ }),

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_errors_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_runtime_scheduler_scheduler_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_js__ = __webpack_require__(15);











var StandardScheduler = function (_Scheduler) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(StandardScheduler, _Scheduler);

    function StandardScheduler() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, StandardScheduler);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (StandardScheduler.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(StandardScheduler)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(StandardScheduler, [{
        key: 'run',
        value: function run() {
            __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(StandardScheduler.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(StandardScheduler.prototype), 'run', this).call(this);
            var self = this;
            function loop() {
                self.tick();
                if (self.isRunning()) {
                    self.timeout = window.setTimeout(loop, self.session.tickDuration);
                }
            }
            loop();
        }
    }, {
        key: 'tick',
        value: function tick() {
            var round = this.currentRound;
            while (round == this.currentRound) {
                this.step(this.nextExecutor);
                if (!this.isRunning()) {
                    break;
                }
            }
        }
    }, {
        key: 'step',
        value: function step(executor) {
            if (executor.penalty >= 1) {
                executor.penalty = Math.max(0, executor.penalty - __WEBPACK_IMPORTED_MODULE_9_constants_js__["a" /* default */].TICK_COST);
            }
            while (!executor.done && executor.penalty < 1) {
                var result = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(StandardScheduler.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(StandardScheduler.prototype), 'step', this).call(this, executor);
                if (result && result.cost) {
                    executor.penalty = Math.round(result.cost);
                    this.accumulatedCost += result.cost;
                }
                if (!this.isRunning()) {
                    break;
                }
                if (this.isError()) {
                    return;
                }
            }
            if (executor.done || executor.penalty >= 1) {
                this.iterate();
            }
        }
    }, {
        key: 'debugTick',
        value: function debugTick() {
            __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(StandardScheduler.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(StandardScheduler.prototype), 'debugTick', this).call(this);
            __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(StandardScheduler.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(StandardScheduler.prototype), 'run', this).call(this);
            this.tick();
            __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(StandardScheduler.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(StandardScheduler.prototype), 'pause', this).call(this);
        }
    }, {
        key: 'debugStep',
        value: function debugStep() {
            __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(StandardScheduler.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(StandardScheduler.prototype), 'debugStep', this).call(this);
            this.step(this.nextExecutor);
            this.highlightNext();
        }
    }, {
        key: 'getNextExecutor',
        value: function getNextExecutor() {
            this.ensureRound();
            return this.currentRound.pop();
        }
    }, {
        key: 'ensureRound',
        value: function ensureRound() {
            if (!this.currentRound || this.currentRound.length == 0) {
                this.makeRound();
            }
        }
    }, {
        key: 'makeRound',
        value: function makeRound() {
            this.currentRound = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.executors), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var e = _step.value;

                    if (!e.done) {
                        this.currentRound.push(e);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.currentRound.reverse();
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.currentRound = [];
            __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(StandardScheduler.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(StandardScheduler.prototype), 'reset', this).call(this);
        }
    }]);

    return StandardScheduler;
}(__WEBPACK_IMPORTED_MODULE_8_runtime_scheduler_scheduler_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (StandardScheduler);

/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_runtime_agentType_js__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_runtime_agent_js__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_global_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_runtime_scheduler_SchedulerFactory_js__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_console_consoleProxy_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_utils_modalMessage_modalMessageProxy__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_runtime_instructionCost_js__ = __webpack_require__(105);














var Session = function () {
    function Session(tutorial, config) {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Session);

        this.tutorial = tutorial;
        this.config = config;

        var agentId = 0;

        this.agentMap = {};
        this.agentNames = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.config.agents), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var agentDefinition = _step.value;

                if (!this.agentMap[agentDefinition.agentType.name]) {
                    this.agentMap[agentDefinition.agentType.name] = new __WEBPACK_IMPORTED_MODULE_5_runtime_agentType_js__["a" /* default */](agentDefinition.agentType);
                }
                var agentType = this.agentMap[agentDefinition.agentType.name];
                var agent = new __WEBPACK_IMPORTED_MODULE_6_runtime_agent_js__["a" /* default */](agentDefinition, agentType, agentId++);
                this.agentMap[agentDefinition.agentType.name].addAgent(agent);
                this.agentNames.push(agentDefinition.name);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        this.agentTypeNames = [];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.config.agentTypes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _agentType = _step2.value;

                this.agentTypeNames.push(_agentType.name);
                if (!this.agentMap[_agentType.name] || !this.agentMap[_agentType.name].agents.length < 1) {
                    __WEBPACK_IMPORTED_MODULE_9_components_console_consoleProxy_js__["a" /* default */].warn("System", "Tutorial config probably wrong; agentType " + _agentType.name + " has no associated agents.");
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.agentMap).length < 1) {
            __WEBPACK_IMPORTED_MODULE_9_components_console_consoleProxy_js__["a" /* default */].error("System", "Tutorial config probably wrong; there were no agents created...");
        }

        this.scheduler = null;

        this.showScheduler = true;

        this.lockstepCallbacks = {};

        __WEBPACK_IMPORTED_MODULE_7_utils_global_js__["a" /* default */].publish(this, "session");
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Session, [{
        key: 'initialize',
        value: function initialize() {
            __WEBPACK_IMPORTED_MODULE_12_runtime_instructionCost_js__["a" /* default */].setConstantProfile();
            this.tutorial.initialize(this);
            this.tutorial.reset(this);
            __WEBPACK_IMPORTED_MODULE_9_components_console_consoleProxy_js__["a" /* default */].info("System", "Loaded and initialized tutorial '" + this.tutorial.definition.name + "'");
        }
    }, {
        key: 'setup',
        value: function setup() {
            if (this.scheduler) {
                this.scheduler.cleanup();
            }

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.agentTypeNames), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var agentTypeName = _step3.value;

                    var agentType = this.agentMap[agentTypeName];
                    if (!agentType.isCompiled()) {
                        if (!agentType.compile()) {
                            return false;
                        }
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            this.scheduler = __WEBPACK_IMPORTED_MODULE_8_runtime_scheduler_SchedulerFactory_js__["a" /* default */].makeScheduler(this.config.schedulerType, this);
            this.reset();

            __WEBPACK_IMPORTED_MODULE_9_components_console_consoleProxy_js__["a" /* default */].debug("System", "Initialized session with " + this.scheduler.type.name);

            return true;
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.scheduler.reset();

            this.tutorial.reset();
        }
    }, {
        key: 'setSpeed',
        value: function setSpeed(value) {
            var factor = 1;
            switch (value) {
                case "Max":
                    factor = 0;break;
                case "8x":
                    factor = 1 / 8;break;
                case "4x":
                    factor = 1 / 4;break;
                case "2x":
                    factor = 1 / 2;break;
                case "1/2x":
                    factor = 2;break;
                case "1/4x":
                    factor = 4;break;
                case "1/8x":
                    factor = 8;break;
                default:
                    factor = 1;
            }
            this.tickDuration = __WEBPACK_IMPORTED_MODULE_10_constants_js__["a" /* default */].TICK_DURATION * factor;
            __WEBPACK_IMPORTED_MODULE_9_components_console_consoleProxy_js__["a" /* default */].debug("System", "Simulation speed: " + value + " (tick duration: " + this.tickDuration + "ms)");
        }
    }, {
        key: 'tutorialFinished',
        value: function tutorialFinished(status) {
            var message = status.message + "<br/><br/>Number of steps: <strong>" + this.scheduler.elapsedSteps + "</strong>";
            if (status.solved) {
                __WEBPACK_IMPORTED_MODULE_11_components_utils_modalMessage_modalMessageProxy__["a" /* default */].success({
                    title: "Great success ;)",
                    body: message
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_11_components_utils_modalMessage_modalMessageProxy__["a" /* default */].warning({
                    title: "Fail :'(",
                    body: message
                });
            }
        }
    }, {
        key: 'tutorialUnsolved',
        value: function tutorialUnsolved() {
            __WEBPACK_IMPORTED_MODULE_11_components_utils_modalMessage_modalMessageProxy__["a" /* default */].warningAlert("Your programs have finished, but the assignment remains unsolved... Try again ;)", "Tutorial unsolved");
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            if (this.scheduler) {
                this.scheduler.cleanup();
            }
            function cleanupRecursive(_package) {
                if (_package.cleanup) {
                    _package.cleanup();
                }

                if (_package.dependencies) {
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(_package.dependencies)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var d = _step4.value;

                            cleanupRecursive(d);
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }
                }
            }
            cleanupRecursive(this.tutorial);
        }
    }]);

    return Session;
}();

/* harmony default export */ __webpack_exports__["a"] = (Session);

/***/ }),

/***/ 1245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);




var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.util.warn('Invalid prop: prop "icon" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.', this);
            return false;
          }
          return true;
        }
        return null;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        __WEBPACK_IMPORTED_MODULE_0_vue___default.a.util.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    clazz: function clazz() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

/***/ }),

/***/ 1246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ObjectTreeNodeComplex_vue__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ObjectTreeNodeComplex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ObjectTreeNodeComplex_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ObjectTreeNodePrimitive_vue__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ObjectTreeNodePrimitive_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ObjectTreeNodePrimitive_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'objectTreeNode',
    props: ['value', 'primary'],
    computed: {
        type: function type() {
            var _type = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.value);
            if (_type == 'object') {
                if (this.value == null) {
                    return "null";
                }
                if (Array.isArray(this.value)) {
                    return "array";
                }
                return "object";
            }
            return _type;
        },
        primitive: function primitive() {
            return !(this.type === 'array' || this.type === 'object');
        }
    },
    components: {
        objectTreeNodeComplex: __WEBPACK_IMPORTED_MODULE_1__ObjectTreeNodeComplex_vue___default.a,
        objectTreeNodePrimitive: __WEBPACK_IMPORTED_MODULE_2__ObjectTreeNodePrimitive_vue___default.a
    }
});

/***/ }),

/***/ 1247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OpenButton_vue__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OpenButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__OpenButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ObjectTreeNode_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ObjectTreeNode_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ObjectTreeNode_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'objectTreeNodeComplex',
    props: ['type', 'value', 'primary'],
    data: function data() {
        return {
            open: false,
            expanded: this.primary,
            items: this.makeItems()
        };
    },

    beforeCreate: function beforeCreate() {
        this.$options.components.objectTreeNode = __webpack_require__(98);
    },
    methods: {
        makeItems: function makeItems() {
            if (this.type == 'object') {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.value);
            } else if (this.type == 'array') {
                return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(Array(this.value.length).keys()));
            }
        }
    },
    computed: {
        charOpen: function charOpen() {
            if (this.type == 'object') return "{";else return "[";
        },
        charClose: function charClose() {
            if (this.type == 'object') return "}";else return "]";
        }
    },
    watch: {
        primary: function primary(value) {
            this.expanded = value;
            this.open = this.open && value;
        }
    },
    components: {
        openButton: __WEBPACK_IMPORTED_MODULE_2__OpenButton_vue___default.a
    }
});

/***/ }),

/***/ 1248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'objectTreeNodePrimitive',
  props: ['type', 'value']
});

/***/ }),

/***/ 1249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'openButton',
  props: ['html']
});

/***/ }),

/***/ 1250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ObjectTreeNode_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ObjectTreeNode_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ObjectTreeNode_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vueObjectView',
  props: ['value'],
  components: {
    objectTreeNode: __WEBPACK_IMPORTED_MODULE_0__ObjectTreeNode_vue___default.a
  }
});

/***/ }),

/***/ 1251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 1252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_workbench_Workbench__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_workbench_Workbench___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_workbench_Workbench__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_tutorialPicker_TutorialPicker__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_tutorialPicker_TutorialPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_tutorialPicker_TutorialPicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_utils_Logo__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_utils_Logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_utils_Logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_utils_modalMessage_ModalMessage__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_utils_modalMessage_ModalMessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_utils_modalMessage_ModalMessage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_MainBar__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_MainBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_MainBar__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    var self = this;
    return {
      workbenchWrapper: {
        getWorkbench: function getWorkbench() {
          return self.$refs.workbench;
        }
      }
    };
  },

  components: {
    workbench: __WEBPACK_IMPORTED_MODULE_0_components_workbench_Workbench___default.a,
    tutorialPicker: __WEBPACK_IMPORTED_MODULE_1_components_tutorialPicker_TutorialPicker___default.a,
    logo: __WEBPACK_IMPORTED_MODULE_2_components_utils_Logo___default.a,
    modalMessage: __WEBPACK_IMPORTED_MODULE_3_components_utils_modalMessage_ModalMessage___default.a,
    mainBar: __WEBPACK_IMPORTED_MODULE_4_components_MainBar___default.a
  }
});

/***/ }),

/***/ 1253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_utils_Logo__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_utils_Logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_utils_Logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_js__ = __webpack_require__(15);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mainBar',
  data: function data() {
    return {
      appRoot: __WEBPACK_IMPORTED_MODULE_1_constants_js__["a" /* default */].APP_ROOT
    };
  },

  components: {
    logo: __WEBPACK_IMPORTED_MODULE_0_components_utils_Logo___default.a
  }
});

/***/ }),

/***/ 1254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_console_consoleProxy_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_object_view__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_object_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_object_view__);






__WEBPACK_IMPORTED_MODULE_2_vue___default.a.filter('consoleTime', function (value) {
    if (value) {
        return value.format('HH:mm:ss');
    }
});



/* harmony default export */ __webpack_exports__["default"] = ({
    name: "console",
    props: ["keys", "slim"],
    data: function data() {
        return {
            logs: []
        };
    },

    methods: {
        log: function log(_log) {
            this.logs.push(_log);

            var $el = this.$refs.logs;
            var scrolledDown = $el.scrollHeight - $el.clientHeight <= $el.scrollTop + 1;
            if (scrolledDown) {
                window.setTimeout(function () {
                    $el.scrollTop = $el.scrollHeight;
                }, 5);
            }
        },
        clear: function clear() {
            this.logs = [];
        }
    },
    components: {
        objectView: __WEBPACK_IMPORTED_MODULE_3_vue_object_view___default.a
    },
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_0_components_console_consoleProxy_js__["a" /* default */].register(this);
    }
});

/***/ }),

/***/ 1255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_MainBar__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_MainBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_MainBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__userDoc_md__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__userDoc_md___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__userDoc_md__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Main',
  data: function data() {
    return {};
  },

  components: {
    mainBar: __WEBPACK_IMPORTED_MODULE_0_components_MainBar___default.a,
    affix: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["affix"],
    markdown: __WEBPACK_IMPORTED_MODULE_2__userDoc_md___default.a
  }
});

/***/ }),

/***/ 1256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_ResourceTemplate__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_ResourceTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utils_ResourceTemplate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_tutorialPicker_schedulerPicker__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_tutorialPicker_schedulerPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_tutorialPicker_schedulerPicker__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'tutorialDetails',
    props: ["name", "helper"],
    data: function data() {
        return {
            json: null,
            template: null,
            componentData: null,
            errorMessage: null
        };
    },
    mounted: function mounted() {
        this.loadDetails();
    },

    components: {
        resourceTemplate: __WEBPACK_IMPORTED_MODULE_0__utils_ResourceTemplate___default.a,
        schedulerPicker: __WEBPACK_IMPORTED_MODULE_1_components_tutorialPicker_schedulerPicker___default.a
    },
    methods: {
        loadDetails: function loadDetails() {
            if (this.name) {
                var self = this;
                this.json = null;
                this.template = null;
                this.componentData = null;
                self.errorMessage = null;
                this.helper.loadTutorialIndex(this.name, function (json) {
                    if (json && json.intro) {
                        self.json = json;
                        self.helper.loadTutorialIntro(self.name, json.intro, function (template, js) {
                            if (js && js.data) {
                                var constrollerConstructor = eval(js.data);
                                self.controller = new constrollerConstructor(self.$refs.content.$el);
                                self.componentData = self.controller.getData;
                            }
                            self.template = template;
                        });
                    } else {
                        self.errorMessage = "Cannot load index file for tutorial " + self.name;
                    }
                });
            }
        },
        getOptions: function getOptions() {
            var options = {};
            if (this.controller && this.controller.getOptions) {
                options = this.controller.getOptions();
            }
            options.schedulerType = this.$refs.schedulerPicker.getScheduler();
            if (!options.schedulerType) {
                options.schedulerType = "roundrobin";
            }
            return options;
        }
    },
    watch: {
        name: function name() {
            this.loadDetails();
        }
    }
});

/***/ }),

/***/ 1257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tutorialPickerHelper__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TutorialDetails__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TutorialDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TutorialDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__packageLoader__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_runtime_session_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ResourceTemplate__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ResourceTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__utils_ResourceTemplate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_console_consoleProxy_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_utils_modalMessage_modalMessageProxy_js__ = __webpack_require__(46);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'tutorialPicker',
    data: function data() {
        return {
            showModal: false,
            tutorials: [],
            selected: null,
            session: null,
            showStartHere: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.helper = new __WEBPACK_IMPORTED_MODULE_0__tutorialPickerHelper__["a" /* default */]();
        window.setTimeout(function () {
            _this.showStartHere = true;
        }, 5000);
    },

    components: {
        tutorialDetails: __WEBPACK_IMPORTED_MODULE_1__TutorialDetails___default.a,
        resourceTemplate: __WEBPACK_IMPORTED_MODULE_4__utils_ResourceTemplate___default.a
    },
    props: ["workbenchWrapper"],
    methods: {
        openModal: function openModal() {
            var self = this;
            this.showModal = true;

            this.helper.loadInstalledTutorials(function (tutorials) {
                self.tutorials = tutorials;
                if (!self.selected) {
                    self.selected = tutorials[0].tutorials[0];
                }
            });
        },
        loadTutorial: function loadTutorial() {
            var options = void 0;
            try {
                options = this.$refs.tutorialDetails.getOptions();
            } catch (e) {
                this.error("Error getting options for tutorial " + this.selected, e);
                return;
            }
            var self = this;
            if (options) {
                this.showModal = false;
                var callback = function callback(tutorial) {
                    var config = void 0;
                    try {
                        config = tutorial.getConfig(options);
                    } catch (e) {
                        self.error("Error getting config for tutorial " + self.selected, e);
                        return;
                    }
                    try {
                        self.session = new __WEBPACK_IMPORTED_MODULE_3_runtime_session_js__["a" /* default */](tutorial, config);
                    } catch (e) {
                        self.error("Error creating session for tutorial " + self.selected, e);
                        return;
                    }
                    self.workbenchWrapper.getWorkbench().setSession(self.session);
                };
                try {
                    __WEBPACK_IMPORTED_MODULE_2__packageLoader__["a" /* default */].load(this.selected, callback);
                } catch (e) {
                    self.error("Error loading tutorial " + self.selected, e);
                    return;
                }
            }
        },
        error: function error(message, exception) {
            console.error(message, exception);
            __WEBPACK_IMPORTED_MODULE_6_components_utils_modalMessage_modalMessageProxy_js__["a" /* default */].errorAlert(message, "Tutorial initialization error");
            __WEBPACK_IMPORTED_MODULE_5_components_console_consoleProxy_js__["a" /* default */].error("System", message);
        }
    },
    watch: {}
});

/***/ }),

/***/ 1258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_runtime_scheduler_types_js__ = __webpack_require__(34);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'schedulerPicker',
    props: ["json"],
    data: function data() {
        return {
            selected: null,
            schedulerType: __WEBPACK_IMPORTED_MODULE_0_runtime_scheduler_types_js__["a" /* default */]
        };
    },
    mounted: function mounted() {
        if (this.json && this.json.schedulers) {
            this.selected = this.json.schedulers[0];
        }
    },

    components: {},
    methods: {
        getScheduler: function getScheduler() {
            return this.selected ? this.selected : __WEBPACK_IMPORTED_MODULE_0_runtime_scheduler_types_js__["a" /* default */].ROUNDROBIN;
        }
    },
    watch: {}
});

/***/ }),

/***/ 1259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'template',
    props: {
        text: {
            type: String,
            default: "Loading..."
        }
    }
});

/***/ }),

/***/ 1260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loading__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'resourceTemplate',
    props: ["resource", "componentData"],
    data: function data() {
        return {
            state: "LOADING",
            errorMessage: "",
            currentView: null
        };
    },
    mounted: function mounted() {
        this.refresh();
    },

    components: {
        loading: __WEBPACK_IMPORTED_MODULE_0__Loading___default.a
    },
    methods: {
        refresh: function refresh() {
            if (this.resource) {
                if (this.resource.data && this.resource.data.children) {
                    try {
                        var html = new XMLSerializer().serializeToString(this.resource.data.children[0]);

                        this.currentView = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.component("ResourceTemplateCurrentView", {
                            template: html,
                            data: this.componentData
                        });

                        this.state = "OK";
                    } catch (e) {
                        this.state = "ERROR";
                        this.errorMessage = "Error deserializing template: " + e;
                    }
                } else {
                    this.state = "ERROR";
                    this.errorMessage = this.resource.error ? this.resource.error : "Unknown error";
                }
            } else {
                this.state = "LOADING";
            }
        }
    },
    watch: {
        resource: function resource() {
            this.refresh();
        }
    }
});

/***/ }),

/***/ 1261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_split_js__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_split_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: "splitter",
    props: ["fullheight", "options"],
    data: function data() {
        return {};
    },

    methods: {},
    components: {},
    mounted: function mounted() {
        var $elements = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$children), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var child = _step.value;

                $elements.push(child.$el);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        __WEBPACK_IMPORTED_MODULE_1_split_js___default()($elements, this.options);

        if (this.fullheight) {
            var fixHeight = function fixHeight() {
                console.log(self, $(self.$el).offset());
                $(self.$el).height($(window).height() - $(self.$el).offset().top);
            };

            var self = this;

            $(window).resize(fixHeight);
            window.setTimeout(fixHeight, 10);
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8)))

/***/ }),

/***/ 1262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_utils_modalMessage_modalMessageProxy_js__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: "schedulerPanel",
    props: ["scheduler"],
    data: function data() {
        return {
            show: false,
            title: "",
            body: "",
            type: {},

            alertShow: false,
            alertTitle: null,
            alertText: null,
            alertType: {}
        };
    },
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_0_components_utils_modalMessage_modalMessageProxy_js__["a" /* default */].component = this;
    },

    methods: {},
    watch: {},
    components: {},
    computed: {}
});

/***/ }),

/***/ 1263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "iconBtn",
    props: ["icon", "tooltip", "type"],
    data: function data() {
        return {};
    },
    mounted: function mounted() {
        $(this.$refs.btn).tooltip();
    },

    methods: {
        click: function (_click) {
            function click() {
                return _click.apply(this, arguments);
            }

            click.toString = function () {
                return _click.toString();
            };

            return click;
        }(function () {
            this.$emit('click', click);
        })
    },
    components: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8)))

/***/ }),

/***/ 1264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    disabled: { type: Boolean, default: false },
    header: { type: String },
    leftIcon: { type: String },
    rightIcon: { type: String }
  },
  data: function data() {
    return {
      fadein: false
    };
  },

  computed: {
    active: function active() {
      var _this = this;

      var active = !this._tabs || this._tabs.show === this;
      this.fadein = false;
      if (active) {
        setTimeout(function () {
          _this.fadein = true;
        }, 0);
      }
      return active;
    },
    index: function index() {
      return this._tabs.tabs.indexOf(this);
    },
    transition: function transition() {
      return this._tabs ? this._tabs.effect : null;
    }
  },
  created: function created() {
    this._isTab = true;
    var tabs = this;
    while (!this._tabs && tabs.$parent) {
      if (tabs._isTabGroup) {
        tabs.tabs.push(this);
        this._tabGroup = tabs;
      }
      if (tabs._isTabs) {
        tabs.tabs.push(this);
        this._tabs = tabs;
        if (!this._tabGroup) tabs.headers.push(this);
      }
      tabs = tabs.$parent;
    }
    if (!this._tabs) throw Error('tab depend on tabs.');
  },
  beforeDestroy: function beforeDestroy() {
    var _this2 = this;

    if (this._tabGroup) {
      this._tabGroup.tabs = this._tabGroup.tabs.filter(function (el) {
        return el !== _this2;
      });
      this._tabGroup.headers = this._tabGroup.headers.filter(function (el) {
        return el !== _this2;
      });
    }
    if (this._tabs) {
      this._tabs.tabs = this._tabs.tabs.filter(function (el) {
        return el !== _this2;
      });
      this._tabs.headers = this._tabs.headers.filter(function (el) {
        return el !== _this2;
      });
    }
    if (this._tabs) {
      if (this._tabs.active === this.index) {
        this._tabs.index = 0;
      }
      if (this._ingroup) {
        var id = this.$parent.tabs.indexOf(this);
        if (~id) {
          this.$parent.tabs.splice(id, 1);
          this.$parent.headers.splice(id, 1);
        }
      }
    }
    if (this._tabs) {
      var _id = this._tabs.tabs.indexOf(this);
      if (~_id) {
        this._tabs.tabs.splice(_id, 1);
        this._tabs.headers.splice(_id, 1);
      }
    }
  }
});

/***/ }),

/***/ 1265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_strap_src_utils_utils_js__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    dropdown: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["dropdown"]
  },
  props: {
    justified: false,
    navStyle: { type: String, default: null },
    value: { type: Number, default: 0 }
  },
  data: function data() {
    var index = this.value || 0;
    return {
      index: index,
      headers: [],
      tabs: []
    };
  },

  watch: {
    index: function index(val) {
      this.$emit('active', val);
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  computed: {
    navStyleClass: function navStyleClass() {
      return ['nav', ~['pills', 'stacked'].indexOf(this.navStyle) ? 'nav-' + this.navStyle : 'nav-tabs', {
        'nav-justified': __WEBPACK_IMPORTED_MODULE_0_vue_strap_src_utils_utils_js__["a" /* coerce */].boolean(this.justified),
        'nav-pills': this.navStyle === 'stacked'
      }];
    },
    show: function show() {
      return this.tabs[this.index] || this.tabs[0];
    }
  },
  methods: {
    select: function select(tab) {
      if (!tab.disabled) {
        this.index = this.tabs.indexOf(tab);
      }
    },
    trim: function trim(n) {
      this.index = 0;
      this.headers.length = 1;
      this.tabs.length = 1;
    }
  },
  created: function created() {
    this._isTabs = true;
  }
});

/***/ }),

/***/ 1266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_workbench_editor_Codearea__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_workbench_editor_Codearea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_workbench_editor_Codearea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_utils_vuestrap_IconTabs__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_utils_vuestrap_IconTabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_utils_vuestrap_IconTabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_utils_vuestrap_IconTab__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_utils_vuestrap_IconTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_utils_vuestrap_IconTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_console_Console__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_console_Console___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_console_Console__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: "editorTabs",
    data: function data() {
        return {
            activeTab: 0,
            session: null
        };
    },
    mounted: function mounted() {},

    methods: {
        setSession: function setSession(session) {
            this.session = session;
            this.activateAgentTab(0);
        },
        activateTab: function activateTab(tabIndex) {
            this.activeTab = tabIndex;
        },
        activateAgentTab: function activateAgentTab(agentIndex) {
            this.activateTab(agentIndex + 1);
        }
    },
    components: {
        codearea: __WEBPACK_IMPORTED_MODULE_0_components_workbench_editor_Codearea___default.a,
        iconTabs: __WEBPACK_IMPORTED_MODULE_1_components_utils_vuestrap_IconTabs___default.a,
        iconTab: __WEBPACK_IMPORTED_MODULE_2_components_utils_vuestrap_IconTab___default.a,
        console: __WEBPACK_IMPORTED_MODULE_3_components_console_Console___default.a
    }
});

/***/ }),

/***/ 1267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "welcome",
    data: function data() {
        return {};
    },

    methods: {},
    mounted: function mounted() {},

    components: {}
});

/***/ }),

/***/ 1268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_workbench_EditorTabs__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_workbench_EditorTabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_workbench_EditorTabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_workbench_simulator_Simulator__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_workbench_simulator_Simulator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_workbench_simulator_Simulator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_runtime_session_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_utils_Splitter__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_utils_Splitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_utils_Splitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_workbench_Welcome__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_workbench_Welcome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_workbench_Welcome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_console_consoleProxy_js__ = __webpack_require__(19);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: "workbench",
    data: function data() {
        return {
            session: null,
            splitterOptions: {
                direction: "vertical",
                sizes: [50, 50]
            }
        };
    },

    methods: {
        setSession: function setSession(session) {
            if (this.session) {
                this.session.destroy();
            }
            this.session = session;
            this.$refs.tabs.setSession(session);
        }
    },
    mounted: function mounted() {
        if (!this.session) {
            __WEBPACK_IMPORTED_MODULE_5_components_console_consoleProxy_js__["a" /* default */].info("System", "Welcome to Parapple!");
            __WEBPACK_IMPORTED_MODULE_5_components_console_consoleProxy_js__["a" /* default */].debug("System", "This is the main console where you'll see system logs as well as logs from all agents.");
        }
    },

    components: {
        editorTabs: __WEBPACK_IMPORTED_MODULE_0_components_workbench_EditorTabs___default.a,
        simulator: __WEBPACK_IMPORTED_MODULE_1_components_workbench_simulator_Simulator___default.a,
        splitter: __WEBPACK_IMPORTED_MODULE_3_components_utils_Splitter___default.a,
        welcome: __WEBPACK_IMPORTED_MODULE_4_components_workbench_Welcome___default.a
    }
});

/***/ }),

/***/ 1269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_ace_editor__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_ace_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_ace_editor__);




var Range = ace.acequire('ace/range').Range;

var ACE_LANG = "javascript";
var ACE_THEME = "monokai";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'aceEditor',
  props: {
    initialSource: {
      type: String,
      default: ""
    },
    height: {
      default: "100px",
      type: String
    },
    width: {
      default: "100%",
      type: String
    },
    style: {
      default: "",
      type: String
    },
    breakpoints: {
      default: true,
      type: Boolean
    }
  },
  data: function data() {
    return {
      theme: ACE_THEME,
      language: ACE_LANG,
      source: ""
    };
  },

  components: {
    vueAceEditor: __WEBPACK_IMPORTED_MODULE_1_vue2_ace_editor___default.a
  },
  methods: {
    editorInit: function editorInit(editor) {
      var self = this;
      this.editor = editor;

      console.log(this.language);
      __webpack_require__(1312)("./" + ACE_LANG);
      __webpack_require__(1313)("./" + ACE_THEME);

      this.editor.getSession().setUseWorker(false);

      if (this.initialSource) {
        this.setSource(this.initialSource);
      }

      if (this.breakpoints) {
        editor.on("guttermousedown", function (e) {
          var target = e.domEvent.target;
          if (target.className.indexOf("ace_gutter-cell") == -1) return;
          if (e.clientX > 40 + target.getBoundingClientRect().left) return;

          var row = e.getDocumentPosition().row;

          self.$emit('gutterClick', row);
          e.stop();
          return false;
        });
      }
    },
    change: function change(content) {
      this.$emit('change', content);
    },
    makeRange: function makeRange(sourceLocation) {
      return new Range(sourceLocation.startLine - 1, sourceLocation.startColumn, sourceLocation.endLine - 1, sourceLocation.endColumn);
    },
    getSource: function getSource() {
      return this.source;
    },
    setSource: function setSource(source) {
      this.source = source;
    },
    goToLine: function goToLine(line) {
      this.editor.gotoLine(line);
    },
    goToLocation: function goToLocation(location) {
      this.goToLine(location.startLine - 1);
    },
    markInstruction: function markInstruction(location) {
      var range = this.makeRange(location);
      this.instructionRangeMarkerId = this.editor.session.addMarker(range, "highlight-instruction-range", "text");
      this.instructionLineMarkerId = this.editor.session.addMarker(range, "highlight-instruction-line", "fullLine");
      this.goToLocation(location);
    },
    unmarkInstruction: function unmarkInstruction() {
      this.editor.session.removeMarker(this.instructionRangeMarkerId);
      this.editor.session.removeMarker(this.instructionLineMarkerId);
    },
    removeMarkers: function removeMarkers() {
      this.unsetError();
      this.unmarkInstruction();

      if (this.markers && this.markers.length) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.markers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var markerId = _step.value;

            this.editor.session.removeMarker(markerId);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        this.markers = [];
      }
    },
    unsetError: function unsetError() {
      if (this.errorRangeMarkerId) {
        this.editor.session.removeMarker(this.errorRangeMarkerId);
      }
      if (this.errorLineMarkerId) {
        this.editor.session.removeMarker(this.errorLineMarkerId);
      }
    },
    setError: function setError(codeError) {
      this.unsetError();
      if (codeError.location) {
        var range = this.makeRange(codeError.location);
        this.errorRangeMarkerId = this.editor.session.addMarker(range, "highlight-error-range", "text");
        this.errorLineMarkerId = this.editor.session.addMarker(range, "highlight-error-line", "fullLine");
        this.goToLocation(codeError.location);
      }
    },
    setBreakpoint: function setBreakpoint(row) {
      this.editor.session.setBreakpoint(row);
    },
    clearBreakpoint: function clearBreakpoint(row) {
      this.editor.session.clearBreakpoint(row);
    },
    removeBreakpoints: function removeBreakpoints() {
      for (var row = 0; row < this.editor.session.doc.getAllLines().length; row++) {
        this.clearBreakpoint(row);
      }
    }
  }
});

/***/ }),

/***/ 1270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_workbench_editor_AceEditor__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_workbench_editor_AceEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_workbench_editor_AceEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ResourceTemplate__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ResourceTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utils_ResourceTemplate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_console_Console__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_console_Console___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_console_Console__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_object_view__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_object_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_object_view__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'codearea',
  data: function data() {
    return {
      selectedInstruction: null,

      activeAgent: null,

      rightPanel: null
    };
  },

  props: ["agentType"],
  components: {
    aceEditor: __WEBPACK_IMPORTED_MODULE_0_components_workbench_editor_AceEditor___default.a,
    resourceTemplate: __WEBPACK_IMPORTED_MODULE_1__utils_ResourceTemplate___default.a,
    console: __WEBPACK_IMPORTED_MODULE_2_components_console_Console___default.a,
    objectView: __WEBPACK_IMPORTED_MODULE_3_vue_object_view___default.a
  },
  mounted: function mounted() {
    this.init();
  },

  watch: {
    agentType: function agentType() {
      this.init();
    }
  },
  methods: {
    init: function init() {
      this.lowlightAgent();
      this.$refs.aceEditor.removeMarkers();
      this.$refs.aceEditor.removeBreakpoints();
      this.agentType.setCodearea(this);
      this.agentType.stateNotCompiled();
    },
    getSource: function getSource() {
      return this.$refs.aceEditor.getSource();
    },
    setError: function setError(e) {
      this.$refs.aceEditor.setError(e);
    },
    compile: function compile() {
      this.agentType.compile();
    },
    editorChange: function editorChange(content) {
      this.agentType.stateNotCompiled();
      this.agentType.removeBreakpoints();
      this.unselectInstruction();
      this.showInstructions = false;
      this.$refs.aceEditor.removeMarkers();
    },
    toggleBreakpoint: function toggleBreakpoint(row) {
      this.agentType.toggleBreakpoint(row);
    },
    selectInstruction: function selectInstruction(instruction) {
      this.unselectInstruction();
      if (instruction.location) {
        this.$refs.aceEditor.markInstruction(instruction.location);
        this.selectedInstruction = instruction;
      }
    },
    unselectInstruction: function unselectInstruction() {
      this.selectedInstruction = null;
      this.$refs.aceEditor.unmarkInstruction();
    },
    focus: function focus() {
      this.$emit('focus');
    },
    highlightAgent: function highlightAgent(agent, instruction) {
      this.selectInstruction(instruction);
      this.activeAgent = agent;
      this.focus();
    },
    lowlightAgent: function lowlightAgent() {
      this.unselectInstruction();
      this.activeAgent = null;
    },
    agentNameClick: function agentNameClick(agentName) {
      var agent = this.agentType.agents[agentName];
      if (agent) {
        agent.highlight();
      }
    },
    toggleRightPanel: function toggleRightPanel(panel) {
      if (this.rightPanel == panel) {
        this.rightPanel = null;
      } else {
        this.rightPanel = panel;
      }
    }
  }
});

/***/ }),

/***/ 1271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_console_consoleProxy_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_workbench_simulator_schedulerPanel_SchedulerPanel__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_workbench_simulator_schedulerPanel_SchedulerPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_workbench_simulator_schedulerPanel_SchedulerPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_workbench_simulator_schedulerPanel_SchedulerShortcut__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_workbench_simulator_schedulerPanel_SchedulerShortcut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_workbench_simulator_schedulerPanel_SchedulerShortcut__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: "simulator",
    props: ["session"],
    data: function data() {
        return {
            scheduler: null,
            speedValue: "1x",
            speedData: ["1/8x", "1/4x", "1/2x", "1x", "2x", "4x", "8x", "Max"]
        };
    },
    mounted: function mounted() {
        this.session.initialize();
        this.session.setSpeed(this.speedValue);
    },

    methods: {
        setupAndRun: function setupAndRun() {
            if (this.session.setup()) {
                this.run();
            }
        },
        setup: function setup() {
            this.session.setup();
        },
        run: function run() {
            if (this.session.scheduler.isDone()) {
                this.session.reset();
            }
            this.session.scheduler.run();
        },
        step: function step() {
            this.session.scheduler.debugStep();
        },
        tick: function tick() {
            this.session.scheduler.debugTick();
        },
        pause: function pause() {
            this.session.scheduler.pause();
        },
        reset: function reset() {
            this.session.reset();
        },
        setSpeed: function setSpeed(value) {
            this.session.setSpeed(value);
        }
    },
    watch: {
        session: function session() {
            this.session.initialize();
            this.session.setSpeed(this.speedValue);
        }
    },
    components: {
        vueSlider: __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default.a,
        schedulerPanel: __WEBPACK_IMPORTED_MODULE_2_components_workbench_simulator_schedulerPanel_SchedulerPanel___default.a,
        schedulerShortcut: __WEBPACK_IMPORTED_MODULE_3_components_workbench_simulator_schedulerPanel_SchedulerShortcut___default.a
    },
    computed: {
        statusClass: function statusClass() {
            return this.session.scheduler ? "alert-" + this.session.scheduler.state.cssClass : "";
        }
    }
});

/***/ }),

/***/ 1272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "executor",
    props: ["executor", "next", "last"],
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    methods: {
        highlight: function highlight() {
            this.executor.highlight();
        }
    },
    watch: {},
    components: {},
    computed: {
        cssClass: function cssClass() {
            if (this.executor.error) {
                return "executor-error";
            } else if (this.executor.done) {
                return "executor-done";
            } else if (this.next) {
                return "executor-next";
            } else if (this.last) {
                return "executor-last";
            }
        }
    }
});

/***/ }),

/***/ 1273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_workbench_simulator_schedulerPanel_Executor__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_workbench_simulator_schedulerPanel_Executor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_workbench_simulator_schedulerPanel_Executor__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: "schedulerPanel",
    props: ["scheduler"],
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    methods: {
        hide: function hide() {
            this.scheduler.session.showScheduler = false;
        }
    },
    watch: {},
    components: {
        executor: __WEBPACK_IMPORTED_MODULE_0_components_workbench_simulator_schedulerPanel_Executor___default.a
    },
    computed: {}
});

/***/ }),

/***/ 1274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "schedulerShortcut",
    props: ["session"],
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    methods: {
        show: function show() {
            this.session.showScheduler = true;
        }
    },
    watch: {},
    components: {},
    computed: {}
});

/***/ }),

/***/ 1275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_resource_loader__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_resource_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_resource_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_console_consoleProxy_js__ = __webpack_require__(19);









var PackageLoader = function () {
    function PackageLoader() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PackageLoader);

        this.cache = {};
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(PackageLoader, [{
        key: 'load',
        value: function load(tutorialName, callback) {
            __WEBPACK_IMPORTED_MODULE_6_components_console_consoleProxy_js__["a" /* default */].debug("System", "Loading tutorial " + tutorialName + "...");
            this.remaining = 0;
            this.root = tutorialName;
            this.callback = callback;

            var cachedTutorial = this.loadMetadata(this.root);

            if (cachedTutorial) {
                if (!cachedTutorial.instance) {
                    this.prepareDependencies();
                } else {
                    this.finished();
                }
            }
        }
    }, {
        key: 'getBaseDir',
        value: function getBaseDir(packageName) {
            if (packageName == this.root) {
                return __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* default */].TUTORIALS_PATH;
            }
            return __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* default */].PACKAGES_PATH;
        }
    }, {
        key: 'loadMetadata',
        value: function loadMetadata(packageName) {
            var _this = this;

            if (this.cache[packageName]) {
                __WEBPACK_IMPORTED_MODULE_6_components_console_consoleProxy_js__["a" /* default */].debug("System", " Ignoring " + packageName + " (already loaded/loading in progress)");
                return this.cache[packageName];
            }
            this.cache[packageName] = { name: packageName };
            this.remaining++;
            __WEBPACK_IMPORTED_MODULE_6_components_console_consoleProxy_js__["a" /* default */].debug("System", " Loading package " + packageName + "...");
            var loader = new __WEBPACK_IMPORTED_MODULE_4_resource_loader___default.a();

            loader.onError.add(function (e) {
                console.error(e);
                __WEBPACK_IMPORTED_MODULE_6_components_console_consoleProxy_js__["a" /* default */].error("System", "Error loading index.json for " + packageName + ": " + e.message);
            });

            loader.add("index", this.getBaseDir(packageName) + packageName + "/index.json").load(function (loader, resources) {
                if (resources.index) {
                    var json = resources.index.data;
                    _this.cache[packageName].json = json;
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(json.dependencies), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var d = _step.value;

                            _this.loadMetadata(d);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this.remaining--;
                    if (_this.remaining <= 0) {
                        _this.prepareDependencies();
                    }
                }
            });
        }
    }, {
        key: 'prepareDependencies',
        value: function prepareDependencies() {

            var self = this;

            function visit(nodeName, operation) {
                var node = self.cache[nodeName];
                operation(node);
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(node.json.dependencies), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var d = _step2.value;

                        visit(d, operation);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }

            visit(this.root, function (node) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(node.json.dependencies), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var d = _step3.value;

                        var child = self.cache[d];
                        if (!child.incoming) {
                            child.incoming = {};
                        }

                        child.incoming[node.name] = true;
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            });

            this.topologicalSort = [];

            var nodesToProcess = [this.root];

            while (nodesToProcess.length > 0) {
                var currentNode = this.cache[nodesToProcess.pop()];
                var json = currentNode.json;

                this.topologicalSort.push(currentNode.name);

                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(json.dependencies), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var d = _step4.value;

                        var child = this.cache[d];
                        delete child.incoming[currentNode.name];
                        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(child.incoming).length <= 0) {
                            nodesToProcess.push(child.name);
                        }
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            }

            this.loadResources();
        }
    }, {
        key: 'loadResources',
        value: function loadResources() {
            var _this2 = this;

            var loader = new __WEBPACK_IMPORTED_MODULE_4_resource_loader___default.a();
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.topologicalSort), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var n = _step5.value;

                    var node = this.cache[n];

                    if (!node.resources) {
                        var json = node.json;

                        loader.add(node.name + "%MAIN", this.getBaseDir(node.name) + node.name + "/" + json.main);

                        if (json.resources) {
                            var _iteratorNormalCompletion7 = true;
                            var _didIteratorError7 = false;
                            var _iteratorError7 = undefined;

                            try {
                                for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(json.resources), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                                    var resource = _step7.value;

                                    loader.add(node.name + "%" + resource, this.getBaseDir(node.name) + node.name + "/" + resource);
                                }
                            } catch (err) {
                                _didIteratorError7 = true;
                                _iteratorError7 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                        _iterator7.return();
                                    }
                                } finally {
                                    if (_didIteratorError7) {
                                        throw _iteratorError7;
                                    }
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            loader.onError.add(function (e) {
                console.error(e);
                __WEBPACK_IMPORTED_MODULE_6_components_console_consoleProxy_js__["a" /* default */].error("System", "Error loading resource: " + e.message);
            });

            loader.load(function (loader, resources) {
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                    for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(resources)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                        var rId = _step6.value;

                        var resource = resources[rId];
                        var parts = rId.split("%");
                        var packageName = parts[0];
                        var resourceName = parts[1];
                        if (resource.error) {
                            __WEBPACK_IMPORTED_MODULE_6_components_console_consoleProxy_js__["a" /* default */].error("System", "Error loading resource " + resourceName + " for package " + packageName + ": " + resource.error);
                        }
                        var node = _this2.cache[packageName];
                        if (resourceName == "MAIN") {
                            node.main = resource;
                        } else {
                            if (!node.resources) {
                                node.resources = {};
                            }
                            node.resources[resourceName] = resource;
                        }
                    }
                } catch (err) {
                    _didIteratorError6 = true;
                    _iteratorError6 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion6 && _iterator6.return) {
                            _iterator6.return();
                        }
                    } finally {
                        if (_didIteratorError6) {
                            throw _iteratorError6;
                        }
                    }
                }

                _this2.instantiate();
            });
        }
    }, {
        key: 'instantiate',
        value: function instantiate() {
            for (var i = this.topologicalSort.length - 1; i >= 0; i--) {
                var node = this.cache[this.topologicalSort[i]];
                if (!node.instance) {
                    this.instantiatePackage(node);
                }
            }

            this.finished();
        }
    }, {
        key: 'instantiatePackage',
        value: function instantiatePackage(node) {
            __WEBPACK_IMPORTED_MODULE_6_components_console_consoleProxy_js__["a" /* default */].debug("System", " Instantiating package " + node.name);

            try {
                node.packageConstructor = eval(node.main.data);
            } catch (e) {
                console.error(e);
                __WEBPACK_IMPORTED_MODULE_6_components_console_consoleProxy_js__["a" /* default */].error("System", "Error evaluating source for package " + node.name + ": " + e);
            }

            var dependencies = {};
            var _iteratorNormalCompletion8 = true;
            var _didIteratorError8 = false;
            var _iteratorError8 = undefined;

            try {
                for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(node.json.dependencies), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                    var d = _step8.value;

                    dependencies[d] = this.cache[d].instance;
                }
            } catch (err) {
                _didIteratorError8 = true;
                _iteratorError8 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion8 && _iterator8.return) {
                        _iterator8.return();
                    }
                } finally {
                    if (_didIteratorError8) {
                        throw _iteratorError8;
                    }
                }
            }

            try {
                node.instance = new node.packageConstructor(dependencies, node.resources);
            } catch (e) {
                console.error(e);
                __WEBPACK_IMPORTED_MODULE_6_components_console_consoleProxy_js__["a" /* default */].error("System", "Error instantiating package " + node.name + ": " + e);
            }

            node.instance.definition = node.json;
            node.instance.resources = node.resources;
            var _iteratorNormalCompletion9 = true;
            var _didIteratorError9 = false;
            var _iteratorError9 = undefined;

            try {
                for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(node.json.dependencies), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                    var _d = _step9.value;

                    node.instance[_d] = this.cache[_d].instance;
                }
            } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion9 && _iterator9.return) {
                        _iterator9.return();
                    }
                } finally {
                    if (_didIteratorError9) {
                        throw _iteratorError9;
                    }
                }
            }

            if (node.json.modules) {
                var _iteratorNormalCompletion10 = true;
                var _didIteratorError10 = false;
                var _iteratorError10 = undefined;

                try {
                    for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(node.json.modules), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                        var m = _step10.value;

                        try {
                            var moduleConstructor = eval(node.resources[m + ".js"].data);
                            node.instance[m] = new moduleConstructor(node.instance);
                        } catch (e) {
                            console.error(e);
                            __WEBPACK_IMPORTED_MODULE_6_components_console_consoleProxy_js__["a" /* default */].error("System", "Error instantiating module " + m + " for package " + node.name + ": " + e);
                        }
                    }
                } catch (err) {
                    _didIteratorError10 = true;
                    _iteratorError10 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion10 && _iterator10.return) {
                            _iterator10.return();
                        }
                    } finally {
                        if (_didIteratorError10) {
                            throw _iteratorError10;
                        }
                    }
                }
            }
        }
    }, {
        key: 'finished',
        value: function finished() {
            if (this.callback) {
                this.callback(this.cache[this.root].instance);
            }
        }
    }]);

    return PackageLoader;
}();

var packageLoader = new PackageLoader();
/* harmony default export */ __webpack_exports__["a"] = (packageLoader);

/***/ }),

/***/ 1276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_resource_loader__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_resource_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_resource_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(15);





var TutorialPickerHelper = function () {
    function TutorialPickerHelper() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TutorialPickerHelper);

        this.cache = {};
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(TutorialPickerHelper, [{
        key: 'loadInstalledTutorials',
        value: function loadInstalledTutorials(callback) {
            var loader = new __WEBPACK_IMPORTED_MODULE_2_resource_loader___default.a();
            loader.add("index", __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].TUTORIALS_PATH + "index.json").load(function (loader, resources) {
                if (resources.index) {
                    callback(resources.index.data);
                }
            });
        }
    }, {
        key: 'loadTutorialIndex',
        value: function loadTutorialIndex(tutorial, callback) {
            var loader = new __WEBPACK_IMPORTED_MODULE_2_resource_loader___default.a();
            loader.add("index", __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].TUTORIALS_PATH + tutorial + "/index.json").load(function (loader, resources) {
                if (resources.index) {
                    callback(resources.index.data);
                }
            });
        }
    }, {
        key: 'loadTutorialIntro',
        value: function loadTutorialIntro(tutorial, intro, callback) {
            var loader = new __WEBPACK_IMPORTED_MODULE_2_resource_loader___default.a();
            if (intro.template) {
                loader.add("template", __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].TUTORIALS_PATH + tutorial + "/" + intro.template);
            }
            if (intro.js) {
                loader.add("js", __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].TUTORIALS_PATH + tutorial + "/" + intro.js);
            }
            loader.load(function (loader, resources) {
                callback(resources.template, resources.js);
            });
        }
    }]);

    return TutorialPickerHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (TutorialPickerHelper);

/***/ }),

/***/ 1277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_global_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_parascript_ast_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_utils_vuestrap_IconBtn__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_utils_vuestrap_IconBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_utils_vuestrap_IconBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon_vue__);








__WEBPACK_IMPORTED_MODULE_3_utils_global_js__["a" /* default */].publish(__WEBPACK_IMPORTED_MODULE_4_parascript_ast_js__, "ast");

__webpack_require__(453);

window.$ = __webpack_require__(8);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('alert', __WEBPACK_IMPORTED_MODULE_5_vue_strap__["alert"]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('modal', __WEBPACK_IMPORTED_MODULE_5_vue_strap__["modal"]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('radio', __WEBPACK_IMPORTED_MODULE_5_vue_strap__["radio"]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('tab', __WEBPACK_IMPORTED_MODULE_5_vue_strap__["tab"]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('tabs', __WEBPACK_IMPORTED_MODULE_5_vue_strap__["tabs"]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('tooltip', __WEBPACK_IMPORTED_MODULE_5_vue_strap__["tooltip"]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('checkbox', __WEBPACK_IMPORTED_MODULE_5_vue_strap__["checkbox"]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('iconBtn', __WEBPACK_IMPORTED_MODULE_6_components_utils_vuestrap_IconBtn___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('vSelect', __WEBPACK_IMPORTED_MODULE_5_vue_strap__["select"]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('vOption', __WEBPACK_IMPORTED_MODULE_5_vue_strap__["option"]);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('icon', __WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon_vue___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__webpack_require__(456));

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 1278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_errors_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_runtime_instructions_js__ = __webpack_require__(106);





var IdentifierTable = function () {
  function IdentifierTable(packageFunctions, packageConstants) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, IdentifierTable);

    this.functions = {};

    this.packageFunctions = packageFunctions;

    this.packageConstants = packageConstants;

    this.currentScope = {
      identifiers: {},

      parentScope: null
    };
    this.globalScope = this.currentScope;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(IdentifierTable, [{
    key: 'declareFunction',
    value: function declareFunction(name, location, argCount) {
      this.checkIdentifierAvailable(name, location);
      this.functions[name] = {
        address: -1,
        argCount: argCount
      };
    }
  }, {
    key: 'setFunctionAddress',
    value: function setFunctionAddress(name, address, location) {
      if (!this.isFunctionDeclared(name)) {
        throw new __WEBPACK_IMPORTED_MODULE_2_common_errors_js__["b" /* CodeError */]("Cannot set function address for undeclared function '" + name + "'", location);
      }
      this.functions[name].address = address;
    }
  }, {
    key: 'createFunctionCallInstruction',
    value: function createFunctionCallInstruction(name, location, argCount) {
      if (this.isFunctionDeclared(name)) {
        var expectedArgCount = this.functions[name].argCount;

        this.checkArgCount(expectedArgCount, argCount, name, location);
        return new __WEBPACK_IMPORTED_MODULE_3_runtime_instructions_js__["r" /* FunctionCallInstruction */](location, name, argCount);
      } else if (this.isPackageFunctionDeclared(name)) {
        var _f = this.packageFunctions[name];

        this.checkArgCount(_f.length - 1, argCount, name, location);
        return new __WEBPACK_IMPORTED_MODULE_3_runtime_instructions_js__["s" /* PackageFunctionCallInstruction */](location, name, argCount, _f);
      }

      throw new __WEBPACK_IMPORTED_MODULE_2_common_errors_js__["b" /* CodeError */]("Undeclared function '" + name + "'", location);
    }
  }, {
    key: 'checkArgCount',
    value: function checkArgCount(expectedArgCount, argCount, name, location) {
      if (argCount > expectedArgCount) {
        throw new __WEBPACK_IMPORTED_MODULE_2_common_errors_js__["b" /* CodeError */]("Too many arguments passed to function '" + name + "' (expected " + expectedArgCount + ")", location);
      }
      if (argCount < expectedArgCount) {
        throw new __WEBPACK_IMPORTED_MODULE_2_common_errors_js__["b" /* CodeError */]("Too few arguments passed to function '" + name + "' (expected " + expectedArgCount + ")", location);
      }
    }
  }, {
    key: 'fixFunctionCallInstruction',
    value: function fixFunctionCallInstruction(instruction) {
      var address = this.functions[instruction.params.name].address;
      if (address < 0) {
        throw new __WEBPACK_IMPORTED_MODULE_2_common_errors_js__["b" /* CodeError */]("Cannot fix function call instruction, function address unknown: '" + instruction.params.name + "'", instruction.location);
      }
      instruction.setAddress(address);
    }
  }, {
    key: 'isFunctionDeclared',
    value: function isFunctionDeclared(name) {
      return this.functions.hasOwnProperty(name);
    }
  }, {
    key: 'isPackageFunctionDeclared',
    value: function isPackageFunctionDeclared(name) {
      return this.packageFunctions.hasOwnProperty(name);
    }
  }, {
    key: 'isPackageConstantDeclared',
    value: function isPackageConstantDeclared(name) {
      return this.packageConstants.hasOwnProperty(name);
    }
  }, {
    key: 'getPackageConstant',
    value: function getPackageConstant(name) {
      return this.packageConstants[name];
    }
  }, {
    key: 'declareIdentifier',
    value: function declareIdentifier(name, location) {
      this.checkIdentifierAvailable(name, location);

      this.currentScope.identifiers[name] = true;
    }
  }, {
    key: 'isIdentifierDeclared',
    value: function isIdentifierDeclared(name) {
      var scope = this.currentScope;
      while (scope) {
        if (scope.identifiers.hasOwnProperty(name)) {
          return true;
        }

        scope = scope.parentScope;
      }
      return false;
    }
  }, {
    key: 'checkIdentifierOrConstantDeclared',
    value: function checkIdentifierOrConstantDeclared(name, location) {
      if (!this.isIdentifierDeclared(name) && !this.isPackageConstantDeclared(name)) {
        throw new __WEBPACK_IMPORTED_MODULE_2_common_errors_js__["b" /* CodeError */]("Undeclared identifier '" + name + "'", location);
      }
    }
  }, {
    key: 'checkIdentifierAssignable',
    value: function checkIdentifierAssignable(name, location) {
      this.checkIdentifierOrConstantDeclared(name, location);
      if (this.isPackageConstantDeclared(name)) {
        throw new __WEBPACK_IMPORTED_MODULE_2_common_errors_js__["b" /* CodeError */]("Cannot assign package constant '" + name + "'", location);
      }
    }
  }, {
    key: 'checkIdentifierAvailable',
    value: function checkIdentifierAvailable(name, location) {
      if (this.isIdentifierDeclared(name)) {
        throw new __WEBPACK_IMPORTED_MODULE_2_common_errors_js__["b" /* CodeError */]("Redeclared identifier '" + name + "'", location);
      }
      if (this.isFunctionDeclared(name)) {
        throw new __WEBPACK_IMPORTED_MODULE_2_common_errors_js__["b" /* CodeError */]("Identifier '" + name + "' is already declared as a function", location);
      }
      if (this.isPackageFunctionDeclared(name)) {
        throw new __WEBPACK_IMPORTED_MODULE_2_common_errors_js__["b" /* CodeError */]("Identifier '" + name + "' is already used by a package function", location);
      }
      if (this.isPackageConstantDeclared(name)) {
        throw new __WEBPACK_IMPORTED_MODULE_2_common_errors_js__["b" /* CodeError */]("Identifier '" + name + "' is already used by a package constant", location);
      }
    }
  }, {
    key: 'pushScope',
    value: function pushScope() {
      var newScope = {
        identifiers: {},
        parentScope: this.currentScope
      };
      this.currentScope = newScope;
    }
  }, {
    key: 'popScope',
    value: function popScope() {
      this.currentScope = this.currentScope.parentScope;
    }
  }, {
    key: 'isGlobal',
    value: function isGlobal(identifier) {
      if (!identifier) {
        return this.currentScope.parentScope == null;
      } else {
        return this.globalScope.identifiers.hasOwnProperty(identifier);
      }
    }
  }]);

  return IdentifierTable;
}();

/* harmony default export */ __webpack_exports__["a"] = (IdentifierTable);

/***/ }),

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, module) {/* parser generated by jison 0.4.17 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var parascript = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[5,9,10,11,23,26,29,30,31,32,35,36,39,69,70,80,82,83,85,96,97,98,101],$V1=[1,30],$V2=[1,38],$V3=[1,15],$V4=[1,16],$V5=[1,22],$V6=[1,19],$V7=[1,23],$V8=[1,24],$V9=[1,25],$Va=[1,26],$Vb=[1,27],$Vc=[1,62],$Vd=[1,61],$Ve=[1,63],$Vf=[1,64],$Vg=[1,65],$Vh=[1,49],$Vi=[1,46],$Vj=[1,47],$Vk=[1,48],$Vl=[1,50],$Vm=[5,9,10,11,23,25,26,28,29,30,31,32,35,36,39,69,70,80,82,83,85,96,97,98,101],$Vn=[10,11,23,25,26,29,30,31,32,35,36,39,69,70,80,82,83,85,96,97,98,101],$Vo=[1,76],$Vp=[1,81],$Vq=[13,15,25,30,86],$Vr=[2,98],$Vs=[1,83],$Vt=[1,85],$Vu=[1,86],$Vv=[1,87],$Vw=[1,88],$Vx=[2,77],$Vy=[1,90],$Vz=[1,91],$VA=[1,93],$VB=[13,15,25,30,51,52,54,56,58,60,62,64,66,69,70,73,74,75,86],$VC=[13,15,25,30,51,52,54,86],$VD=[1,96],$VE=[13,15,25,30,51,52,54,56,58,60,62,64,66,69,70,73,74,75,85,86,87],$VF=[13,15,25,30,51,52,54,56,86],$VG=[1,98],$VH=[13,15,25,30,51,52,54,56,58,86],$VI=[1,99],$VJ=[2,39],$VK=[13,15,25,30,51,52,54,56,58,60,86],$VL=[1,102],$VM=[13,15,25,30,51,52,54,56,58,60,62,86],$VN=[1,103],$VO=[13,15,25,30,51,52,54,56,58,60,62,64,86],$VP=[1,104],$VQ=[13,15,25,30,51,52,54,56,58,60,62,64,66,86],$VR=[1,106],$VS=[1,107],$VT=[13,15,25,30,51,52,54,56,58,60,62,64,66,69,70,86],$VU=[1,109],$VV=[1,110],$VW=[1,111],$VX=[1,114],$VY=[10,11,69,70,80,82,83,85,96,97,98,101],$VZ=[15,25],$V_=[1,123],$V$=[15,30],$V01=[13,15],$V11=[10,11,23,69,70,80,82,83,85,96,97,98,101],$V21=[1,143],$V31=[13,15,86],$V41=[1,151],$V51=[13,15,25,30,42,49,51,52,54,56,58,60,62,64,66,69,70,73,74,75,85,86,87];
var parser = {trace: function trace() { },
yy: {},
symbols_: {"error":2,"Program":3,"ProgramElements":4,"EOF":5,"ProgramElement":6,"Statement":7,"FunctionDeclaration":8,"FUNCTION":9,"IDENTIFIER":10,"(":11,"ArgumentList":12,")":13,"Block":14,",":15,"Argument":16,"SelectionStatement":17,"IterationStatement":18,"ExpressionStatement":19,"BreakStatement":20,"ContinueStatement":21,"ReturnStatement":22,"{":23,"StatementList":24,"}":25,"IF":26,"Expression":27,"ELSE":28,"BREAK":29,";":30,"CONTINUE":31,"RETURN":32,"ForStatement":33,"WhileStatement":34,"FOR":35,"WHILE":36,"VarStatement":37,"ExpressionNoMapLiteral":38,"VAR":39,"DeclarationList":40,"Declaration":41,"=":42,"ExpressionList":43,"MapLiteral":44,"AssignmentExpression":45,"TernaryExpression":46,"AssignmentOperator":47,"MemberExpression":48,"ARITHMETIC_ASSIGNMENT_OPERATOR":49,"LogicalOrExpression":50,"?":51,":":52,"LogicalAndExpression":53,"||":54,"BitwiseOrExpression":55,"&&":56,"BitwiseAndExpression":57,"|":58,"BitwiseXorExpression":59,"&":60,"EqualityExpression":61,"^":62,"RelationalExpression":63,"LOGICAL_EQUALITY":64,"AddSubExpression":65,"RELATIONAL_OPERATOR":66,"MulDivExpression":67,"AddSubOperator":68,"+":69,"-":70,"UnaryExpression":71,"MulDivOperator":72,"*":73,"/":74,"%":75,"PostfixExpression":76,"PrefixExpression":77,"PrimaryExpression":78,"UnaryOperator":79,"!":80,"PostfixOperator":81,"++":82,"--":83,"PrefixOperator":84,"[":85,"]":86,".":87,"Literal":88,"Identifier":89,"FunctionCall":90,"BooleanLiteral":91,"NumericLiteral":92,"StringLiteral":93,"ArrayLiteral":94,"NullLiteral":95,"BOOLEAN":96,"NUMERIC_LITERAL":97,"STRING":98,"PropertyList":99,"Property":100,"NULL":101,"$accept":0,"$end":1},
terminals_: {2:"error",5:"EOF",9:"FUNCTION",10:"IDENTIFIER",11:"(",13:")",15:",",23:"{",25:"}",26:"IF",28:"ELSE",29:"BREAK",30:";",31:"CONTINUE",32:"RETURN",35:"FOR",36:"WHILE",39:"VAR",42:"=",49:"ARITHMETIC_ASSIGNMENT_OPERATOR",51:"?",52:":",54:"||",56:"&&",58:"|",60:"&",62:"^",64:"LOGICAL_EQUALITY",66:"RELATIONAL_OPERATOR",69:"+",70:"-",73:"*",74:"/",75:"%",80:"!",82:"++",83:"--",85:"[",86:"]",87:".",96:"BOOLEAN",97:"NUMERIC_LITERAL",98:"STRING",101:"NULL"},
productions_: [0,[3,2],[4,2],[4,0],[6,1],[6,1],[8,6],[12,0],[12,3],[12,1],[16,1],[7,1],[7,1],[7,1],[7,1],[7,1],[7,1],[7,1],[14,3],[17,5],[17,7],[20,2],[21,2],[22,2],[22,3],[18,1],[18,1],[33,8],[34,5],[19,1],[19,1],[19,2],[37,3],[40,1],[40,3],[41,1],[41,3],[24,2],[24,0],[43,0],[43,3],[43,1],[27,1],[27,1],[38,1],[45,1],[45,3],[45,3],[47,1],[47,1],[46,1],[46,5],[50,1],[50,3],[53,1],[53,3],[55,1],[55,3],[57,1],[57,3],[59,1],[59,3],[61,1],[61,3],[63,1],[63,3],[65,1],[65,3],[68,1],[68,1],[67,1],[67,3],[72,1],[72,1],[72,1],[71,1],[71,1],[71,1],[71,1],[71,2],[79,1],[79,1],[79,1],[76,2],[81,1],[81,1],[77,2],[84,1],[84,1],[48,4],[48,4],[48,3],[48,3],[78,1],[78,1],[78,1],[78,3],[90,4],[89,1],[88,1],[88,1],[88,1],[88,1],[88,1],[91,1],[92,1],[93,1],[94,3],[44,3],[99,0],[99,3],[99,1],[100,3],[95,1]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 1:

            // false: ensure this ListASTNode does not enter nested scope (stay in global)
            this.$ = new PARAPPLE.ast.ListASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-1], _$[$0]), $$[$0-1], false);
            return this.$;
        
break;
case 2:

            this.$ = $$[$0-1].concat($$[$0]);
        
break;
case 3:

            this.$ = [];
        
break;
case 6:

          this.$ = new PARAPPLE.ast.FunctionASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-5], _$[$0]), $$[$0-4], $$[$0-2], $$[$0]);
      
break;
case 8:

        this.$ = $$[$0-2].concat($$[$0]);
      
break;
case 9: case 33:

        this.$ = [ $$[$0] ];
      
break;
case 18:

            // ListASTNode, true: enter nested scope
            this.$ = new PARAPPLE.ast.ListASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0]), $$[$0-1], true);
          
break;
case 19:

          this.$ = new PARAPPLE.ast.IfASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-4], _$[$0]), $$[$0-2], $$[$0], null);
        
break;
case 20:

          this.$ = new PARAPPLE.ast.IfASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-6], _$[$0]), $$[$0-4], $$[$0-2], $$[$0]);
        
break;
case 21:

            this.$ = new PARAPPLE.ast.BreakASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-1], _$[$0]));
          
break;
case 22:

            this.$ = new PARAPPLE.ast.ContinueASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-1], _$[$0]));
          
break;
case 23:

              this.$ = new PARAPPLE.ast.ReturnASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-1], _$[$0]), null);
          
break;
case 24:

              this.$ = new PARAPPLE.ast.ReturnASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0-1]), $$[$0-1]);
          
break;
case 27:

        this.$ = new PARAPPLE.ast.ForASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-7], _$[$0]),  $$[$0-5], $$[$0-4], $$[$0-2], $$[$0]);
      
break;
case 28:

          this.$ = new PARAPPLE.ast.WhileASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-4], _$[$0]), $$[$0-2], $$[$0]);
        
break;
case 29:

        this.$ = new PARAPPLE.ast.EmptyASTNode();
      
break;
case 31:

          // Expression statements need to be followed by a POP instructions, that is
          // why we need to nest the expression node under an expression statement node.
          this.$ = new PARAPPLE.ast.ExpressionStatementASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-1], _$[$0-1]), $$[$0-1]);
        
break;
case 32:

          // false: do not enter nested scope
          this.$ = new PARAPPLE.ast.ListASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0]), $$[$0-1], false);
        
break;
case 34:

        this.$ = $$[$0-2].concat($$[$0])
      
break;
case 35:

          this.$ = new PARAPPLE.ast.VarASTNode(new PARAPPLE.ast.SourceLocation(_$[$0], _$[$0]), $$[$0], null);
        
break;
case 36:

          this.$ = new PARAPPLE.ast.VarASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0]), $$[$0-2], $$[$0]);
        
break;
case 37:

              this.$ = $$[$0-1].concat($$[$0]);
          
break;
case 38:

              this.$ = [];
          
break;
case 40:

          this.$ = $$[$0-2].concat($$[$0]);
        
break;
case 41:

          this.$ = [ $$[$0] ];
        
break;
case 46:

          this.$ = new PARAPPLE.ast.IdentifierAssignmentASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0]), $$[$0-2], $$[$0], $$[$0-1]);
      
break;
case 47:

          this.$ = new PARAPPLE.ast.MemberAssignmentASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0]), $$[$0-2], $$[$0], $$[$0-1]);
      
break;
case 51:

        this.$ = new PARAPPLE.ast.TernaryExpressionASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-4], _$[$0]), $$[$0-4], $$[$0-2], $$[$0]);
      
break;
case 53: case 55: case 57: case 59: case 61: case 63: case 65: case 67: case 71:

        this.$ = new PARAPPLE.ast.BinaryExpressionASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0]), $$[$0-2], $$[$0], $$[$0-1]);
      
break;
case 79:

        this.$ = new PARAPPLE.ast.UnaryExpressionASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-1], _$[$0]), $$[$0-1], $$[$0]);
      
break;
case 83:

        this.$ = new PARAPPLE.ast.PostfixExpressionASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-1], _$[$0]), $$[$0-1], $$[$0]);
      
break;
case 86:

        this.$ = new PARAPPLE.ast.PrefixExpressionASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-1], _$[$0]), $$[$0], $$[$0-1]);
      
break;
case 89: case 90:

        this.$ = new PARAPPLE.ast.MemberExpressionASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-3], _$[$0]), $$[$0-3], $$[$0-1], true);
      
break;
case 91: case 92:

        this.$ = new PARAPPLE.ast.MemberExpressionASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0]), $$[$0-2], $$[$0]);
      
break;
case 96:

        this.$ = $$[$0-1]
      
break;
case 97:

        this.$ = new PARAPPLE.ast.FunctionCallASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-3], _$[$0]), $$[$0-3], $$[$0-1]);
      
break;
case 98:

      this.$ = new PARAPPLE.ast.IdentifierASTNode(new PARAPPLE.ast.SourceLocation(_$[$0], _$[$0]), $$[$0]);
    
break;
case 104: case 106:

        this.$ = new PARAPPLE.ast.LiteralASTNode(new PARAPPLE.ast.SourceLocation(_$[$0], _$[$0]), $$[$0]);
      
break;
case 105:

      this.$ = new PARAPPLE.ast.LiteralASTNode(new PARAPPLE.ast.SourceLocation(_$[$0], _$[$0]), $$[$0]);
    
break;
case 107:

      this.$ = new PARAPPLE.ast.ArrayLiteralASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0]), $$[$0-1])
    
break;
case 108:

      this.$ = new PARAPPLE.ast.MapLiteralASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0]), $$[$0-1])
    
break;
case 110:

      this.$ = $$[$0-2].concat($$[$0]);
    
break;
case 111:

      this.$ = [ $$[$0] ];
    
break;
case 112:

      this.$ = new PARAPPLE.ast.PropertyASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0]), $$[$0-2], $$[$0]);
    
break;
case 113:

        this.$ = new PARAPPLE.ast.LiteralASTNode(new PARAPPLE.ast.SourceLocation(_$[$0], _$[$0]), null);
      
break;
}
},
table: [o($V0,[2,3],{3:1,4:2}),{1:[3]},{5:[1,3],6:4,7:5,8:6,9:[1,14],10:$V1,11:$V2,14:7,17:8,18:9,19:10,20:11,21:12,22:13,23:$V3,26:$V4,29:$V5,30:$V6,31:$V7,32:$V8,33:17,34:18,35:$V9,36:$Va,37:20,38:21,39:$Vb,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{1:[2,1]},o($V0,[2,2]),o($V0,[2,4]),o($V0,[2,5]),o($Vm,[2,11]),o($Vm,[2,12]),o($Vm,[2,13]),o($Vm,[2,14]),o($Vm,[2,15]),o($Vm,[2,16]),o($Vm,[2,17]),{10:[1,66]},o($Vn,[2,38],{24:67}),{11:[1,68]},o($Vm,[2,25]),o($Vm,[2,26]),o($Vm,[2,29]),o($Vm,[2,30]),{30:[1,69]},{30:[1,70]},{30:[1,71]},{10:$V1,11:$V2,23:$Vo,27:73,30:[1,72],38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{11:[1,77]},{11:[1,78]},{10:$Vp,40:79,41:80},o($Vq,[2,44]),o($Vq,[2,45]),o([13,15,25,30,51,54,56,58,60,62,64,66,69,70,73,74,75,85,86,87],$Vr,{47:82,81:84,11:$Vs,42:$Vt,49:$Vu,82:$Vv,83:$Vw}),o([13,15,25,30,51,54,56,58,60,62,64,66,69,70,73,74,75,86],$Vx,{47:89,42:$Vt,49:$Vu,85:$Vy,87:$Vz}),o($Vq,[2,50],{51:[1,92],54:$VA}),o($VB,[2,78],{85:[1,94],87:[1,95]}),o($VC,[2,52],{56:$VD}),o($VE,[2,93]),o($VE,[2,94]),o($VE,[2,95]),{10:$V1,11:$V2,23:$Vo,27:97,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($VF,[2,54],{58:$VG}),o($VE,[2,99]),o($VE,[2,100]),o($VE,[2,101]),o($VE,[2,102]),o($VE,[2,103]),o($VH,[2,56],{60:$VI}),o($VE,[2,104]),o($VE,[2,105]),o($VE,[2,106]),o([15,86],$VJ,{45:28,46:29,48:31,50:32,78:33,53:34,88:35,89:36,90:37,55:39,91:40,92:41,93:42,94:43,95:44,57:45,59:51,61:52,63:53,65:54,67:55,71:56,76:57,77:58,79:59,84:60,38:74,44:75,43:100,27:101,10:$V1,11:$V2,23:$Vo,69:$Vc,70:$Vd,80:$Ve,82:$Vf,83:$Vg,85:$Vh,96:$Vi,97:$Vj,98:$Vk,101:$Vl}),o($VE,[2,113]),o($VK,[2,58],{62:$VL}),o($VM,[2,60],{64:$VN}),o($VO,[2,62],{66:$VP}),o($VQ,[2,64],{68:105,69:$VR,70:$VS}),o($VT,[2,66],{72:108,73:$VU,74:$VV,75:$VW}),o($VB,[2,70]),o($VB,[2,75]),o($VB,[2,76]),{10:$VX,11:$V2,48:113,69:$Vc,70:$Vd,71:112,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:[1,115]},o($VY,[2,80]),o($VY,[2,81]),o($VY,[2,82]),{10:[2,87]},{10:[2,88]},{11:[1,116]},{7:118,10:$V1,11:$V2,14:7,17:8,18:9,19:10,20:11,21:12,22:13,23:$V3,25:[1,117],26:$V4,29:$V5,30:$V6,31:$V7,32:$V8,33:17,34:18,35:$V9,36:$Va,37:20,38:21,39:$Vb,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:$V1,11:$V2,23:$Vo,27:119,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($Vm,[2,31]),o($Vm,[2,21]),o($Vm,[2,22]),o($Vm,[2,23]),{30:[1,120]},o($Vq,[2,42]),o($Vq,[2,43]),o($VZ,[2,109],{99:121,100:122,10:$V_}),{10:$V1,11:$V2,19:124,30:$V6,37:20,38:21,39:$Vb,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:$V1,11:$V2,23:$Vo,27:125,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{15:[1,127],30:[1,126]},o($V$,[2,33]),o($V$,[2,35],{42:[1,128]}),{10:$V1,11:$V2,23:$Vo,27:129,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($V01,$VJ,{45:28,46:29,48:31,50:32,78:33,53:34,88:35,89:36,90:37,55:39,91:40,92:41,93:42,94:43,95:44,57:45,59:51,61:52,63:53,65:54,67:55,71:56,76:57,77:58,79:59,84:60,38:74,44:75,27:101,43:130,10:$V1,11:$V2,23:$Vo,69:$Vc,70:$Vd,80:$Ve,82:$Vf,83:$Vg,85:$Vh,96:$Vi,97:$Vj,98:$Vk,101:$Vl}),o($VB,[2,83]),o($V11,[2,48]),o($V11,[2,49]),o($VB,[2,84]),o($VB,[2,85]),{10:$V1,11:$V2,23:$Vo,27:131,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:$V1,11:$V2,23:$Vo,27:132,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:[1,133]},{10:$VX,11:$V2,48:113,50:134,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:$VX,11:$V2,48:113,53:135,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:$V1,11:$V2,23:$Vo,27:136,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:[1,137]},{10:$VX,11:$V2,48:113,55:138,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{13:[1,139]},{10:$VX,11:$V2,48:113,57:140,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:$VX,11:$V2,48:113,59:141,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{15:$V21,86:[1,142]},o($V31,[2,41]),{10:$VX,11:$V2,48:113,61:144,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:$VX,11:$V2,48:113,63:145,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:$VX,11:$V2,48:113,65:146,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:$VX,11:$V2,48:113,67:147,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($VY,[2,68]),o($VY,[2,69]),{10:$VX,11:$V2,48:113,69:$Vc,70:$Vd,71:148,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($VY,[2,72]),o($VY,[2,73]),o($VY,[2,74]),o($VB,[2,79]),o($VB,$Vx,{85:$Vy,87:$Vz}),o($VE,$Vr,{81:84,11:$Vs,82:$Vv,83:$Vw}),o($VB,[2,86]),o($V01,[2,7],{12:149,16:150,10:$V41}),o($Vm,[2,18]),o($Vn,[2,37]),{13:[1,152]},o($Vm,[2,24]),{15:[1,154],25:[1,153]},o($VZ,[2,111]),{52:[1,155]},{10:$V1,11:$V2,23:$Vo,27:156,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{13:[1,157]},o($Vm,[2,32]),{10:$Vp,41:158},{10:$V1,11:$V2,23:$Vo,27:159,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($Vq,[2,46]),{13:[1,160],15:$V21},o($Vq,[2,47]),{86:[1,161]},o($V51,[2,92]),{52:[1,162],54:$VA},o($VC,[2,53],{56:$VD}),{86:[1,163]},o($V51,[2,91]),o($VF,[2,55],{58:$VG}),o($VE,[2,96]),o($VH,[2,57],{60:$VI}),o($VK,[2,59],{62:$VL}),o($VE,[2,107]),{10:$V1,11:$V2,23:$Vo,27:164,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($VM,[2,61],{64:$VN}),o($VO,[2,63],{66:$VP}),o($VQ,[2,65],{68:105,69:$VR,70:$VS}),o($VT,[2,67],{72:108,73:$VU,74:$VV,75:$VW}),o($VB,[2,71]),{13:[1,165],15:[1,166]},o($V01,[2,9]),o($V01,[2,10]),{7:167,10:$V1,11:$V2,14:7,17:8,18:9,19:10,20:11,21:12,22:13,23:$V3,26:$V4,29:$V5,30:$V6,31:$V7,32:$V8,33:17,34:18,35:$V9,36:$Va,37:20,38:21,39:$Vb,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($Vq,[2,108]),{10:$V_,100:168},{10:$V1,11:$V2,23:$Vo,27:169,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{30:[1,170]},{7:171,10:$V1,11:$V2,14:7,17:8,18:9,19:10,20:11,21:12,22:13,23:$V3,26:$V4,29:$V5,30:$V6,31:$V7,32:$V8,33:17,34:18,35:$V9,36:$Va,37:20,38:21,39:$Vb,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($V$,[2,34]),o($V$,[2,36]),o($VE,[2,97]),o($V51,[2,90]),{10:$VX,11:$V2,46:172,48:113,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($V51,[2,89]),o($V31,[2,40]),{14:173,23:$V3},{10:$V41,16:174},o([5,9,10,11,23,25,26,29,30,31,32,35,36,39,69,70,80,82,83,85,96,97,98,101],[2,19],{28:[1,175]}),o($VZ,[2,110]),o($VZ,[2,112]),{10:$V1,11:$V2,23:$Vo,27:176,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($Vm,[2,28]),o($Vq,[2,51]),o($V0,[2,6]),o($V01,[2,8]),{7:177,10:$V1,11:$V2,14:7,17:8,18:9,19:10,20:11,21:12,22:13,23:$V3,26:$V4,29:$V5,30:$V6,31:$V7,32:$V8,33:17,34:18,35:$V9,36:$Va,37:20,38:21,39:$Vb,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{13:[1,178]},o($Vm,[2,20]),{7:179,10:$V1,11:$V2,14:7,17:8,18:9,19:10,20:11,21:12,22:13,23:$V3,26:$V4,29:$V5,30:$V6,31:$V7,32:$V8,33:17,34:18,35:$V9,36:$Va,37:20,38:21,39:$Vb,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($Vm,[2,27])],
defaultActions: {3:[2,1],64:[2,87],65:[2,88]},
parseError: function parseError(str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        function _parseError (msg, hash) {
            this.message = msg;
            this.hash = hash;
        }
        _parseError.prototype = Error;

        throw new _parseError(str, hash);
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
    _token_stack:
        var lex = function () {
            var token;
            token = lexer.lex() || EOF;
            if (typeof token !== 'number') {
                token = self.symbols_[token] || token;
            }
            return token;
        };
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
                    if (typeof action === 'undefined' || !action.length || !action[0]) {
                var errStr = '';
                expected = [];
                for (p in table[state]) {
                    if (this.terminals_[p] && p > TERROR) {
                        expected.push('\'' + this.terminals_[p] + '\'');
                    }
                }
                if (lexer.showPosition) {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                } else {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                }
                this.parseError(errStr, {
                    text: lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: lexer.yylineno,
                    loc: yyloc,
                    expected: expected
                });
            }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};

/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function (match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex() {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin(condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState() {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules() {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState(n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState(condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0: // ignore whitespace 
break;
case 1: // multi-line comment 
break;
case 2: // single-line comment 
break;
case 3:return "IF";
break;
case 4:return "ELSE";
break;
case 5:return "VAR";
break;
case 6:return "FOR";
break;
case 7:return "WHILE";
break;
case 8:return "FUNCTION";
break;
case 9:return "RETURN";
break;
case 10:return "BREAK";
break;
case 11:return "CONTINUE";
break;
case 12:return "BOOLEAN";
break;
case 13:return "BOOLEAN";
break;
case 14:return "NULL";
break;
case 15:return "IDENTIFIER";
break;
case 16:return "STRING";
break;
case 17:return "NUMERIC_LITERAL";
break;
case 18:return "{";
break;
case 19:return "}";
break;
case 20:return "(";
break;
case 21:return ")";
break;
case 22:return "[";
break;
case 23:return "]";
break;
case 24:return ";";
break;
case 25:return ":";
break;
case 26:return ",";
break;
case 27:return ".";
break;
case 28:return "?";
break;
case 29:return "LOGICAL_EQUALITY";
break;
case 30:return "LOGICAL_EQUALITY";
break;
case 31:return "LOGICAL_EQUALITY";
break;
case 32:return "LOGICAL_EQUALITY";
break;
case 33:return "RELATIONAL_OPERATOR";
break;
case 34:return "RELATIONAL_OPERATOR";
break;
case 35:return "RELATIONAL_OPERATOR";
break;
case 36:return "RELATIONAL_OPERATOR";
break;
case 37:return "ARITHMETIC_ASSIGNMENT_OPERATOR";
break;
case 38:return "ARITHMETIC_ASSIGNMENT_OPERATOR";
break;
case 39:return "ARITHMETIC_ASSIGNMENT_OPERATOR";
break;
case 40:return "ARITHMETIC_ASSIGNMENT_OPERATOR";
break;
case 41:return "=";
break;
case 42:return "++";
break;
case 43:return "--";
break;
case 44:return "+";
break;
case 45:return "-";
break;
case 46:return "*";
break;
case 47:return "/";
break;
case 48:return "%";
break;
case 49:return "||"
break;
case 50:return "&&"
break;
case 51:return "|"
break;
case 52:return "&"
break;
case 53:return "^"
break;
case 54:return "!"
break;
case 55:return 5
break;
case 56:return 'Invalid_character'
break;
}
},
rules: [/^(?:\s+)/,/^(?:\/\*(.|\r|\n)*?\*\/)/,/^(?:\/\/.*($|\r\n|\r|\n))/,/^(?:if\b)/,/^(?:else\b)/,/^(?:var\b)/,/^(?:for\b)/,/^(?:while\b)/,/^(?:function\b)/,/^(?:return\b)/,/^(?:break\b)/,/^(?:continue\b)/,/^(?:true\b)/,/^(?:false\b)/,/^(?:null\b)/,/^(?:(([$_a-zA-Z])(([$_a-zA-Z])|[0-9])*))/,/^(?:(("(([^\"\\\n\r]+))*")|('(([^\'\\\n\r]+))*')))/,/^(?:((((0|([1-9])[0-9]*)?(\.([0-9])+))|((0|([1-9])[0-9]*)(\.([0-9])+)?))([Ee][+-]?([0-9])+)?))/,/^(?:\{)/,/^(?:\})/,/^(?:\()/,/^(?:\))/,/^(?:\[)/,/^(?:\])/,/^(?:;)/,/^(?::)/,/^(?:,)/,/^(?:\.)/,/^(?:\?)/,/^(?:===)/,/^(?:==)/,/^(?:!==)/,/^(?:!=)/,/^(?:>=)/,/^(?:<=)/,/^(?:>)/,/^(?:<)/,/^(?:\+=)/,/^(?:-=)/,/^(?:\*=)/,/^(?:\/=)/,/^(?:=)/,/^(?:\+\+)/,/^(?:--)/,/^(?:\+)/,/^(?:-)/,/^(?:\*)/,/^(?:\/)/,/^(?:%)/,/^(?:\|\|)/,/^(?:&&)/,/^(?:\|)/,/^(?:&)/,/^(?:\^)/,/^(?:!)/,/^(?:$)/,/^(?:.)/],
conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (true) {
exports.parser = parascript;
exports.Parser = parascript.Parser;
exports.parse = function () { return parascript.parse.apply(parascript, arguments); };
exports.main = function commonjsMain(args) {
    if (!args[1]) {
        console.log('Usage: '+args[0]+' FILE');
        process.exit(1);
    }
    var source = __webpack_require__(1489).readFileSync(__webpack_require__(442).normalize(args[1]), "utf8");
    return exports.parser.parse(source);
};
if (typeof module !== 'undefined' && __webpack_require__.c[__webpack_require__.s] === module) {
  exports.main(process.argv.slice(1));
}
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(101), __webpack_require__(45)(module)))

/***/ }),

/***/ 1280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_runtime_executor_js__ = __webpack_require__(104);





var Agent = function () {
    function Agent(definition, agentType, agentId) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Agent);

        this.definition = definition;
        this.name = definition.name;
        this.agentType = agentType;
        this.definition.agentId = agentId;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Agent, [{
        key: 'createExecutor',
        value: function createExecutor() {
            this.executor = new __WEBPACK_IMPORTED_MODULE_2_runtime_executor_js__["a" /* default */](this);
            return this.executor;
        }
    }, {
        key: 'highlight',
        value: function highlight() {
            if (this.executor) {
                this.executor.highlight();
            }
        }
    }]);

    return Agent;
}();

/* harmony default export */ __webpack_exports__["a"] = (Agent);

/***/ }),

/***/ 1281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_runtime_instructionCost_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_parascript_compiler_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_utils_modalMessage_modalMessageProxy_js__ = __webpack_require__(46);




var STATE_NOT_COMPILED = {
  status: "NOT_COMPILED",
  icon: "edit",
  tabIcon: "pencil",
  message: "Not compiled."
};
var STATE_COMPILING = {
  status: "COMPILING",
  icon: "gears",
  tabIcon: "gears",
  message: "Compiling."
};
var STATE_COMPILED = {
  status: "COMPILED",
  icon: "check",
  tabIcon: "check",
  message: "Compiled."
};
var STATE_ERROR = {
  status: "ERROR",
  icon: "warning",
  tabIcon: "warning",
  message: "Error."
};





var AgentType = function () {
  function AgentType(definition) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AgentType);

    this.definition = definition;
    this.name = definition.name;

    this.agents = {};
    this.agentNames = [];

    this.source = null;

    this.instructions = null;

    this.sourceMap = {};
    this.breakpointCount = 0;

    this.prepareAgentAPI();
    this.prepareAgentCosts();

    this.stateNotCompiled();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AgentType, [{
    key: "addAgent",
    value: function addAgent(agent) {
      this.agents[agent.name] = agent;
      this.agentNames.push(agent.name);
    }
  }, {
    key: "setCodearea",
    value: function setCodearea(codearea) {
      this.codearea = codearea;
    }
  }, {
    key: "compile",
    value: function compile(source) {
      this.removeBreakpoints();
      this.codearea.lowlightAgent();
      this.stateCompiling();
      var compiler = new __WEBPACK_IMPORTED_MODULE_4_parascript_compiler_js__["a" /* default */]();
      this.source = this.codearea.getSource();;
      try {
        this.instructions = compiler.compile(this.source, this);
        this.makeSourceMap();
        this.stateCompiled();
        return true;
      } catch (e) {
        this.stateError(e);
        this.codearea.setError(e);
        this.focus();
        __WEBPACK_IMPORTED_MODULE_5_components_utils_modalMessage_modalMessageProxy_js__["a" /* default */].errorAlert(e.message, "Error compiling code for  '" + this.name + "':");
        return false;
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.codearea.focus();
    }
  }, {
    key: "toggleBreakpoint",
    value: function toggleBreakpoint(row) {
      if (this.state == STATE_COMPILED) {
        var instruction = this.sourceMap[row];
        if (!instruction) {
          return;
        }
        if (instruction.breakpoint) {
          instruction.breakpoint = false;
          this.codearea.$refs.aceEditor.clearBreakpoint(row);
          this.breakpointCount--;
        } else {
          instruction.breakpoint = true;
          this.codearea.$refs.aceEditor.setBreakpoint(row);
          this.breakpointCount++;
        }
      }
    }
  }, {
    key: "removeBreakpoints",
    value: function removeBreakpoints() {
      if (this.breakpointCount > 0) {
        if (this.instructions) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.instructions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var i = _step.value;

              i.breakpoint = false;
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
        this.codearea.$refs.aceEditor.removeBreakpoints();
        this.breakpointCount = 0;
      }
    }
  }, {
    key: "stateNotCompiled",
    value: function stateNotCompiled() {
      this.state = STATE_NOT_COMPILED;
    }
  }, {
    key: "stateError",
    value: function stateError(codeError) {
      this.state = STATE_ERROR;
      this.state.message = codeError.message;
    }
  }, {
    key: "stateCompiled",
    value: function stateCompiled() {
      this.state = STATE_COMPILED;
    }
  }, {
    key: "stateCompiling",
    value: function stateCompiling() {
      this.state = STATE_COMPILING;
    }
  }, {
    key: "isCompiled",
    value: function isCompiled() {
      return this.state == STATE_COMPILED;
    }
  }, {
    key: "prepareAgentAPI",
    value: function prepareAgentAPI() {
      var packageFunctions = {};
      var packageConstants = {};
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.definition.api), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var api = _step2.value;

          $.extend(packageFunctions, api.functions);
          $.extend(packageConstants, api.constants);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.api = {
        packageConstants: packageConstants,
        packageFunctions: packageFunctions
      };
    }
  }, {
    key: "prepareAgentCosts",
    value: function prepareAgentCosts() {
      this.costs = $.extend(__WEBPACK_IMPORTED_MODULE_3_runtime_instructionCost_js__["b" /* DEFAULT_AGENT_COSTS */], this.definition.costs);
      console.log("COSTS", this.costs);
    }
  }, {
    key: "makeSourceMap",
    value: function makeSourceMap() {
      this.sourceMap = {};
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.instructions), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var i = _step3.value;

          if (i.location && this.sourceMap[i.location.startLine - 1] == undefined) {
            this.sourceMap[i.location.startLine - 1] = i;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }]);

  return AgentType;
}();

/* harmony default export */ __webpack_exports__["a"] = (AgentType);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8)))

/***/ }),

/***/ 1282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_stack_js__ = __webpack_require__(47);




var Memory = function () {
    function Memory() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Memory);

        this.stack = new __WEBPACK_IMPORTED_MODULE_2_utils_stack_js__["a" /* default */]();
        this.callStack = new __WEBPACK_IMPORTED_MODULE_2_utils_stack_js__["a" /* default */]();

        this.stack.push({});
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Memory, [{
        key: 'enter',
        value: function enter(jumpInstruction) {
            this.stack.push({});
            this.callStack.push(jumpInstruction);
        }
    }, {
        key: 'exit',
        value: function exit() {
            this.stack.pop();
            this.callStack.pop();
        }
    }, {
        key: 'localScope',
        value: function localScope() {
            return this.stack.peek();
        }
    }, {
        key: 'globalScope',
        value: function globalScope() {
            return this.stack.peekBottom();
        }
    }, {
        key: 'storeLocal',
        value: function storeLocal(key, value) {
            this.localScope()[key] = value;
        }
    }, {
        key: 'loadLocal',
        value: function loadLocal(key) {
            return this.localScope()[key];
        }
    }, {
        key: 'storeGlobal',
        value: function storeGlobal(key, value) {
            this.globalScope()[key] = value;
        }
    }, {
        key: 'loadGlobal',
        value: function loadGlobal(key) {
            return this.globalScope()[key];
        }
    }]);

    return Memory;
}();

/* harmony default export */ __webpack_exports__["a"] = (Memory);

/***/ }),

/***/ 1283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_runtime_scheduler_randomScheduler_js__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_runtime_scheduler_roundrobinScheduler_js__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_runtime_scheduler_lockstepScheduler_js__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_runtime_scheduler_types_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_console_consoleProxy_js__ = __webpack_require__(19);








var SchedulerFactory = function () {
    function SchedulerFactory() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SchedulerFactory);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(SchedulerFactory, [{
        key: 'makeScheduler',
        value: function makeScheduler(schedulerType, session) {

            try {
                switch (schedulerType) {
                    case __WEBPACK_IMPORTED_MODULE_5_runtime_scheduler_types_js__["a" /* default */].roundrobin.key:
                        return new __WEBPACK_IMPORTED_MODULE_3_runtime_scheduler_roundrobinScheduler_js__["a" /* default */](session);
                    case __WEBPACK_IMPORTED_MODULE_5_runtime_scheduler_types_js__["a" /* default */].random.key:
                        return new __WEBPACK_IMPORTED_MODULE_2_runtime_scheduler_randomScheduler_js__["a" /* default */](session);
                    case __WEBPACK_IMPORTED_MODULE_5_runtime_scheduler_types_js__["a" /* default */].lockstep.key:
                        return new __WEBPACK_IMPORTED_MODULE_4_runtime_scheduler_lockstepScheduler_js__["a" /* default */](session);
                    default:
                        __WEBPACK_IMPORTED_MODULE_6_components_console_consoleProxy_js__["a" /* default */].warn("System", "Unknown scheduler type: " + schedulerType);
                }
            } catch (e) {
                __WEBPACK_IMPORTED_MODULE_6_components_console_consoleProxy_js__["a" /* default */].error("System", "Error instantiating scheduler [" + schedulerType + "]: " + e);
            }
            __WEBPACK_IMPORTED_MODULE_6_components_console_consoleProxy_js__["a" /* default */].info("System", "Defaulting to round-robin scheduler...");
            return new __WEBPACK_IMPORTED_MODULE_3_runtime_scheduler_roundrobinScheduler_js__["a" /* default */](session);
        }
    }]);

    return SchedulerFactory;
}();

/* harmony default export */ __webpack_exports__["a"] = (new SchedulerFactory());

/***/ }),

/***/ 1284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_common_errors_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_runtime_scheduler_scheduler_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_stack_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_runtime_scheduler_types_js__ = __webpack_require__(34);















var LockstepScheduler = function (_Scheduler) {
    __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(LockstepScheduler, _Scheduler);

    function LockstepScheduler(session) {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, LockstepScheduler);

        if (session.agentTypeNames.length != 1) {
            throw "Lock-step scheduler may be used only for tutorials with single agent type!";
        }

        var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LockstepScheduler.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(LockstepScheduler)).call(this, session));

        _this.type = __WEBPACK_IMPORTED_MODULE_13_runtime_scheduler_types_js__["a" /* default */].lockstep;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(LockstepScheduler, [{
        key: 'reset',
        value: function reset() {
            this.waitMap = {};
            this.waitStack = new __WEBPACK_IMPORTED_MODULE_12_utils_stack_js__["a" /* default */]();
            this.currentRound = null;
            this.activeExecutors = this.executors;
            this.lastResult = null;
            __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get___default()(LockstepScheduler.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(LockstepScheduler.prototype), 'reset', this).call(this);
        }
    }, {
        key: 'run',
        value: function run() {
            __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get___default()(LockstepScheduler.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(LockstepScheduler.prototype), 'run', this).call(this);
            this.ensureRound();
            var self = this;
            function loop() {
                self.tick();
                if (self.isRunning()) {
                    window.setTimeout(loop, self.session.tickDuration);
                }
            }
            loop();
        }
    }, {
        key: 'tick',
        value: function tick() {
            var round = this.currentRound;
            while (round == this.currentRound) {
                this.step(this.nextExecutor);
                if (!this.isRunning()) {
                    break;
                }
            }
        }
    }, {
        key: 'lockstep',
        value: function lockstep(last) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.session.lockstepCallbacks)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var lockstepCallback = _step.value;

                    lockstepCallback(last, this.activeExecutors);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (last.id == "COND_JUMP" || last.id == "CALL") {
                var jumped = [];
                var notJumped = [];
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.activeExecutors), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var e = _step2.value;

                        if (e.jumped) {
                            jumped.push(e);
                        } else {
                            notJumped.push(e);
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                if (notJumped.length == 0) {} else {
                    var waitAddress = last.id == "COND_JUMP" ? last.params.address : last.address + 1;

                    this.wait(jumped, waitAddress);

                    this.activeExecutors = notJumped;

                    if (last.continueAddr) {
                        this.wait([], last.continueAddr);
                    }
                }
            }

            if (this.areWaiting()) {

                var currentAddress = this.activeExecutors[0].ip;

                if (last.isBreak || last.isContinue || last.id == "RETURN") {
                    this.wait(this.activeExecutors, currentAddress);
                    this.activeExecutors = this.pop();
                } else if (last.isElse) {
                    var waiting = this.pop();
                    this.wait(this.activeExecutors, currentAddress);
                    this.activeExecutors = waiting;
                }

                while (this.activeExecutors.length == 0) {
                    this.activeExecutors = this.pop();
                }

                currentAddress = this.activeExecutors[0].ip;
                if (this.waitMap.hasOwnProperty(currentAddress)) {
                    var _activeExecutors;

                    var _waiting = this.pop();
                    (_activeExecutors = this.activeExecutors).push.apply(_activeExecutors, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_waiting));
                }
            }
        }
    }, {
        key: 'areWaiting',
        value: function areWaiting() {
            return this.waitStack.size() > 0;
        }
    }, {
        key: 'wait',
        value: function wait(executors, waitAddress) {
            if (!this.waitMap[waitAddress]) {
                this.waitMap[waitAddress] = executors;

                this.waitStack.push({ executors: executors, waitAddress: waitAddress });
            } else {
                var _waitMap$waitAddress;

                (_waitMap$waitAddress = this.waitMap[waitAddress]).push.apply(_waitMap$waitAddress, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(executors));
            }
        }
    }, {
        key: 'pop',
        value: function pop() {
            var element = this.waitStack.pop();
            var executors = element.executors;
            var addr = element.waitAddress;
            delete this.waitMap[addr];
            return executors;
        }
    }, {
        key: 'step',
        value: function step(executor) {
            var result = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get___default()(LockstepScheduler.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(LockstepScheduler.prototype), 'step', this).call(this, executor);
            if (this.currentRound.length == 0 && result && result.instruction) {
                this.lockstep(result.instruction);
            }
            if (result) {
                this.iterate();
            }
        }
    }, {
        key: 'debugTick',
        value: function debugTick() {
            __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get___default()(LockstepScheduler.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(LockstepScheduler.prototype), 'debugTick', this).call(this);
            __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get___default()(LockstepScheduler.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(LockstepScheduler.prototype), 'run', this).call(this);
            this.tick();
            this.highlightNext();
            __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get___default()(LockstepScheduler.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(LockstepScheduler.prototype), 'pause', this).call(this);
        }
    }, {
        key: 'debugStep',
        value: function debugStep() {
            __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get___default()(LockstepScheduler.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(LockstepScheduler.prototype), 'debugStep', this).call(this);
            this.step(this.nextExecutor);
            this.highlightNext();
        }
    }, {
        key: 'getNextExecutor',
        value: function getNextExecutor() {
            this.ensureRound();
            return this.currentRound.pop();
        }
    }, {
        key: 'ensureRound',
        value: function ensureRound() {
            if (!this.currentRound || this.currentRound.length == 0) {
                this.makeRound();
            }
        }
    }, {
        key: 'makeRound',
        value: function makeRound() {
            this.currentRound = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.activeExecutors));
        }
    }]);

    return LockstepScheduler;
}(__WEBPACK_IMPORTED_MODULE_10_runtime_scheduler_scheduler_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (LockstepScheduler);

/***/ }),

/***/ 1285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_errors_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_runtime_scheduler_standardScheduler_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_runtime_scheduler_types_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_js__ = __webpack_require__(15);











var RandomScheduler = function (_StandardScheduler) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(RandomScheduler, _StandardScheduler);

    function RandomScheduler(session) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RandomScheduler);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RandomScheduler.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(RandomScheduler)).call(this, session));

        _this.type = __WEBPACK_IMPORTED_MODULE_8_runtime_scheduler_types_js__["a" /* default */].random;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(RandomScheduler, [{
        key: 'makeRound',
        value: function makeRound() {
            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(RandomScheduler.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(RandomScheduler.prototype), 'makeRound', this).call(this);

            function shuffle(a) {
                for (var i = a.length; i; i--) {
                    var j = Math.floor(Math.random() * i);
                    var _ref = [a[j], a[i - 1]];
                    a[i - 1] = _ref[0];
                    a[j] = _ref[1];
                }
            }
            shuffle(this.currentRound);
        }
    }]);

    return RandomScheduler;
}(__WEBPACK_IMPORTED_MODULE_7_runtime_scheduler_standardScheduler_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (RandomScheduler);

/***/ }),

/***/ 1286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_errors_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_runtime_scheduler_standardScheduler_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_runtime_scheduler_types_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_js__ = __webpack_require__(15);









var RoundrobinScheduler = function (_StandardScheduler) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(RoundrobinScheduler, _StandardScheduler);

    function RoundrobinScheduler(session) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RoundrobinScheduler);

        var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RoundrobinScheduler.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(RoundrobinScheduler)).call(this, session));

        _this.type = __WEBPACK_IMPORTED_MODULE_6_runtime_scheduler_types_js__["a" /* default */].roundrobin;
        return _this;
    }

    return RoundrobinScheduler;
}(__WEBPACK_IMPORTED_MODULE_5_runtime_scheduler_standardScheduler_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (RoundrobinScheduler);

/***/ }),

/***/ 1287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

    READY: {
        icon: "play-circle",
        name: "Ready",
        cssClass: ["success"]
    },
    PAUSED: {
        icon: "pause-circle",
        name: "Paused",
        cssClass: ["warning"]
    },
    RUNNING: {
        icon: "spinner",
        name: "Running",
        cssClass: ["info"]
    },
    DONE: {
        icon: "check",
        name: "Finished",
        cssClass: ["success"]
    },
    ERROR: {
        icon: "warning",
        name: "Error",
        cssClass: ["danger"]
    }

});

/***/ }),

/***/ 1288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_stack_js__ = __webpack_require__(47);








var ValueStack = function (_Stack) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ValueStack, _Stack);

    function ValueStack() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ValueStack);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ValueStack.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ValueStack)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ValueStack, [{
        key: 'push',
        value: function push(e) {
            if (e === undefined) {
                e = null;
            }
            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(ValueStack.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ValueStack.prototype), 'push', this).call(this, e);
        }
    }]);

    return ValueStack;
}(__WEBPACK_IMPORTED_MODULE_6_utils_stack_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ValueStack);

/***/ }),

/***/ 1312:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./abap": 111,
	"./abap.js": 111,
	"./abc": 112,
	"./abc.js": 112,
	"./actionscript": 113,
	"./actionscript.js": 113,
	"./ada": 114,
	"./ada.js": 114,
	"./apache_conf": 115,
	"./apache_conf.js": 115,
	"./applescript": 116,
	"./applescript.js": 116,
	"./asciidoc": 117,
	"./asciidoc.js": 117,
	"./assembly_x86": 118,
	"./assembly_x86.js": 118,
	"./autohotkey": 119,
	"./autohotkey.js": 119,
	"./batchfile": 120,
	"./batchfile.js": 120,
	"./c9search": 121,
	"./c9search.js": 121,
	"./c_cpp": 122,
	"./c_cpp.js": 122,
	"./cirru": 123,
	"./cirru.js": 123,
	"./clojure": 124,
	"./clojure.js": 124,
	"./cobol": 125,
	"./cobol.js": 125,
	"./coffee": 126,
	"./coffee.js": 126,
	"./coldfusion": 127,
	"./coldfusion.js": 127,
	"./csharp": 128,
	"./csharp.js": 128,
	"./css": 129,
	"./css.js": 129,
	"./curly": 130,
	"./curly.js": 130,
	"./d": 131,
	"./d.js": 131,
	"./dart": 132,
	"./dart.js": 132,
	"./diff": 133,
	"./diff.js": 133,
	"./django": 134,
	"./django.js": 134,
	"./dockerfile": 135,
	"./dockerfile.js": 135,
	"./dot": 136,
	"./dot.js": 136,
	"./eiffel": 137,
	"./eiffel.js": 137,
	"./ejs": 138,
	"./ejs.js": 138,
	"./elixir": 139,
	"./elixir.js": 139,
	"./elm": 140,
	"./elm.js": 140,
	"./erlang": 141,
	"./erlang.js": 141,
	"./forth": 142,
	"./forth.js": 142,
	"./ftl": 143,
	"./ftl.js": 143,
	"./gcode": 144,
	"./gcode.js": 144,
	"./gherkin": 145,
	"./gherkin.js": 145,
	"./gitignore": 146,
	"./gitignore.js": 146,
	"./glsl": 147,
	"./glsl.js": 147,
	"./gobstones": 148,
	"./gobstones.js": 148,
	"./golang": 149,
	"./golang.js": 149,
	"./groovy": 150,
	"./groovy.js": 150,
	"./haml": 151,
	"./haml.js": 151,
	"./handlebars": 152,
	"./handlebars.js": 152,
	"./haskell": 153,
	"./haskell.js": 153,
	"./haxe": 154,
	"./haxe.js": 154,
	"./html": 155,
	"./html.js": 155,
	"./html_elixir": 156,
	"./html_elixir.js": 156,
	"./html_ruby": 157,
	"./html_ruby.js": 157,
	"./ini": 158,
	"./ini.js": 158,
	"./io": 159,
	"./io.js": 159,
	"./jack": 160,
	"./jack.js": 160,
	"./jade": 161,
	"./jade.js": 161,
	"./java": 162,
	"./java.js": 162,
	"./javascript": 163,
	"./javascript.js": 163,
	"./json": 164,
	"./json.js": 164,
	"./jsoniq": 165,
	"./jsoniq.js": 165,
	"./jsp": 166,
	"./jsp.js": 166,
	"./jsx": 167,
	"./jsx.js": 167,
	"./julia": 168,
	"./julia.js": 168,
	"./latex": 169,
	"./latex.js": 169,
	"./lean": 170,
	"./lean.js": 170,
	"./less": 171,
	"./less.js": 171,
	"./liquid": 172,
	"./liquid.js": 172,
	"./lisp": 173,
	"./lisp.js": 173,
	"./live_script": 174,
	"./live_script.js": 174,
	"./livescript": 175,
	"./livescript.js": 175,
	"./logiql": 176,
	"./logiql.js": 176,
	"./lsl": 177,
	"./lsl.js": 177,
	"./lua": 178,
	"./lua.js": 178,
	"./luapage": 179,
	"./luapage.js": 179,
	"./lucene": 180,
	"./lucene.js": 180,
	"./makefile": 181,
	"./makefile.js": 181,
	"./markdown": 182,
	"./markdown.js": 182,
	"./mask": 183,
	"./mask.js": 183,
	"./matlab": 184,
	"./matlab.js": 184,
	"./mavens_mate_log": 185,
	"./mavens_mate_log.js": 185,
	"./maze": 186,
	"./maze.js": 186,
	"./mel": 187,
	"./mel.js": 187,
	"./mips_assembler": 188,
	"./mips_assembler.js": 188,
	"./mipsassembler": 189,
	"./mipsassembler.js": 189,
	"./mushcode": 190,
	"./mushcode.js": 190,
	"./mysql": 191,
	"./mysql.js": 191,
	"./nix": 192,
	"./nix.js": 192,
	"./nsis": 193,
	"./nsis.js": 193,
	"./objectivec": 194,
	"./objectivec.js": 194,
	"./ocaml": 195,
	"./ocaml.js": 195,
	"./pascal": 196,
	"./pascal.js": 196,
	"./perl": 197,
	"./perl.js": 197,
	"./pgsql": 198,
	"./pgsql.js": 198,
	"./php": 199,
	"./php.js": 199,
	"./plain_text": 200,
	"./plain_text.js": 200,
	"./powershell": 201,
	"./powershell.js": 201,
	"./praat": 202,
	"./praat.js": 202,
	"./prolog": 203,
	"./prolog.js": 203,
	"./properties": 204,
	"./properties.js": 204,
	"./protobuf": 205,
	"./protobuf.js": 205,
	"./python": 206,
	"./python.js": 206,
	"./r": 207,
	"./r.js": 207,
	"./razor": 208,
	"./razor.js": 208,
	"./rdoc": 209,
	"./rdoc.js": 209,
	"./rhtml": 210,
	"./rhtml.js": 210,
	"./rst": 211,
	"./rst.js": 211,
	"./ruby": 212,
	"./ruby.js": 212,
	"./rust": 213,
	"./rust.js": 213,
	"./sass": 214,
	"./sass.js": 214,
	"./scad": 215,
	"./scad.js": 215,
	"./scala": 216,
	"./scala.js": 216,
	"./scheme": 217,
	"./scheme.js": 217,
	"./scss": 218,
	"./scss.js": 218,
	"./sh": 219,
	"./sh.js": 219,
	"./sjs": 220,
	"./sjs.js": 220,
	"./smarty": 221,
	"./smarty.js": 221,
	"./snippets": 222,
	"./snippets.js": 222,
	"./soy_template": 223,
	"./soy_template.js": 223,
	"./space": 224,
	"./space.js": 224,
	"./sql": 225,
	"./sql.js": 225,
	"./sqlserver": 226,
	"./sqlserver.js": 226,
	"./stylus": 227,
	"./stylus.js": 227,
	"./svg": 228,
	"./svg.js": 228,
	"./swift": 229,
	"./swift.js": 229,
	"./swig": 230,
	"./swig.js": 230,
	"./tcl": 231,
	"./tcl.js": 231,
	"./tex": 232,
	"./tex.js": 232,
	"./text": 233,
	"./text.js": 233,
	"./textile": 234,
	"./textile.js": 234,
	"./toml": 235,
	"./toml.js": 235,
	"./twig": 236,
	"./twig.js": 236,
	"./typescript": 237,
	"./typescript.js": 237,
	"./vala": 238,
	"./vala.js": 238,
	"./vbscript": 239,
	"./vbscript.js": 239,
	"./velocity": 240,
	"./velocity.js": 240,
	"./verilog": 241,
	"./verilog.js": 241,
	"./vhdl": 242,
	"./vhdl.js": 242,
	"./wollok": 243,
	"./wollok.js": 243,
	"./xml": 244,
	"./xml.js": 244,
	"./xquery": 245,
	"./xquery.js": 245,
	"./yaml": 246,
	"./yaml.js": 246
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1312;

/***/ }),

/***/ 1313:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ambiance": 247,
	"./ambiance.js": 247,
	"./chaos": 248,
	"./chaos.js": 248,
	"./chrome": 249,
	"./chrome.js": 249,
	"./clouds": 250,
	"./clouds.js": 250,
	"./clouds_midnight": 251,
	"./clouds_midnight.js": 251,
	"./cobalt": 252,
	"./cobalt.js": 252,
	"./crimson_editor": 253,
	"./crimson_editor.js": 253,
	"./dawn": 254,
	"./dawn.js": 254,
	"./dreamweaver": 255,
	"./dreamweaver.js": 255,
	"./eclipse": 256,
	"./eclipse.js": 256,
	"./github": 257,
	"./github.js": 257,
	"./idle_fingers": 258,
	"./idle_fingers.js": 258,
	"./iplastic": 259,
	"./iplastic.js": 259,
	"./katzenmilch": 260,
	"./katzenmilch.js": 260,
	"./kr_theme": 261,
	"./kr_theme.js": 261,
	"./kuroir": 262,
	"./kuroir.js": 262,
	"./merbivore": 263,
	"./merbivore.js": 263,
	"./merbivore_soft": 264,
	"./merbivore_soft.js": 264,
	"./mono_industrial": 265,
	"./mono_industrial.js": 265,
	"./monokai": 266,
	"./monokai.js": 266,
	"./pastel_on_dark": 267,
	"./pastel_on_dark.js": 267,
	"./solarized_dark": 268,
	"./solarized_dark.js": 268,
	"./solarized_light": 269,
	"./solarized_light.js": 269,
	"./sqlserver": 270,
	"./sqlserver.js": 270,
	"./terminal": 271,
	"./terminal.js": 271,
	"./textmate": 272,
	"./textmate.js": 272,
	"./tomorrow": 273,
	"./tomorrow.js": 273,
	"./tomorrow_night": 274,
	"./tomorrow_night.js": 274,
	"./tomorrow_night_blue": 275,
	"./tomorrow_night_blue.js": 275,
	"./tomorrow_night_bright": 276,
	"./tomorrow_night_bright.js": 276,
	"./tomorrow_night_eighties": 277,
	"./tomorrow_night_eighties.js": 277,
	"./twilight": 278,
	"./twilight.js": 278,
	"./vibrant_ink": 279,
	"./vibrant_ink.js": 279,
	"./xcode": 280,
	"./xcode.js": 280
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1313;

/***/ }),

/***/ 1365:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1366:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1367:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1368:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1369:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1370:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1371:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1372:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1373:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1374:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1375:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1376:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1377:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1378:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1379:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1380:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1381:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1382:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1383:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1384:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1385:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1386:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1387:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1388:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1389:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1390:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1391:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1392:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1393:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1394:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1395:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1396:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1397:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Error */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CodeError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InternalError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RuntimeError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);




var Error = function Error(message) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Error);

  this.message = message;
};

var CodeError = function (_Error) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(CodeError, _Error);

  function CodeError(message, location) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, CodeError);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CodeError.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CodeError)).call(this, message));

    _this.location = location;
    return _this;
  }

  return CodeError;
}(Error);

var InternalError = function (_Error2) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(InternalError, _Error2);

  function InternalError(message, exception) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, InternalError);

    var _this2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InternalError.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(InternalError)).call(this, message));

    console.error("[InternalError] " + message + "", exception);
    return _this2;
  }

  return InternalError;
}(Error);

var RuntimeError = function (_CodeError) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(RuntimeError, _CodeError);

  function RuntimeError(message, agent, instruction, error) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, RuntimeError);

    var _this3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RuntimeError.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(RuntimeError)).call(this, message, instruction.location));

    _this3.agent = agent;
    _this3.instruction = instruction;
    _this3.error = error;
    return _this3;
  }

  return RuntimeError;
}(CodeError);

/***/ }),

/***/ 1488:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 326,
	"./af.js": 326,
	"./ar": 333,
	"./ar-dz": 327,
	"./ar-dz.js": 327,
	"./ar-kw": 328,
	"./ar-kw.js": 328,
	"./ar-ly": 329,
	"./ar-ly.js": 329,
	"./ar-ma": 330,
	"./ar-ma.js": 330,
	"./ar-sa": 331,
	"./ar-sa.js": 331,
	"./ar-tn": 332,
	"./ar-tn.js": 332,
	"./ar.js": 333,
	"./az": 334,
	"./az.js": 334,
	"./be": 335,
	"./be.js": 335,
	"./bg": 336,
	"./bg.js": 336,
	"./bn": 337,
	"./bn.js": 337,
	"./bo": 338,
	"./bo.js": 338,
	"./br": 339,
	"./br.js": 339,
	"./bs": 340,
	"./bs.js": 340,
	"./ca": 341,
	"./ca.js": 341,
	"./cs": 342,
	"./cs.js": 342,
	"./cv": 343,
	"./cv.js": 343,
	"./cy": 344,
	"./cy.js": 344,
	"./da": 345,
	"./da.js": 345,
	"./de": 348,
	"./de-at": 346,
	"./de-at.js": 346,
	"./de-ch": 347,
	"./de-ch.js": 347,
	"./de.js": 348,
	"./dv": 349,
	"./dv.js": 349,
	"./el": 350,
	"./el.js": 350,
	"./en-au": 351,
	"./en-au.js": 351,
	"./en-ca": 352,
	"./en-ca.js": 352,
	"./en-gb": 353,
	"./en-gb.js": 353,
	"./en-ie": 354,
	"./en-ie.js": 354,
	"./en-nz": 355,
	"./en-nz.js": 355,
	"./eo": 356,
	"./eo.js": 356,
	"./es": 358,
	"./es-do": 357,
	"./es-do.js": 357,
	"./es.js": 358,
	"./et": 359,
	"./et.js": 359,
	"./eu": 360,
	"./eu.js": 360,
	"./fa": 361,
	"./fa.js": 361,
	"./fi": 362,
	"./fi.js": 362,
	"./fo": 363,
	"./fo.js": 363,
	"./fr": 366,
	"./fr-ca": 364,
	"./fr-ca.js": 364,
	"./fr-ch": 365,
	"./fr-ch.js": 365,
	"./fr.js": 366,
	"./fy": 367,
	"./fy.js": 367,
	"./gd": 368,
	"./gd.js": 368,
	"./gl": 369,
	"./gl.js": 369,
	"./gom-latn": 370,
	"./gom-latn.js": 370,
	"./he": 371,
	"./he.js": 371,
	"./hi": 372,
	"./hi.js": 372,
	"./hr": 373,
	"./hr.js": 373,
	"./hu": 374,
	"./hu.js": 374,
	"./hy-am": 375,
	"./hy-am.js": 375,
	"./id": 376,
	"./id.js": 376,
	"./is": 377,
	"./is.js": 377,
	"./it": 378,
	"./it.js": 378,
	"./ja": 379,
	"./ja.js": 379,
	"./jv": 380,
	"./jv.js": 380,
	"./ka": 381,
	"./ka.js": 381,
	"./kk": 382,
	"./kk.js": 382,
	"./km": 383,
	"./km.js": 383,
	"./kn": 384,
	"./kn.js": 384,
	"./ko": 385,
	"./ko.js": 385,
	"./ky": 386,
	"./ky.js": 386,
	"./lb": 387,
	"./lb.js": 387,
	"./lo": 388,
	"./lo.js": 388,
	"./lt": 389,
	"./lt.js": 389,
	"./lv": 390,
	"./lv.js": 390,
	"./me": 391,
	"./me.js": 391,
	"./mi": 392,
	"./mi.js": 392,
	"./mk": 393,
	"./mk.js": 393,
	"./ml": 394,
	"./ml.js": 394,
	"./mr": 395,
	"./mr.js": 395,
	"./ms": 397,
	"./ms-my": 396,
	"./ms-my.js": 396,
	"./ms.js": 397,
	"./my": 398,
	"./my.js": 398,
	"./nb": 399,
	"./nb.js": 399,
	"./ne": 400,
	"./ne.js": 400,
	"./nl": 402,
	"./nl-be": 401,
	"./nl-be.js": 401,
	"./nl.js": 402,
	"./nn": 403,
	"./nn.js": 403,
	"./pa-in": 404,
	"./pa-in.js": 404,
	"./pl": 405,
	"./pl.js": 405,
	"./pt": 407,
	"./pt-br": 406,
	"./pt-br.js": 406,
	"./pt.js": 407,
	"./ro": 408,
	"./ro.js": 408,
	"./ru": 409,
	"./ru.js": 409,
	"./sd": 410,
	"./sd.js": 410,
	"./se": 411,
	"./se.js": 411,
	"./si": 412,
	"./si.js": 412,
	"./sk": 413,
	"./sk.js": 413,
	"./sl": 414,
	"./sl.js": 414,
	"./sq": 415,
	"./sq.js": 415,
	"./sr": 417,
	"./sr-cyrl": 416,
	"./sr-cyrl.js": 416,
	"./sr.js": 417,
	"./ss": 418,
	"./ss.js": 418,
	"./sv": 419,
	"./sv.js": 419,
	"./sw": 420,
	"./sw.js": 420,
	"./ta": 421,
	"./ta.js": 421,
	"./te": 422,
	"./te.js": 422,
	"./tet": 423,
	"./tet.js": 423,
	"./th": 424,
	"./th.js": 424,
	"./tl-ph": 425,
	"./tl-ph.js": 425,
	"./tlh": 426,
	"./tlh.js": 426,
	"./tr": 427,
	"./tr.js": 427,
	"./tzl": 428,
	"./tzl.js": 428,
	"./tzm": 430,
	"./tzm-latn": 429,
	"./tzm-latn.js": 429,
	"./tzm.js": 430,
	"./uk": 431,
	"./uk.js": 431,
	"./ur": 432,
	"./ur.js": 432,
	"./uz": 434,
	"./uz-latn": 433,
	"./uz-latn.js": 433,
	"./uz.js": 434,
	"./vi": 435,
	"./vi.js": 435,
	"./x-pseudo": 436,
	"./x-pseudo.js": 436,
	"./yo": 437,
	"./yo.js": 437,
	"./zh-cn": 438,
	"./zh-cn.js": 438,
	"./zh-hk": 439,
	"./zh-hk.js": 439,
	"./zh-tw": 440,
	"./zh-tw.js": 440
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1488;

/***/ }),

/***/ 1496:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1497:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1498:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/parapple.02bd493.png";

/***/ }),

/***/ 1499:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = __webpack_require__(458);

function getConfig() {
    return  true ? config.build : config.dev;
}

function staticPath(suffix) {
    var _config = getConfig();
    return _config.assetsPublicPath + _config.assetsSubDirectory + suffix;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    APP_ROOT: getConfig().assetsPublicPath,

    TUTORIALS_PATH: staticPath("/tutorials/"),
    PACKAGES_PATH: staticPath("/packages/"),

    TICK_DURATION: 20,
    TICK_COST: 1 });

/***/ }),

/***/ 1500:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1504:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(1544),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1505:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1373)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1247),
  /* template */
  __webpack_require__(1534),
  /* scopeId */
  "data-v-258cbfbe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1506:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1380)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1248),
  /* template */
  __webpack_require__(1540),
  /* scopeId */
  "data-v-42538298",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1507:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1372)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1249),
  /* template */
  __webpack_require__(1533),
  /* scopeId */
  "data-v-1c42583c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1508:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1369)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1252),
  /* template */
  __webpack_require__(1530),
  /* scopeId */
  "data-v-0e3804f6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1509:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1375)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1255),
  /* template */
  __webpack_require__(1536),
  /* scopeId */
  "data-v-37a06497",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1510:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1376)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1256),
  /* template */
  __webpack_require__(1537),
  /* scopeId */
  "data-v-39520732",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1511:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1384)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1257),
  /* template */
  __webpack_require__(1545),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1512:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1392)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1258),
  /* template */
  __webpack_require__(1553),
  /* scopeId */
  "data-v-c62dc3a8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1513:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1377)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1259),
  /* template */
  __webpack_require__(1538),
  /* scopeId */
  "data-v-3fdb6ba8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1514:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1390)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1261),
  /* template */
  __webpack_require__(1551),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1515:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1394)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1262),
  /* template */
  __webpack_require__(1555),
  /* scopeId */
  "data-v-d2a407ca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1516:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1389)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1264),
  /* template */
  __webpack_require__(1550),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1517:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1381)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1265),
  /* template */
  __webpack_require__(1541),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1518:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1385)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1266),
  /* template */
  __webpack_require__(1546),
  /* scopeId */
  "data-v-834d70fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1519:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1374)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1267),
  /* template */
  __webpack_require__(1535),
  /* scopeId */
  "data-v-295a81dc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1520:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1370)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1268),
  /* template */
  __webpack_require__(1531),
  /* scopeId */
  "data-v-187a4d39",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1521:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1378)
__webpack_require__(1379)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1269),
  /* template */
  __webpack_require__(1539),
  /* scopeId */
  "data-v-40876a64",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1522:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1388)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1270),
  /* template */
  __webpack_require__(1549),
  /* scopeId */
  "data-v-b366a3d4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1523:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1383)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1271),
  /* template */
  __webpack_require__(1543),
  /* scopeId */
  "data-v-70a1e09a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1524:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1396)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1272),
  /* template */
  __webpack_require__(1557),
  /* scopeId */
  "data-v-d7082170",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1525:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1371)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1273),
  /* template */
  __webpack_require__(1532),
  /* scopeId */
  "data-v-19d07084",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1526:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1382)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1274),
  /* template */
  __webpack_require__(1542),
  /* scopeId */
  "data-v-5b70b908",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1527:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1528:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.slim) ? _c('nav', {
    staticClass: "navbar navbar-inverse navbar-sm"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [_c('icon', {
    attrs: {
      "name": "list-alt"
    }
  }), _vm._v(" Console")], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.clear()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('icon', {
    attrs: {
      "name": "trash"
    }
  })], 1)])])])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    ref: "logs",
    staticClass: "logs",
    class: {
      slim: _vm.slim, normal: !_vm.slim
    }
  }, _vm._l((_vm.logs), function(data) {
    return _c('span', [_c('div', {
      staticClass: "log",
      class: data.level.cssClass
    }, [_c('div', {
      staticClass: "level"
    }, [(data.level.icon) ? _c('icon', {
      attrs: {
        "name": data.level.icon
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "key"
    }, [_vm._v(_vm._s(data.key))]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("consoleTime")(data.time)))]), _vm._v(" "), (!data.object) ? _c('div', {
      staticClass: "message"
    }, [_vm._v(_vm._s(data.message))]) : _c('div', {
      staticClass: "message"
    }, [_c('objectView', {
      model: {
        value: (data.message),
        callback: function($$v) {
          data.message = $$v
        },
        expression: "data.message"
      }
    })], 1)])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "log head"
  }, [_c('div', {
    staticClass: "level"
  }), _vm._v(" "), _c('div', {
    staticClass: "key"
  }, [_vm._v("Module")]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v("Time")]), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_vm._v("Message")])])
}]}

/***/ }),

/***/ 1529:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    ref: "btn",
    staticClass: "btn",
    class: _vm.type,
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom"
    },
    on: {
      "click": _vm.click
    }
  }, [(_vm.icon) ? _c('icon', {
    attrs: {
      "name": _vm.icon
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1530:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mainBar'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid home"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('tutorialPicker', {
    attrs: {
      "workbenchWrapper": _vm.workbenchWrapper
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('workbench', {
    ref: "workbench"
  })], 1)])]), _vm._v(" "), _c('modalMessage')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1531:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.session) ? _c('simulator', {
    attrs: {
      "session": _vm.session
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.session) ? _c('welcome') : _vm._e()], 1), _vm._v(" "), _c('editorTabs', {
    ref: "tabs"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1532:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel scheduler-panel",
    class: 'panel-' + _vm.scheduler.state.cssClass
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v(_vm._s(_vm.scheduler.type.name) + "\n            "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hide()
      }
    }
  }, [_c('span', [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "scheduler-data"
  }, [_vm._v("state: "), _c('strong', [_vm._v(_vm._s(_vm.scheduler.state.name))])]), _vm._v(" "), _c('div', {
    staticClass: "scheduler-data"
  }, [_vm._v("steps: "), _c('strong', [_vm._v(_vm._s(_vm.scheduler.elapsedSteps))])])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.scheduler.executors), function(executor) {
    return _c('executor', {
      attrs: {
        "executor": executor,
        "last": _vm.scheduler.lastExecutor == executor,
        "next": _vm.scheduler.nextExecutor == executor
      }
    })
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 1533:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    },
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 1534:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      open: _vm.open, inline: !_vm.open
    }
  }, [(_vm.primary && !_vm.open) ? _c('openButton', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "html": '&#x25B6;'
    },
    on: {
      "click": function($event) {
        _vm.open = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.primary && _vm.open) ? _c('openButton', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "html": '&#x25BC;'
    },
    on: {
      "click": function($event) {
        _vm.open = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.charOpen)
    }
  }), _vm._v(" "), (!_vm.open && !_vm.expanded) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.expanded = true
      }
    }
  }, [_vm._v("...")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(key, index) {
    return (_vm.open || _vm.expanded) ? _c('div', [_c('span', {
      staticClass: "key",
      domProps: {
        "textContent": _vm._s(key)
      }
    }), _vm._v(": "), _c('objectTreeNode', {
      attrs: {
        "primary": _vm.open
      },
      model: {
        value: (_vm.value[key]),
        callback: function($$v) {
          _vm.$set(_vm.value, key, $$v)
        },
        expression: "value[key]"
      }
    }), (!_vm.open && index < _vm.items.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.charClose)
    }
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1535:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron jumbotron-parapple"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("Hello, welcome to Parapple!")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Online platform for parallel programming tutorials")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "thumbnail thumbnail-parapple"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1497)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('h3', [_vm._v("Parallel Programming?")]), _vm._v(" "), _vm._m(0), _vm._m(1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/docs"
    }
  }, [_vm._v("Read more...")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "thumbnail thumbnail-parapple"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1499)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('h3', [_vm._v("Coding in Parascript")]), _vm._v(" "), _c('p', [_vm._v("The tutorials are solved by programming the agents in Parascript—a simplified clone of JavaScript. The syntax should feel very familiar if you know the basics of any C-like language.")]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/docs"
    }
  }, [_vm._v("Documentation")])], 1)])])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Running more programs in parallel (think multiple servers/CPUs/threads...) is cool, but it can get "), _c('a', {
    attrs: {
      "target": "_balnk",
      "href": "http://www.thinkingparallel.com/2007/08/06/what-makes-parallel-programming-hard/"
    }
  }, [_vm._v("hard")]), _vm._v(".\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("On this platform, you can try parallel programming exercies by writing code for multiple "), _c('em', [_vm._v("agents")]), _vm._v(" and run the simulation right in your browser.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "thumbnail thumbnail-parapple"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1496)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('h3', [_vm._v("Extensions & Visualizations")]), _vm._v(" "), _c('p', [_vm._v("Packages written in JavaScript can add arbitrary functionality to the Parascript programming language. They can also provide visualizations for the tutorials. Most tutorials you'll find here use the sample "), _c('em', [_vm._v("Ladybugs package")]), _vm._v(" which runs on top of "), _c('a', {
    attrs: {
      "href": "http://www.pixijs.com/"
    }
  }, [_vm._v("PixiJS")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "static/devDocs.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Developing packages and tutorials")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("Parapple is developed as a master thesis project by "), _c('a', {
    attrs: {
      "href": "mailto:emanuel.buzek@roke.cz"
    }
  }, [_vm._v("Emanuel Buzek")]), _vm._v(" at "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.mff.cuni.cz/to.en/"
    }
  }, [_vm._v("MFF UK")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("Icons made by "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.freepik.com",
      "title": "Freepik"
    }
  }, [_vm._v("Freepik")]), _vm._v(" from "), _c('a', {
    attrs: {
      "href": "http://www.flaticon.com",
      "title": "Flaticon"
    }
  }, [_vm._v("www.flaticon.com")]), _vm._v(" licensed by "), _c('a', {
    attrs: {
      "href": "http://creativecommons.org/licenses/by/3.0/",
      "title": "Creative Commons BY 3.0",
      "target": "_blank"
    }
  }, [_vm._v("CC 3.0 BY")])])
}]}

/***/ }),

/***/ 1536:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mainBar'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-11"
  }, [_c('markdown')], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1537:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.json) ? _c('div', [_c('div', {
    staticClass: "panel panel-primary"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v(_vm._s(_vm.json.name))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('resourceTemplate', {
    ref: "content",
    attrs: {
      "resource": _vm.template,
      "componentData": _vm.componentData
    }
  }), _vm._v(" "), _c('schedulerPicker', {
    ref: "schedulerPicker",
    attrs: {
      "json": _vm.json
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_vm._v("\n            Dependencies: "), _vm._l((_vm.json.dependencies), function(d) {
    return _c('span', {
      staticClass: "label label-primary dependency"
    }, [_vm._v(_vm._s(d))])
  })], 2)])]) : (_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1538:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('icon', {
    attrs: {
      "name": "spinner",
      "spin": ""
    }
  }), _vm._v(" " + _vm._s(_vm.text))], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1539:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vueAceEditor', {
    style: (_vm.style),
    attrs: {
      "lang": _vm.language,
      "theme": _vm.theme,
      "width": _vm.width,
      "height": _vm.height
    },
    on: {
      "init": _vm.editorInit,
      "input": _vm.change
    },
    model: {
      value: (_vm.source),
      callback: function($$v) {
        _vm.source = $$v
      },
      expression: "source"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 1540:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.type === 'null') ? _c('span', {
    staticClass: "object-tree-node-primitive object-tree-node-null"
  }, [_vm._v("null")]) : (_vm.type === 'undefined') ? _c('span', {
    staticClass: "object-tree-node-primitive object-tree-node-undefined"
  }, [_vm._v("undefined")]) : (_vm.type === 'number') ? _c('span', {
    staticClass: "object-tree-node-primitive object-tree-node-number"
  }, [_vm._v(_vm._s(_vm.value))]) : (_vm.type === 'string') ? _c('span', {
    staticClass: "object-tree-node-primitive object-tree-node-string"
  }, [_vm._v("\"" + _vm._s(_vm.value) + "\"")]) : (_vm.type === 'boolean') ? _c('span', {
    staticClass: "object-tree-node-primitive object-tree-node-boolean"
  }, [_vm._v(_vm._s(_vm.value))]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1541:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "tabs": ""
    }
  }, [_c('ul', {
    class: _vm.navStyleClass,
    attrs: {
      "role": "tablist"
    }
  }, [_vm._l((_vm.headers), function(header) {
    return [(header._isTab) ? _c('li', {
      class: {
        active: header.active, disabled: header.disabled
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.select(header)
        }
      }
    }, [_vm._t("header", [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [(header.leftIcon) ? _c('icon', {
      attrs: {
        "name": header.leftIcon
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(header.header) + " "), (header.rightIcon) ? _c('icon', {
      attrs: {
        "name": header.rightIcon
      }
    }) : _vm._e()], 1)])], 2) : _vm._e(), _vm._v(" "), (header._isTabGroup) ? _c('dropdown', {
      class: {
        active: header.active
      },
      attrs: {
        "text": header.header,
        "disabled": header.disabled
      }
    }, _vm._l((header.tabs), function(tab) {
      return _c('li', {
        class: {
          disabled: tab.disabled
        }
      }, [_c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.select(tab)
          }
        }
      }, [_vm._v(_vm._s(tab.header))])])
    })) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1542:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.session.scheduler && !_vm.session.showScheduler) ? _c('a', {
    staticClass: "btn-group pull-right",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.show()
      }
    }
  }, [_vm._v("\n" + _vm._s(_vm.session.scheduler.type.name) + " "), _c('icon', {
    attrs: {
      "name": "external-link"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1543:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-toolbar",
    attrs: {
      "role": "toolbar"
    }
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": !_vm.session
    },
    on: {
      "click": function($event) {
        _vm.setupAndRun()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "cogs"
    }
  }), _vm._v(" Compile & Run")], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.setup()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "cogs"
    }
  }), _vm._v(" Setup")], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": !_vm.session.scheduler || _vm.session.scheduler.isRunning()
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "undo"
    }
  }), _vm._v(" Reset")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": !_vm.session.scheduler || _vm.session.scheduler.isRunning()
    },
    on: {
      "click": function($event) {
        _vm.run()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "play-circle"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": !_vm.session.scheduler || !_vm.session.scheduler.isRunning()
    },
    on: {
      "click": function($event) {
        _vm.pause()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "pause-circle"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": !_vm.session.scheduler || !_vm.session.scheduler.isPaused()
    },
    on: {
      "click": function($event) {
        _vm.step()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "step-forward"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": !_vm.session.scheduler || !_vm.session.scheduler.isPaused()
    },
    on: {
      "click": function($event) {
        _vm.tick()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "fast-forward"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    staticStyle: {
      "width": "256px"
    }
  }, [_c('vue-slider', {
    attrs: {
      "data": _vm.speedData,
      "piecewise": true,
      "piecewiseLabel": true,
      "tooltip": "hover",
      "disabled": !_vm.session
    },
    on: {
      "callback": _vm.setSpeed
    },
    model: {
      value: (_vm.speedValue),
      callback: function($$v) {
        _vm.speedValue = $$v
      },
      expression: "speedValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('checkbox', {
    attrs: {
      "disabled": !_vm.session.scheduler,
      "button": true
    },
    model: {
      value: (_vm.session.showScheduler),
      callback: function($$v) {
        _vm.session.showScheduler = $$v
      },
      expression: "session.showScheduler"
    }
  }, [_c('icon', {
    attrs: {
      "name": "tasks",
      "title": _vm.session.scheduler ? _vm.session.scheduler.type.name : 'Scheduler not initialized'
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-status",
    class: _vm.statusClass
  }, [(_vm.session.scheduler) ? _c('span', [_c('icon', {
    attrs: {
      "name": _vm.session.scheduler.state.icon
    }
  }), _vm._v(" " + _vm._s(_vm.session.scheduler.state.name) + "\n                "), (_vm.session.scheduler.isPaused()) ? _c('span', [_vm._v(" ["), _c('icon', {
    attrs: {
      "name": "user-secret"
    }
  }), _vm._v(" " + _vm._s(_vm.session.scheduler.nextExecutor.agent.name) + "]")], 1) : _vm._e(), _vm._v(" "), (_vm.session.scheduler.isError()) ? _c('span', [_vm._v(" ["), _c('icon', {
    attrs: {
      "name": "user-secret"
    }
  }), _vm._v(" " + _vm._s(_vm.session.scheduler.nextExecutor.agent.name) + "] " + _vm._s(_vm.session.scheduler.exception.message))], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.session.scheduler) ? _c('span', [_vm._v("Please compile your code to run the simulation...")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.session.scheduler && _vm.session.showScheduler) ? _c('schedulerPanel', {
    attrs: {
      "scheduler": _vm.session.scheduler
    }
  }) : _vm._e()], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-success dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "caret"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "simulator-canvas",
    attrs: {
      "id": "parapple-canvas"
    }
  })])
}]}

/***/ }),

/***/ 1544:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('blockquote', [_c('p', [_vm._v("User Documentation")])]), _vm._v(" "), _c('h2', [_vm._v("What is Parapple")]), _vm._v(" "), _c('p', [_vm._v("Parapple is trying to make learning parallel programming "), _c('em', [_vm._v("easier")]), _vm._v(". In real life, parallel programming can be difficult and frustrating--many parallel platforms (such as MPI, CUDA, OpenCL...) have a pretty steep learning curve. This platform should help programmers with their first attempts with solving parallel problems. It should help beginners to focus on "), _c('em', [_vm._v("how their think")]), _vm._v(" about parallelism rather than worrying about the API and underlying architecture of sophisticated parallel platforms.")]), _vm._v(" "), _c('h2', [_vm._v("Get Started!")]), _vm._v(" "), _c('p', [_vm._v("Just open the "), _c('em', [_vm._v("first tutorial")]), _vm._v(" and follow the instructions. Good luck!")]), _vm._v(" "), _c('h3', [_vm._v("Basic Concepts")]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("agents")]), _vm._v(" execute the code you provide for them. Each agent executes the code separately, but they interact in a shared world.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("agent type")]), _vm._v(" determines the available functions and constants for the given agent. Each agent has an associated type. You write one program per agent type.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("simulation")]), _vm._v(" is the process of executing all agent programs. If the tutorial objective is achieved during the simulation, the tutorial is solved.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("scheduler")]), _vm._v(" determines the order in which agents execute their code in the simulation")])]), _vm._v(" "), _c('h4', [_vm._v("Tutorial Objective")]), _vm._v(" "), _c('p', [_vm._v("The tutorial assignment is always displayed in the "), _c('em', [_vm._v("left panel")]), _vm._v(".")]), _vm._v(" "), _c('h4', [_vm._v("Completing a Tutorial")]), _vm._v(" "), _c('p', [_vm._v("You have to write a program (in Parascript) for every agent type. In other words, you have to fill in some code in every tab in the lower part of the screen. Once you think it might work, or you just want to give it a shot, just hit "), _c('em', [_vm._v("Compile & Run")]), _vm._v(". You will probably see some output in the console, and if your solution is correct, you you will see a modal message once your simulation completes.")]), _vm._v(" "), _c('h4', [_vm._v("Programming Help")]), _vm._v(" "), _c('p', [_vm._v("The available functions and constants for each agent type can be found under the "), _c('strong', [_vm._v("Help")]), _vm._v(" button in the top-right corner of the "), _c('em', [_vm._v("coding area")]), _vm._v(".")]), _vm._v(" "), _c('h4', [_vm._v("Simulator GUI")]), _vm._v(" "), _c('p', [_vm._v("The simulator is the main view. It consists of the following parts:")]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("Control panel")]), _vm._v(": This is where you may compile your programs, launch the simulation, and control the simulation speed")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Scheduler panel")]), _vm._v(": This panel is visible only when the simulation is running. It is the panel in the right side of the screen. It shows you all executors (one per agent) and it highlights the current (active) executor. For each executor, it shows you the last and next instructions.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Canvas")]), _vm._v(": the central element is the canvas used for visualizations. What is displayed in this area is completely dependent on the tutorial.")])]), _vm._v(" "), _c('h2', [_vm._v("Parascript Programming Language")]), _vm._v(" "), _c('p', [_vm._v("The programming language used for programming the agents is called "), _c('em', [_vm._v("Parascript")]), _vm._v(", and it is very similar to "), _c('em', [_vm._v("JavaScript")]), _vm._v(". If you program in "), _c('em', [_vm._v("simple")]), _vm._v(" JavaScript, you should be more or less fine. There are several things that are different:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("no objects (no "), _c('code', {
    pre: true
  }, [_vm._v("new")]), _vm._v(" keyword, prototyping)")]), _vm._v(" "), _c('li', [_vm._v("there is no "), _c('code', {
    pre: true
  }, [_vm._v("undefined")]), _vm._v(", all undefined values are "), _c('code', {
    pre: true
  }, [_vm._v("null")])]), _vm._v(" "), _c('li', [_vm._v("functions can be declared only in the top-most scope of the program")]), _vm._v(" "), _c('li', [_vm._v("all variables must be declared using "), _c('code', {
    pre: true
  }, [_vm._v("var")]), _vm._v("; variables are block-scoped")]), _vm._v(" "), _c('li', [_vm._v("semicolons are mandatory "), _c('code', {
    pre: true
  }, [_vm._v(";")])])]), _vm._v(" "), _c('h3', [_vm._v("Data types")]), _vm._v(" "), _c('p', [_vm._v("Primitive data types:")]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("null")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("boolean")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("number")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("string")])])]), _vm._v(" "), _c('p', [_vm._v("Structured data types:")]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("map")]), _vm._v(" resembles very much JavaScript object. It is basically a key-value store. You may initialize it like this: "), _c('code', {
    pre: true
  }, [_vm._v("var map = { key: \"values\", foo: true }")]), _vm._v(". You can access map values with bracket notation: "), _c('code', {
    pre: true
  }, [_vm._v("map[\"key\"]")]), _vm._v(" or with dot notation: "), _c('code', {
    pre: true
  }, [_vm._v("map.key")]), _vm._v(". Keys and values can be of nay type.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("array")]), _vm._v(" is an ordered set of elements. Like map, it can contain mixed types including null. You may initialize arrays like this: "), _c('code', {
    pre: true
  }, [_vm._v("var array = [1, true, \"three\", null]")])])]), _vm._v(" "), _c('h3', [_vm._v("Variables")]), _vm._v(" "), _c('p', [_vm._v("Variables must be declared using "), _c('code', {
    pre: true
  }, [_vm._v("var")]), _vm._v(" statement. All variables are block-scoped.")]), _vm._v(" "), _c('h3', [_vm._v("Expressions")]), _vm._v(" "), _c('p', [_vm._v("Expressions work much like in JavaScript.")]), _vm._v(" "), _c('h3', [_vm._v("IF-ELSE Statement")]), _vm._v(" "), _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": ""
    }
  }, [_vm._v("if (condition) {\n    \n} else {\n\n}\n")])]), _vm._v(" "), _c('h3', [_vm._v("FOR Statement")]), _vm._v(" "), _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": ""
    }
  }, [_vm._v("for (var i = 0; i < 10; i++) {\n\n}\n")])]), _vm._v(" "), _c('h3', [_vm._v("WHILE Statement")]), _vm._v(" "), _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": ""
    }
  }, [_vm._v("while (condition) {\n    \n}\n")])]), _vm._v(" "), _c('h3', [_vm._v("Functions")]), _vm._v(" "), _c('p', [_vm._v("Functions may be declared only in the top-most block if the program. The "), _c('strong', [_vm._v("argument count")]), _vm._v(" in the function declaration and in the function call must match.")]), _vm._v(" "), _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": ""
    }
  }, [_vm._v("function add(arg1, arg2) {\n    return arg1 + arg2;\n}\n\nadd(1, 2);\n")])]), _vm._v(" "), _c('p', [_vm._v("If a function does not contain an explicit "), _c('code', {
    pre: true
  }, [_vm._v("return")]), _vm._v(" statement, it returns null.")]), _vm._v(" "), _c('h2', [_vm._v("Schedulers")]), _vm._v(" "), _c('p', [_vm._v("Scheduler determines the order in which the agents are executed. To be precise, it determines the interleaving order of the instructions of the compiled agent code.\nThere are three scheduling algorithms implemented:")]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("round robin scheduler")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("random scheduler")]), _vm._v(" is the same as the round robin scheduler, but the agents are iterated in a random order (without repetition)")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("lock-step scheduler")]), _vm._v(" simulates execution on a GPU. It ensures that in every simulation cycle, all agents execute exactly the same instruction. Code branching (IF and iteration statements) is solved by pausing/resuming certain executors.")])]), _vm._v(" "), _c('h3', [_vm._v("Selecting a Scheduler")]), _vm._v(" "), _c('p', [_vm._v("You may select the scheduler when loading the tutorial. Some tutorials allow only certain schedulers to be selected.")]), _vm._v(" "), _c('h2', [_vm._v("Debugging")]), _vm._v(" "), _c('p', [_vm._v("Debugging parallel programs can be difficult. Since the programs usually affect each other, they cannot be simply ran one-by-one and debugged separately.")]), _vm._v(" "), _c('p', [_vm._v("In Parapple, you may always pause the simulation (pause button in the top bar). The tab of the "), _c('em', [_vm._v("active agent")]), _vm._v(" should get highlighted together with the exact code location (line of code highlighting the command that will be executed next.) Also, the "), _c('em', [_vm._v("scheduler panel")]), _vm._v(" (on the right) should be showing the active executor (agent).")]), _vm._v(" "), _c('h3', [_vm._v("Placing a break point")]), _vm._v(" "), _c('p', [_vm._v("To force the simulation to pause at an exact place in your code, you may insert a "), _c('em', [_vm._v("breakpoint")]), _vm._v(". This is done by clicking the line number in the coding area of the program.")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("Note: you may only place a breakpoint once the program is compiled!")])]), _vm._v(" "), _c('h3', [_vm._v("Stepping")]), _vm._v(" "), _c('p', [_vm._v("Once the simulation is paused (i.e., it hit a breakpoint), you may use the step-through button (top bar, next to pause) to run the simulation step-by-step. The instruction order will be exactly the same as when the simulation runs normally.")]), _vm._v(" "), _c('h3', [_vm._v("Memory Contents and Callstack")]), _vm._v(" "), _c('p', [_vm._v("When the simulation is active, the following information can be found in the "), _c('em', [_vm._v("right panel")]), _vm._v(" in the code area")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("memory contents")]), _vm._v(" "), _c('li', [_vm._v("call stack and stack contents")]), _vm._v(" "), _c('li', [_vm._v("list of compiled instructions")])])])
}]}

/***/ }),

/***/ 1545:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-default btn-lg",
    on: {
      "click": function($event) {
        _vm.openModal()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "folder-open"
    }
  }), _vm._v(" Select tutorial")], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "title": "Select tutorial",
      "large": ""
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    staticClass: "modal-body",
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, _vm._l((_vm.tutorials), function(section) {
    return (_vm.tutorials) ? _c('div', [_c('h4', [_c('icon', {
      attrs: {
        "name": section.icon
      }
    }), _vm._v(" " + _vm._s(section.name))], 1), _vm._v(" "), _vm._l((section.tutorials), function(tutorial) {
      return _c('radio', {
        attrs: {
          "selected-value": tutorial,
          "type": "success"
        },
        model: {
          value: (_vm.selected),
          callback: function($$v) {
            _vm.selected = $$v
          },
          expression: "selected"
        }
      }, [_vm._v(_vm._s(tutorial))])
    })], 2) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(!_vm.selected) ? _c('div', [_c('h4', [_vm._v("Just pick a tutorial from the list on the left...")])]) : _vm._e(), _vm._v(" "), (_vm.selected) ? _c('div', [_c('tutorialDetails', {
    ref: "tutorialDetails",
    attrs: {
      "name": _vm.selected,
      "helper": _vm.helper
    }
  })], 1) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.loadTutorial()
      }
    }
  }, [_vm._v("Start tutorial")])])]), _vm._v(" "), (!_vm.session) ? _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showStartHere) ? _c('img', {
    attrs: {
      "src": __webpack_require__(1500)
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.session) ? _c('div', [_c('h4', {
    staticClass: "page-header"
  }, [_vm._v(_vm._s(_vm.session.tutorial.definition.name))]), _vm._v(" "), (_vm.session.tutorial.definition.guide) ? _c('resourceTemplate', {
    attrs: {
      "resource": _vm.session.tutorial.resources[_vm.session.tutorial.definition.guide]
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1546:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iconTabs', {
    attrs: {
      "nav-style": "tabs"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('iconTab', {
    attrs: {
      "header": "Console",
      "leftIcon": "list-alt"
    }
  }, [_c('console')], 1), _vm._v(" "), (_vm.session != null) ? _c('div', _vm._l((_vm.session.agentMap), function(agentType, agentTypeName, index) {
    return _c('iconTab', {
      key: agentType.name,
      attrs: {
        "header": agentTypeName,
        "leftIcon": "user-secret",
        "rightIcon": agentType.state.tabIcon
      }
    }, [_c('codearea', {
      attrs: {
        "agentType": agentType
      },
      on: {
        "focus": function($event) {
          _vm.activateAgentTab(index)
        }
      }
    })], 1)
  })) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1547:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.clazz,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path) {
    return _c('path', _vm._b({}, 'path', path, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon) {
    return _c('polygon', _vm._b({}, 'polygon', polygon, false))
  }) : _vm._e(), _vm._v("\b\n    "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.icon.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1548:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1498)
    }
  }), _vm._v(" Parapple")])
}]}

/***/ }),

/***/ 1549:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "f9")) { return null; }
        _vm.compile($event)
      }
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-inverse navbar-sm"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [_c('icon', {
    attrs: {
      "name": "user-secret"
    }
  }), _vm._v(" " + _vm._s(_vm.agentType.name) + " (" + _vm._s(_vm.agentType.agentNames.length) + ")")], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [_c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['f9']),
      expression: "['f9']"
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.compile,
      "shortkey": function($event) {
        _vm.compile()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "gears"
    }
  }), _vm._v(" Compile")], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [(_vm.activeAgent) ? _c('li', {
    class: {
      active: _vm.rightPanel == 'CALLSTACK'
    },
    on: {
      "click": function($event) {
        _vm.toggleRightPanel('CALLSTACK')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('icon', {
    attrs: {
      "name": "stack-overflow"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.activeAgent) ? _c('li', {
    class: {
      active: _vm.rightPanel == 'MEMORY'
    },
    on: {
      "click": function($event) {
        _vm.toggleRightPanel('MEMORY')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('icon', {
    attrs: {
      "name": "database"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.agentType.instructions) ? _c('li', {
    class: {
      active: _vm.rightPanel == 'INSTRUCTIONS'
    },
    on: {
      "click": function($event) {
        _vm.toggleRightPanel('INSTRUCTIONS')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('icon', {
    attrs: {
      "name": "th-list"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      active: _vm.rightPanel == 'CONSOLE'
    },
    on: {
      "click": function($event) {
        _vm.toggleRightPanel('CONSOLE')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('icon', {
    attrs: {
      "name": "list-alt"
    }
  })], 1)]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.rightPanel == 'API'
    },
    on: {
      "click": function($event) {
        _vm.toggleRightPanel('API')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('icon', {
    attrs: {
      "name": "book"
    }
  }), _vm._v(" Help")], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "agent-bar"
  }, _vm._l((_vm.agentType.agentNames), function(agentName) {
    return _c('span', {
      class: {
        active: _vm.activeAgent && _vm.activeAgent.name == agentName
      },
      on: {
        "click": function($event) {
          _vm.agentNameClick(agentName)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "user-secret"
      }
    }), _vm._v(" " + _vm._s(agentName))], 1)
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "hidden",
      "position": "relative"
    }
  }, [_c('aceEditor', {
    ref: "aceEditor",
    attrs: {
      "width": "100%",
      "height": "200px",
      "initialSource": _vm.agentType.definition.solution
    },
    on: {
      "change": _vm.editorChange,
      "gutterClick": _vm.toggleBreakpoint
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rightPanel != null),
      expression: "rightPanel != null"
    }],
    staticClass: "right-panel"
  }, [(_vm.rightPanel == 'INSTRUCTIONS') ? _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.agentType.instructions), function(instruction, index) {
    return _c('tr', {
      class: {
        info: _vm.selectedInstruction == instruction, warning: instruction.breakpoint
      },
      on: {
        "click": function($event) {
          _vm.selectInstruction(instruction)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(index))]), _c('td', [_vm._v(_vm._s(instruction.id))]), _c('td', [_vm._v(_vm._s(instruction.params))])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.agentType.definition.api) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rightPanel == 'API'),
      expression: "rightPanel=='API'"
    }],
    staticClass: "doc-panel"
  }, [_c('tabs', {
    attrs: {
      "nav-style": "pills"
    }
  }, _vm._l((_vm.agentType.definition.api), function(api) {
    return _c('tab', {
      attrs: {
        "header": api.name
      }
    }, [_c('resourceTemplate', {
      attrs: {
        "resource": api.doc
      }
    })], 1)
  }))], 1) : _vm._e(), _vm._v(" "), _c('console', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rightPanel == 'CONSOLE'),
      expression: "rightPanel=='CONSOLE'"
    }],
    attrs: {
      "keys": _vm.agentType.agentNames,
      "slim": "true"
    }
  }), _vm._v(" "), (_vm.activeAgent && _vm.rightPanel == 'CALLSTACK') ? _c('div', [_c('h4', [_vm._v("Call stack")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped table-condensed"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.activeAgent.executor.memory.callStack.array), function(instruction, index) {
    return _c('tr', {
      class: {
        info: _vm.selectedInstruction == instruction, warning: instruction.breakpoint
      },
      on: {
        "click": function($event) {
          _vm.selectInstruction(instruction)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(index))]), _c('td', [_vm._v(_vm._s(instruction.params.name))])])
  }))]), _vm._v(" "), _c('h4', [_vm._v("Main value stack")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped table-condensed"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.activeAgent.executor.stack.array), function(value, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index))]), _c('td', [_c('objectView', {
      attrs: {
        "value": _vm.activeAgent.executor.stack.array[index]
      }
    })], 1)])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.activeAgent && _vm.rightPanel == 'MEMORY') ? _c('div', [_c('h3', [_vm._v("Global scope")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped table-condensed"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((Object.keys(_vm.activeAgent.executor.memory.globalScope())), function(key) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(key))]), _c('td', [_c('objectView', {
      attrs: {
        "value": _vm.activeAgent.executor.memory.loadGlobal(key)
      }
    }), _vm._v(" }}")], 1)])
  }))]), _vm._v(" "), _c('h3', [_vm._v("Local scope")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped table-condensed"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((Object.keys(_vm.activeAgent.executor.memory.localScope())), function(key) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(key))]), _c('td', [_c('objectView', {
      attrs: {
        "value": _vm.activeAgent.executor.memory.loadLocal(key)
      }
    })], 1)])
  }))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "status-bar"
  }, [_c('icon', {
    attrs: {
      "name": _vm.agentType.state.icon
    }
  }), _vm._v(" " + _vm._s(_vm.agentType.state.message) + "\n  ")], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _c('th', [_vm._v("Instruction")]), _c('th', [_vm._v("Parameters")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _c('th', [_vm._v("Function call")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _c('th', [_vm._v("Value")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Identifier")]), _c('th', [_vm._v("Value")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Identifier")]), _c('th', [_vm._v("Value")])])])
}]}

/***/ }),

/***/ 1550:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "panel",
    class: ['tab-pane', {
      'active fade': _vm.active,
      'in': _vm.fadein
    }],
    attrs: {
      "role": "tabpanel"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1551:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1552:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.state == 'OK') ? _c(_vm.currentView, {
    tag: "component"
  }) : (_vm.state == 'ERROR') ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : (_vm.state == 'LOADING') ? _c('loading', {
    attrs: {
      "text": "loading template..."
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1553:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hr'), _vm._v(" "), _c('h4', [_vm._v("Scheduler")]), _vm._v(" "), (_vm.json && _vm.json.schedulers) ? _c('div', [_c('div', {
    staticClass: "description"
  }, [_vm._v("\n            You can pick from the following scheduling policies to run the simulation for this tutorial:\n        ")]), _vm._v(" "), _vm._l((_vm.json.schedulers), function(scheduler) {
    return _c('radio', {
      attrs: {
        "selected-value": scheduler,
        "type": "success"
      },
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.schedulerType[scheduler].name) + "\n            "), (_vm.selected == scheduler) ? _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(_vm.schedulerType[scheduler].description))]) : _vm._e()])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.json || !_vm.json.schedulers) ? _c('div', {
    staticClass: "description"
  }, [_vm._v("\n        This tutorial does not specify any schedulers; default "), _c('strong', [_vm._v("round-robin")]), _vm._v(" scheduler will be used.\n    ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1554:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.primitive) ? _c('objectTreeNodePrimitive', {
    attrs: {
      "type": _vm.type
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }) : _c('objectTreeNodeComplex', {
    attrs: {
      "type": _vm.type,
      "primary": _vm.primary
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 1555:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "title": _vm.title
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "modal-body",
    slot: "modal-body"
  }, [_c('alert', {
    attrs: {
      "type": _vm.type.type
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('icon', {
    attrs: {
      "name": _vm.type.icon,
      "scale": "2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.body)
    }
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("OK")])])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": _vm.alertType.type,
      "width": "480px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertShow),
      callback: function($$v) {
        _vm.alertShow = $$v
      },
      expression: "alertShow"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "padding-right": "35px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('icon', {
    attrs: {
      "name": _vm.alertType.icon,
      "scale": "2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('strong', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alertTitle),
      expression: "alertTitle"
    }]
  }, [_vm._v(_vm._s(_vm.alertTitle))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alertText),
      expression: "alertText"
    }]
  }, [_vm._v(_vm._s(_vm.alertText))])])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1556:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-object-view"
  }, [_c('objectTreeNode', {
    attrs: {
      "primary": true
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1557:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: [_vm.cssClass, 'list-group-item', 'executor'],
    on: {
      "click": _vm.highlight
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.executor.agent.name))]), _vm._v(" "), _c('span', {
    staticClass: "badge",
    attrs: {
      "title": "Number of performed instructions",
      "data-toggle": "tooltip",
      "data-placement": "top"
    }
  }, [_vm._v(_vm._s(_vm.executor.elapsedSteps))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.executor.penalty >= 1),
      expression: "executor.penalty >= 1"
    }],
    staticClass: "badge",
    attrs: {
      "title": "Current penalty for instruction cost"
    }
  }, [_vm._v("Penalty: " + _vm._s(_vm.executor.penalty))]), _vm._v(" "), _c('div', {
    staticClass: "instructions"
  }, [(_vm.executor.last) ? _c('div', {
    staticClass: "instruction instruction-last"
  }, [_vm._v("[" + _vm._s(_vm.executor.lastIp) + "] " + _vm._s(_vm.executor.last.id))]) : _vm._e(), _vm._v(" "), (_vm.executor.next) ? _c('div', {
    class: ['instruction', 'instruction-next', {
      'instruction-highlight': _vm.next
    }]
  }, [_vm._v("[" + _vm._s(_vm.executor.ip) + "] " + _vm._s(_vm.executor.next.id))]) : _vm._e()]), _vm._v(" "), (_vm.executor.error) ? _c('div', {
    staticClass: "error-msg",
    attrs: {
      "title": _vm.executor.error.message
    }
  }, [_c('small', [_c('icon', {
    attrs: {
      "name": "warning"
    }
  }), _vm._v(" Runtime error!")], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1558:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": _vm.appRoot
    }
  }, [_c('logo')], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "static/devDocs.pdf",
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "book"
    }
  }), _vm._v(" API")], 1)]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/docs"
    }
  }, [_c('icon', {
    attrs: {
      "name": "book"
    }
  }), _vm._v(" Help")], 1)], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 1559:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1504);

/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LOG_LEVEL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_global_js__ = __webpack_require__(32);






var LOG_LEVEL = {

    DEBUG: {
        cssClass: "debug-msg"
    },
    INFO: {
        cssClass: "info-msg"
    },
    WARNING: {
        icon: "warning",
        cssClass: "warning-msg"
    },
    ERROR: {
        icon: "warning",
        cssClass: "error-msg"
    }

};

var Log = function Log(level, key, message) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Log);

    this.level = level;
    this.message = message;
    this.key = key;
    this.time = __WEBPACK_IMPORTED_MODULE_4_moment___default()();
    if ((typeof message === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(message)) == 'object') {
        this.object = true;
    }
};

var ConsoleProxy = function () {
    function ConsoleProxy() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ConsoleProxy);

        this.map = {};
        this._default = null;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ConsoleProxy, [{
        key: "register",
        value: function register(_console) {
            if (_console.keys) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_console.keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var key = _step.value;

                        this.map[key] = _console;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            } else {
                this._default = _console;
            }
        }
    }, {
        key: "log",
        value: function log(level, key, message) {
            var log = new Log(level, key, message);
            if (this.map[key]) {
                this.map[key].log(log);
            }
            this._default.log(log);
        }
    }, {
        key: "debug",
        value: function debug(key, message) {
            this.log(LOG_LEVEL.DEBUG, key, message);
        }
    }, {
        key: "info",
        value: function info(key, message) {
            this.log(LOG_LEVEL.INFO, key, message);
        }
    }, {
        key: "warn",
        value: function warn(key, message) {
            this.log(LOG_LEVEL.WARNING, key, message);
        }
    }, {
        key: "error",
        value: function error(key, message) {
            this.log(LOG_LEVEL.ERROR, key, message);
        }
    }]);

    return ConsoleProxy;
}();

var consoleProxy = new ConsoleProxy();
/* harmony default export */ __webpack_exports__["a"] = (consoleProxy);


__WEBPACK_IMPORTED_MODULE_5_utils_global_js__["a" /* default */].publish(consoleProxy, "console");

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Global = function () {
    function Global() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Global);

        if (!window.PARAPPLE) {
            window.PARAPPLE = {};
        }
        this.PARAPPLE = window.PARAPPLE;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Global, [{
        key: "publish",
        value: function publish(object, key) {
            this.PARAPPLE[key] = object;
        }
    }]);

    return Global;
}();

var global = new Global();
/* harmony default export */ __webpack_exports__["a"] = (global);

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

    roundrobin: {
        name: "Round-robin Scheduler",
        description: "Executors are invoked in round-robin; instruction cost is accumulated as penalty which makes the executor skip cycles.",
        icon: "list-ol",
        key: "roundrobin"
    },
    random: {
        name: "Random Scheduler",
        description: "Executors are invoked in a random order (without repetition per cycle); instruction cost is accumulated as penalty which makes the executor skip cycles.",
        icon: "random",
        key: "random"
    },
    lockstep: {
        name: "Lock-step Scheduler",
        description: "All executors perform the same instruction in every cycle.",
        icon: "indent",
        key: "lockstep"
    }

});

/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1395)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1250),
  /* template */
  __webpack_require__(1556),
  /* scopeId */
  "data-v-d5fe508c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1397)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1253),
  /* template */
  __webpack_require__(1558),
  /* scopeId */
  "data-v-e8a64638",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1367)
__webpack_require__(1366)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1254),
  /* template */
  __webpack_require__(1528),
  /* scopeId */
  "data-v-0c06ad2e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1387)

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(1548),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Home__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_docs_Main__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_docs_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_docs_Main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_parascript_compiler_js__ = __webpack_require__(103);







__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2_components_Home___default.a
  }, {
    path: '/docs',
    name: 'Docs',
    component: __WEBPACK_IMPORTED_MODULE_3_components_docs_Main___default.a
  }]
}));

/***/ }),

/***/ 453:
/***/ (function(module, exports) {


window.Userback = window.Userback || {};
window.Userback.access_token = '1112|1315|VXmT4k3wBAqG5f24XIqFf3gGdWxgI0lDYHx22AyDaYkfdmkb4L';

(function (id) {
    if (document.getElementById(id)) {
        return;
    }
    var s = document.createElement('script');
    s.id = id;
    s.src = 'https://static.userback.io/widget/v1.js';
    var parent_node = document.head || document.body;
    parent_node.appendChild(s);
})('userback-sdk');

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1365)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1251),
  /* template */
  __webpack_require__(1527),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1368)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1263),
  /* template */
  __webpack_require__(1529),
  /* scopeId */
  "data-v-0cc68272",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

var merge = __webpack_require__(1566)
var prodEnv = __webpack_require__(102)

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"'
})


/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__dirname) {// see http://vuejs-templates.github.io/webpack for documentation.
var path = __webpack_require__(442)

module.exports = {
  build: {
    env: __webpack_require__(102),
    index: path.resolve(__dirname, '../dist/index.html'),
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    assetsPublicPath: '/parapple/',
    productionSourceMap: true,
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: __webpack_require__.i({"NODE_ENV":"production"}).npm_config_report
  },
  dev: {
    env: __webpack_require__(457),
    port: 8080,
    autoOpenBrowser: true,
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {},
    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_global_js__ = __webpack_require__(32);


var TYPE = {
    info: {
        icon: "info",
        type: "info"
    },
    success: {
        icon: "check",
        type: "success"
    },
    error: {
        icon: "remove",
        type: "danger"
    },
    warning: {
        icon: "warning",
        type: "warning"
    }
};

var ModalMessageProxy = function () {
    function ModalMessageProxy() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ModalMessageProxy);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ModalMessageProxy, [{
        key: "info",
        value: function info(options) {
            options.type = TYPE.info;
            this.show(options);
        }
    }, {
        key: "success",
        value: function success(options) {
            options.type = TYPE.success;
            this.show(options);
        }
    }, {
        key: "error",
        value: function error(options) {
            options.type = TYPE.error;
            this.show(options);
        }
    }, {
        key: "warning",
        value: function warning(options) {
            options.type = TYPE.warning;
            this.show(options);
        }
    }, {
        key: "show",
        value: function show(options) {
            this.component.title = options.title;
            this.component.body = options.body;
            this.component.type = options.type || TYPE.info;
            this.component.show = true;
        }
    }, {
        key: "alert",
        value: function alert(text, title, type) {
            this.component.alertText = text;
            this.component.alertTitle = title;
            this.component.alertType = type || TYPE.info;
            this.component.alertShow = true;
        }
    }, {
        key: "errorAlert",
        value: function errorAlert(text, title) {
            this.alert(text, title, TYPE.error);
        }
    }, {
        key: "warningAlert",
        value: function warningAlert(text, title) {
            this.alert(text, title, TYPE.warning);
        }
    }, {
        key: "successAlert",
        value: function successAlert(text, title) {
            this.alert(text, title, TYPE.success);
        }
    }, {
        key: "register",
        value: function register(component) {
            this.component = component;
        }
    }]);

    return ModalMessageProxy;
}();

var proxy = new ModalMessageProxy();
/* harmony default export */ __webpack_exports__["a"] = (proxy);


__WEBPACK_IMPORTED_MODULE_2_utils_global_js__["a" /* default */].publish(proxy, 'modalMessage');

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Stack = function () {
    function Stack() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Stack);

        this.array = [];
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Stack, [{
        key: "push",
        value: function push(e) {
            this.array.push(e);
        }
    }, {
        key: "pop",
        value: function pop() {
            return this.array.pop();
        }
    }, {
        key: "popN",
        value: function popN(n) {
            return this.array.splice(this.array.length - n, n);
        }
    }, {
        key: "peek",
        value: function peek() {
            return this.array[this.array.length - 1];
        }
    }, {
        key: "peekBottom",
        value: function peekBottom() {
            return this.array[0];
        }
    }, {
        key: "size",
        value: function size() {
            return this.array.length;
        }
    }, {
        key: "empty",
        value: function empty() {
            return this.array.length == 0;
        }
    }]);

    return Stack;
}();

/* harmony default export */ __webpack_exports__["a"] = (Stack);

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1393)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1246),
  /* template */
  __webpack_require__(1554),
  /* scopeId */
  "data-v-d18ba082",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1391)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1260),
  /* template */
  __webpack_require__(1552),
  /* scopeId */
  "data-v-c25ec428",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })

},[1277]);


// WEBPACK FOOTER //
// static/js/app.8ba6c7bb9679b271dd01.js